
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("em5PR", function(module, exports) {

$parcel$export(module.exports, "ActionsWrapper", () => $fe8542ce34e670ba$export$c8223871eecc8f3a);
$parcel$export(module.exports, "default", () => $fe8542ce34e670ba$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $8Rkzz = parcelRequire("8Rkzz");

var $c5wox = parcelRequire("c5wox");

var $3jA9Y = parcelRequire("3jA9Y");

var $gwIPs = parcelRequire("gwIPs");

var $2gCtH = parcelRequire("2gCtH");

var $93Yeu = parcelRequire("93Yeu");

var $17Gip = parcelRequire("17Gip");

var $g5X3G = parcelRequire("g5X3G");

var $itmJb = parcelRequire("itmJb");

var $9OXo1 = parcelRequire("9OXo1");

var $44VbI = parcelRequire("44VbI");

var $9RrVQ = parcelRequire("9RrVQ");

var $bUXoM = parcelRequire("bUXoM");

var $7lu0s = parcelRequire("7lu0s");
const $fe8542ce34e670ba$var$ActionsMenuComponentOld = ({ issueKey: issueKey, issueId: issueId, environment: environment, cloudId: cloudId, projectType: projectType, transitions: transitions, onTransitionStatus: onTransitionStatus, animationEnabled: animationEnabled, baseAutomationUrl: baseAutomationUrl, canManageAutomations: canManageAutomations })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fe8542ce34e670ba$export$c8223871eecc8f3a, {
        animationEnabled: animationEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3jA9Y.ManualRulesContainer), {
        env: environment,
        cloudId: cloudId,
        issueIds: issueId ? [
            Number(issueId)
        ] : []
    }, ({ triggerFetch: triggerFetch, initialised: initialised, rules: rules, invokingRuleId: invokingRuleId, invokeRuleOrShowDialog: invokeRuleOrShowDialog })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7lu0s.ActionsMenu), {
            issueKey: issueKey,
            issueId: Number(issueId),
            projectType: projectType,
            rules: rules,
            triggerFetch: triggerFetch,
            executeRule: invokeRuleOrShowDialog,
            executingRule: invokingRuleId,
            initialised: initialised,
            transitions: transitions,
            onSelect: onTransitionStatus,
            canManageAutomations: canManageAutomations,
            baseAutomationUrl: baseAutomationUrl
        })));
const $fe8542ce34e670ba$var$ActionsOld = ({ initialStatusValue: initialStatusValue, onSubmit: onSubmit, onSuccess: onSuccess })=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const issueId = (0, $2gCtH.useIssueId)();
    const baseUrl = (0, $g5X3G.toBaseUrl)('');
    const projectKey = (0, $2gCtH.useProjectKey)();
    const projectId = (0, $93Yeu.useProjectId)(projectKey);
    const isSimplified = (0, $93Yeu.useIsSimplifiedProject)(projectKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const baseAutomationUrl = (0, $5uXOq.useMemo)(()=>(0, $c5wox.getBaseAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplified
        }), [
        projectKey,
        projectType,
        isSimplified
    ]);
    const isProjectAdmin = (0, $17Gip.useCanAdministerProject)(projectKey);
    const isGlobalAdmin = (0, $itmJb.useIsAdmin)();
    const canManageAutomations = isProjectAdmin || isGlobalAdmin;
    const { environment: environment, cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const [animationEnabled, setAnimationEnabled] = (0, $5uXOq.useState)(false);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const onSuccesInternal = (...args)=>{
        setAnimationEnabled(true);
        // @ts-expect-error - TS2556 - A spread argument must either have a tuple type or be passed to a rest parameter.
        onSuccess(...args);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9RrVQ.StatusService), {
        appearance: "button",
        projectType: projectType || null,
        issueKey: issueKey,
        issueId: issueId,
        baseUrl: baseUrl,
        onSubmit: onSubmit,
        onSuccess: onSuccesInternal,
        onFailure: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onEditStart: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onEditCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        initialValue: initialStatusValue
    }, ({ value: statusServiceValue, loading: saving, transitionStatus: transitionStatus })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUXoM.TransitionsQuery), {
            issueKey: issueKey,
            baseUrl: baseUrl,
            status: statusServiceValue,
            isSaving: saving,
            preFetch: true,
            projectType: projectType
        }, ({ data: transitions })=>{
            const loopedTransitions = (0, $44VbI.getLoopedTransitionsForStatus)(transitions, statusServiceValue.id);
            const menuProps = {
                environment: environment,
                cloudId: cloudId,
                projectId: projectId,
                projectType: projectType,
                issueKey: issueKey,
                issueId: issueId,
                transitions: loopedTransitions,
                onTransitionStatus: transitionStatus,
                animationEnabled: animationEnabled,
                baseAutomationUrl: baseAutomationUrl,
                canManageAutomations: canManageAutomations
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fe8542ce34e670ba$var$ActionsMenuComponentOld, menuProps);
        }));
};
const $fe8542ce34e670ba$var$fadeInAnimation = /*#__PURE__*/ (0, $47bDC.keyframes)({
    '0%': {
        opacity: 0,
        maxHeight: 0
    },
    '50%': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: `${(0, $gwIPs.gridSize) * 5}px`
    },
    '100%': {
        opacity: 1
    }
});
const $fe8542ce34e670ba$export$c8223871eecc8f3a = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "p0b6p4-0"
})((props)=>({
        display: 'inline-flex',
        maxWidth: '100%',
        animationDuration: '0.5s',
        animationIterationCount: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationName: props.animationEnabled ? $fe8542ce34e670ba$var$fadeInAnimation : 'none',
        animationTimingFunction: 'linear',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    }));
var $fe8542ce34e670ba$export$2e2bcd8739ae039 = $fe8542ce34e670ba$var$ActionsOld;

});
parcelRegister("c5wox", function(module, exports) {

$parcel$export(module.exports, "getAutomationStack", () => $8833cfad9f41bd36$export$6123178d3f5fb24d);
$parcel$export(module.exports, "getAutomationRecommendationsUrl", () => $8833cfad9f41bd36$export$38f41aa7b608011d);
$parcel$export(module.exports, "getBaseAutomationUrl", () => $8833cfad9f41bd36$export$8e479e490e1e69bc);

var $bSSG7 = parcelRequire("bSSG7");

var $4R6GH = parcelRequire("4R6GH");
const $8833cfad9f41bd36$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('automation-menu');
const $8833cfad9f41bd36$var$getLatestStack = async (cloudId)=>fetch(`/gateway/api/automation/internal-api/jira/${cloudId}/pro/rest/environments`).then((response)=>response.json()).then((response)=>{
        const stacks = response.prod.otherStacks.filter(({ releasedSuccessfully: releasedSuccessfully })=>!releasedSuccessfully).map(({ stack: stack })=>stack);
        return stacks.length > 0 ? stacks[0] : null;
    }).catch(()=>null);
const $8833cfad9f41bd36$export$6123178d3f5fb24d = async (env, cloudId)=>{
    if (env === 'prod') {
        if ((0, $4R6GH.fg)('automation-platform-pre-prod-instance')) {
            const stack = await $8833cfad9f41bd36$var$getLatestStack(cloudId);
            return stack ?? 'pro';
        }
        return 'pro';
    }
    // Set this manually to your Automation dev stack e.g. devesukmajaya. The full key is: __storejs_automation-menu_automationStack
    const stackOverride = $8833cfad9f41bd36$var$localStorage.get('automationStack');
    return stackOverride || 'staging';
};
const $8833cfad9f41bd36$export$45ce04a98782e28a = async (env, cloudId, projectId)=>{
    const automationStack = await $8833cfad9f41bd36$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${projectId}`;
};
const $8833cfad9f41bd36$export$f8e019b45a22d26a = async (env, cloudId, ruleId)=>{
    const automationStack = await $8833cfad9f41bd36$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${ruleId}`;
};
const $8833cfad9f41bd36$export$38f41aa7b608011d = async ({ env: env, cloudId: cloudId, target: target })=>{
    const automationStack = await $8833cfad9f41bd36$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/v1/recommendation/templates?target=${target}`;
};
const $8833cfad9f41bd36$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ if ((0, $4R6GH.fg)('jcs_project_type_m3')) switch(projectType){
        case 'customer_service':
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
    switch(projectType){
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
};

});

parcelRegister("3jA9Y", function(module, exports) {

$parcel$export(module.exports, "ManualRulesContainer", () => $7dbcf6c35b47cce5$export$eb0a81e78d942dba);

var $5uXOq = parcelRequire("5uXOq");

var $deUkU = parcelRequire("deUkU");

var $4R6GH = parcelRequire("4R6GH");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $k9To8 = parcelRequire("k9To8");
const $7dbcf6c35b47cce5$export$eb0a81e78d942dba = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { env: env, cloudId: cloudId, issueIds: issueIds } = props;
    let automationEnv = env;
    if (env === 'prod') automationEnv = (0, $4R6GH.fg)('automation-dev-helper') ? 'pre-prod' : 'prod';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $deUkU.ManualRulesContainer), {
        site: (0, $dXq4S.createAri)({
            resourceOwner: 'jira',
            resourceType: 'site',
            resourceId: cloudId
        }),
        query: {
            objects: issueIds?.map((id)=>(0, $dXq4S.createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'issue',
                    cloudId: cloudId,
                    resourceId: id.toString()
                }))
        },
        env: automationEnv,
        onInputsModalOpened: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'manualRuleModal',
                action: 'opened'
            });
            const attributes = {
                objectType: 'issue'
            };
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
        },
        onRuleInvocationLifecycleStarted: (_, __, userInputs)=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'manualRule',
                action: 'tryInvoke'
            });
            const attributes = {
                objectType: 'issue',
                ruleHasInputs: Boolean(userInputs),
                objectsSelected: issueIds.length
            };
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
        },
        onRuleInvocationSuccess: ()=>showFlag({
                type: 'info',
                title: formatMessage((0, $k9To8.default).successFlag),
                isAutoDismiss: true,
                messageId: 'automation-platform.ui.manual-rules-container.show-flag.info.success-flag',
                messageType: 'transactional'
            }),
        onRuleInvocationFailure: ()=>showFlag({
                type: 'error',
                title: formatMessage((0, $k9To8.default).failureFlagTitle),
                description: formatMessage((0, $k9To8.default).failureFlagDescription),
                isAutoDismiss: true,
                messageId: 'automation-platform.ui.manual-rules-container.show-flag.error.failure-flag',
                messageType: 'transactional'
            })
    }, props.children);
};

});
parcelRegister("deUkU", function(module, exports) {

$parcel$export(module.exports, "ManualRulesContainer", () => $9495b2e06f8b54ff$export$eb0a81e78d942dba);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $i8Qvm = parcelRequire("i8Qvm");

var $3ozzK = parcelRequire("3ozzK");

var $gSw9T = parcelRequire("gSw9T");
const $9495b2e06f8b54ff$export$96513fc6544cb4e5 = (env, site, query)=>{
    const [initialised, setInitialised] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [rules, setRules] = (0, $5uXOq.useState)([]);
    const transformRules = (ruleResponse)=>{
        const rulesUnsorted = Object.values(ruleResponse);
        return rulesUnsorted.sort((rule1, rule2)=>rule1.name.localeCompare(rule2.name));
    };
    const triggerFetch = async ()=>{
        setInitialised(false);
        try {
            const fetchedRules = await (0, $3ozzK.searchManuallyTriggeredRules)(env, site, query);
            setError(null);
            setRules(transformRules(fetchedRules));
        } catch (e) {
            setError(e);
            setRules([]);
        } finally{
            setInitialised(true);
        }
    };
    return [
        triggerFetch,
        initialised,
        error,
        rules
    ];
};
const $9495b2e06f8b54ff$export$eb0a81e78d942dba = (props)=>{
    (0, $gKZoD.di)((0, $i8Qvm.default), (0, $gSw9T.default), (0, $3ozzK.invokeManuallyTriggeredRule), $9495b2e06f8b54ff$export$96513fc6544cb4e5, (0, $5uXOq.useMemo), (0, $5uXOq.useState));
    const { env: env, site: site, query: query, children: children, onInputsModalOpened: onInputsModalOpened, onInputsModalClosed: onInputsModalClosed, onRuleInvocationLifecycleStarted: onRuleInvocationLifecycleStarted, onRuleInvocationSuccess: onRuleInvocationSuccess, onRuleInvocationFailure: onRuleInvocationFailure, onRuleInvocationLifecycleDone: onRuleInvocationLifecycleDone } = props;
    // Initial data loading state
    const [triggerFetch, initialised, error, rules] = $9495b2e06f8b54ff$export$96513fc6544cb4e5(env, site, query);
    // We store a rule in state here if and only if a rule has user inputs, and thus
    // we need to preserve state while the input dialog is open.
    const [selectedRule, setSelectedRule] = (0, $5uXOq.useState)(null);
    const clearSelectedRule = ()=>{
        setSelectedRule(null);
    };
    // Value set when a rule is invoking, either from the dialog or without dialog
    const [invokingRuleId, setInvokingRuleId] = (0, $5uXOq.useState)(null);
    // Memoized projection of rules by id
    const rulesById = (0, $5uXOq.useMemo)(()=>rules.reduce((acc, rule)=>({
                // eslint-disable-next-line
                ...acc,
                [rule.id]: rule
            }), {}), [
        rules
    ]);
    const getRule = (id)=>rulesById[id];
    const ruleHasInputs = (rule)=>rule?.userInputPrompts?.length > 0;
    const INVOCATIONS = 'invocations';
    const SUCCESS = 'SUCCESS';
    const getFailedObjects = (response)=>Object.keys(response).filter((object)=>object !== INVOCATIONS && response[object] !== SUCCESS);
    const getSuccessfulObjects = (response)=>Object.keys(response).filter((object)=>object !== INVOCATIONS && response[object] === SUCCESS);
    const handleInvocationFailure = (ruleId, successfulObjects, failedObjects)=>{
        if (onRuleInvocationFailure) onRuleInvocationFailure(ruleId, successfulObjects, failedObjects);
    };
    const invokeRule = async (ruleId, objects, userInputs)=>{
        const rule = getRule(ruleId);
        if (rule) {
            setInvokingRuleId(ruleId);
            try {
                if (onRuleInvocationLifecycleStarted) onRuleInvocationLifecycleStarted(ruleId, objects, userInputs);
                const response = await (0, $3ozzK.invokeManuallyTriggeredRule)(env, site, ruleId, objects, userInputs);
                const failedObjects = getFailedObjects(response);
                setInvokingRuleId(null);
                if (failedObjects.length === 0) {
                    if (onRuleInvocationSuccess) onRuleInvocationSuccess(ruleId, objects);
                } else {
                    const successfulObjects = getSuccessfulObjects(response);
                    handleInvocationFailure(ruleId, successfulObjects, failedObjects);
                }
            } catch (e) {
                handleInvocationFailure(ruleId, [], objects);
                setInvokingRuleId(null);
            }
        } else handleInvocationFailure(ruleId, [], objects);
        clearSelectedRule();
        if (onRuleInvocationLifecycleDone) onRuleInvocationLifecycleDone(ruleId, objects);
    };
    const invokeRuleOrShowDialog = (ruleId, objects)=>{
        const rule = getRule(ruleId);
        if (!rule) return handleInvocationFailure(ruleId, [], objects);
        if (ruleHasInputs(rule)) setSelectedRule({
            rule: rule,
            objects: objects
        });
        else invokeRule(ruleId, objects);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            children({
                triggerFetch: triggerFetch,
                initialised: initialised,
                error: error,
                rules: rules,
                invokingRuleId: invokingRuleId,
                invokeRuleOrShowDialog: invokeRuleOrShowDialog
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i8Qvm.default), {
                children: selectedRule && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gSw9T.default), {
                    onInputsModalOpened: onInputsModalOpened,
                    onInputsModalClosed: onInputsModalClosed,
                    clearSelectedRule: clearSelectedRule,
                    selectedRule: selectedRule,
                    invokeRule: invokeRule
                })
            })
        ]
    });
};

});
parcelRegister("3ozzK", function(module, exports) {

$parcel$export(module.exports, "searchManuallyTriggeredRules", () => $60d395c05d97bad7$export$11e317ae81dd4223);
$parcel$export(module.exports, "invokeManuallyTriggeredRule", () => $60d395c05d97bad7$export$9a0eb4136c6b46c);

var $8lImo = parcelRequire("8lImo");
const $60d395c05d97bad7$export$11e317ae81dd4223 = async (env, site, query)=>{
    const url = await (0, $8lImo.getSearchUrl)(env, site);
    // TODO this will in the new API be a GET request instead, with the above getSearchUrl method
    // constructing a URL with the appropriate query parameters. For now, instead, we pass the
    // destructured query through as a POST body.
    const response = await (0, $8lImo.performPostRequest)(url, {
        body: JSON.stringify(query)
    });
    return response.reduce((acc, { id: id, name: name, ruleScope: ruleScope, userInputs: userInputs })=>({
            // eslint-disable-next-line
            ...acc,
            [id]: {
                id: id,
                name: name,
                ruleScope: ruleScope,
                userInputPrompts: userInputs
            }
        }), {});
};
const $60d395c05d97bad7$export$9a0eb4136c6b46c = async (env, site, ruleId, objects, userInputs)=>{
    const url = await (0, $8lImo.getInvocationUrl)(env, site, ruleId);
    const bodyRaw = {
        objects: objects
    };
    if (userInputs) bodyRaw.userInputs = userInputs;
    return (0, $8lImo.performPostRequest)(url, {
        body: JSON.stringify(bodyRaw)
    });
};

});
parcelRegister("8lImo", function(module, exports) {

$parcel$export(module.exports, "getSearchUrl", () => $1ea2f24134ab0fcb$export$7d4675b206f57488);
$parcel$export(module.exports, "getInvocationUrl", () => $1ea2f24134ab0fcb$export$e62dcf5e32cec4bf);
$parcel$export(module.exports, "performPostRequest", () => $1ea2f24134ab0fcb$export$692a4d9808143175);

var $VSDnB = parcelRequire("VSDnB");

var $jbrzS = parcelRequire("jbrzS");

var $g3zK9 = parcelRequire("g3zK9");
const $1ea2f24134ab0fcb$export$1cb1c6bd5a8f1613 = (site)=>{
    let cloudId;
    let resourceOwner;
    let resourceType;
    try {
        const ari = (0, $jbrzS.ResourceIdentifier).parse(site);
        cloudId = ari.cloudId;
        resourceOwner = ari.resourceOwner;
        resourceType = ari.resourceType;
        // Keep backwards compatibility for platform site ARIs
        if (resourceOwner === 'platform') resourceOwner = 'jira';
    } catch (error) {
        throw new Error('Attempted to parse malformed ARI: ' + site);
    }
    if (resourceType !== 'site' || cloudId === undefined) throw new Error('Not a site ARI: ' + site);
    return {
        product: resourceOwner,
        cloudId: cloudId
    };
};
const $1ea2f24134ab0fcb$export$7d4675b206f57488 = async (env, site)=>{
    const { product: product, cloudId: cloudId } = $1ea2f24134ab0fcb$export$1cb1c6bd5a8f1613(site);
    const automationStack = await (0, $g3zK9.getAutomationStack)(env, cloudId);
    // TODO in the unified API, GET requests as according to Atlassian API standards will destructure the whole query into
    // query parameters as part of the URL. For now, this is considered a POST request instead and thus the query is used
    // later on as the request body.
    return `/gateway/api/automation/internal-api/${product}/${cloudId}/${automationStack}/rest/v1/rules/manual/search`;
};
const $1ea2f24134ab0fcb$export$e62dcf5e32cec4bf = async (env, site, ruleId)=>{
    const { product: product, cloudId: cloudId } = $1ea2f24134ab0fcb$export$1cb1c6bd5a8f1613(site);
    const automationStack = await (0, $g3zK9.getAutomationStack)(env, cloudId);
    return `/gateway/api/automation/internal-api/${product}/${cloudId}/${automationStack}/rest/v1/rules/manual/invocation/${ruleId}`;
};
const $1ea2f24134ab0fcb$var$DEFAULT_HEADER = {
    'Content-Type': 'application/json'
};
const $1ea2f24134ab0fcb$var$_performRequest = async (url, method, options = {
    headers: $1ea2f24134ab0fcb$var$DEFAULT_HEADER
})=>{
    const response = await fetch(url, {
        ...options,
        method: method
    });
    return response.json();
};
const $1ea2f24134ab0fcb$export$4a53ae1be8ec80c7 = async (url, options)=>{
    return $1ea2f24134ab0fcb$var$_performRequest(url, 'GET', options);
};
const $1ea2f24134ab0fcb$export$692a4d9808143175 = async (url, options)=>{
    return $1ea2f24134ab0fcb$var$_performRequest(url, 'POST', options);
};
const $1ea2f24134ab0fcb$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ if (projectType === 'customer_service' && (0, $VSDnB.fg)('jcs_project_type_m3')) return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
    switch(projectType){
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
};

});
parcelRegister("jbrzS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3VFsf = parcelRequire("3VFsf");

var $aRXoY = parcelRequire("aRXoY");

$3VFsf.__exportStar((parcelRequire("8T6Ee")), module.exports);
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ class $df746fbe0ba5443e$var$InvalidAriError extends Error {
    /**
     * Construct an InvalidAriError given an error message
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {string|undefined} description - The error message
     */ constructor(ariString, description){
        super(`Invalid ari string: ${ariString}${description ? '. ' + description : ''}`);
        this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(this, $df746fbe0ba5443e$var$InvalidAriError.prototype);
    }
    /**
     * Construct an InvalidAriError given some constraint violations
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
     */ static withConstraintViolations(ariString, violations) {
        return new $df746fbe0ba5443e$var$InvalidAriError(ariString, violations.map((v)=>v.toString()).join('\n'));
    }
}
module.exports.InvalidAriError = $df746fbe0ba5443e$var$InvalidAriError;
function $df746fbe0ba5443e$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
const $df746fbe0ba5443e$var$basicCharConstraint = $aRXoY.pattern(/^[a-z][a-z.-]*$/);
/**
 * resourceType allows for capitalized letters to support Identity ARIs (`ari:cloud:identity::userGrant/<...>`)
 * It's a violation of the spec, but we still need to support that.
 * See https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0
 */ const $df746fbe0ba5443e$var$resourceTypeCharConstraints = $aRXoY.pattern(/^[a-z][a-z.-]*$/i);
const $df746fbe0ba5443e$var$resourceOwnerConstraints = [
    $aRXoY.lengthBetween(3, 255),
    $df746fbe0ba5443e$var$basicCharConstraint
];
const $df746fbe0ba5443e$var$resourceTypeConstraints = [
    $aRXoY.lengthBetween(3, 255),
    $df746fbe0ba5443e$var$resourceTypeCharConstraints
];
const $df746fbe0ba5443e$var$cloudIdConstraints = [
    $aRXoY.lengthBetween(3, 255)
];
const $df746fbe0ba5443e$var$siteResourceType = 'site';
const $df746fbe0ba5443e$var$resourceIdChars = /[\w-._~:@#]/.source;
const $df746fbe0ba5443e$var$resourceIdConstraints = [
    $aRXoY.pattern(new RegExp(`^${$df746fbe0ba5443e$var$resourceIdChars}+(/${$df746fbe0ba5443e$var$resourceIdChars}*)*(;v=${$df746fbe0ba5443e$var$resourceIdChars}*)*$`))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $df746fbe0ba5443e$var$upgrade(values) {
    const { resourceId: resourceId, resourceOwner: resourceOwner, cloudId: cloudId } = values;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $df746fbe0ba5443e$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
class $df746fbe0ba5443e$var$ResourceIdentifier {
    get cloudId() {
        if (this.resourceType === $df746fbe0ba5443e$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
        return this.internalCloudId;
    }
    /**
     * Create a new Ari
     *
     * Only the resourceOwner is a required field, any other field can be omitted.
     * Older format types are converted on creation
     *
     * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
     * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
     * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
     * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
     *
     * @throws {InvalidAriError} if the provided segments fail to pass validation
     */ constructor(values){
        const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $df746fbe0ba5443e$var$upgrade(values);
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    /**
    * Parse a string as an Ari
    *
    * @param {string} ariString - the string to parse
    * @returns {Ari} the parsed ari
    * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
    */ static parse(ariString) {
        if (!ariString) throw new $df746fbe0ba5443e$var$InvalidAriError(ariString);
        const match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $df746fbe0ba5443e$var$InvalidAriError(ariString);
        const terms = match.map((a)=>a && a.length > 0 ? a : undefined);
        const resourceOwner = terms[1];
        if (!resourceOwner) throw new $df746fbe0ba5443e$var$InvalidAriError(ariString);
        return new $df746fbe0ba5443e$var$ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    }
    static parseEncoded(encodedAriString) {
        return $df746fbe0ba5443e$var$parse(decodeURIComponent(encodedAriString));
    }
    /**
     * Converts this Ari to a string.
     */ toString() {
        if (!this.ariString) {
            const resourceId = this.resourceType === $df746fbe0ba5443e$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            const resourceType = this.resourceType || '';
            const sanitizedCloudId = this.resourceType === $df746fbe0ba5443e$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = `ari:cloud:${this.resourceOwner}:${sanitizedCloudId}:${resourceType}/${resourceId}`;
        }
        return this.ariString;
    }
    /**
     * Converts this object to its json representation
     */ toJSON() {
        return this.toString();
    }
    /**
     * Checks if this context is the same as another context
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
     */ equals(other) {
        return other instanceof $df746fbe0ba5443e$var$ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }
    /**
     * This method checks if the current context contains the other context.
     *
     * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
     * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
     *
     * @param {Ari} other
     * @returns {boolean}
     */ contains(other) {
        return this.matches(new $df746fbe0ba5443e$var$ResourceIdentifier(other));
    }
    /**
     * Checks if this context is the same as or contains the provided context.
     *
     * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
     *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
     *
     * e.g.
     * ```
     * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
     * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
     */ matches(other) {
        return $df746fbe0ba5443e$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $df746fbe0ba5443e$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $df746fbe0ba5443e$var$siteResourceType && !!other.resourceType || $df746fbe0ba5443e$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $df746fbe0ba5443e$var$siteResourceType && !!other.resourceType || $df746fbe0ba5443e$var$matchesSegment(this.resourceId, other.resourceId));
    }
    validateSiteWide() {
        const { resourceType: resourceType, cloudId: cloudId } = this;
        if (resourceType === $df746fbe0ba5443e$var$siteResourceType && !cloudId) return new $aRXoY.GeneralValidationError('site wide ARIs must have a cloudId');
    }
    validate() {
        const constraintViolations = [
            $aRXoY.validateField(this, 'resourceOwner', $df746fbe0ba5443e$var$resourceOwnerConstraints),
            $aRXoY.validateField(this, 'resourceType', $df746fbe0ba5443e$var$resourceTypeConstraints),
            $aRXoY.validateField(this, 'resourceId', $df746fbe0ba5443e$var$resourceIdConstraints),
            $aRXoY.validateField(this, 'cloudId', $df746fbe0ba5443e$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $df746fbe0ba5443e$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $df746fbe0ba5443e$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    }
    urlEncode() {
        return encodeURIComponent(this.toString());
    }
    urlDecode() {
        return decodeURIComponent(this.toString());
    }
}
module.exports.ResourceIdentifier = $df746fbe0ba5443e$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $df746fbe0ba5443e$var$parse(ariString) {
    return $df746fbe0ba5443e$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $df746fbe0ba5443e$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $df746fbe0ba5443e$var$parseEncoded(encodedAriString) {
    return $df746fbe0ba5443e$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $df746fbe0ba5443e$var$parseEncoded;

});
parcelRegister("aRXoY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aB0SS = parcelRequire("aB0SS");
class $7e9cee950eba220a$var$LengthConstraint {
    constructor(min, max){
        this.min = min;
        this.max = max;
    }
    get description() {
        return `length must be between ${this.min} and ${this.max}`;
    }
    isValid(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    }
}
module.exports.LengthConstraint = $7e9cee950eba220a$var$LengthConstraint;
class $7e9cee950eba220a$var$RegexConstraint {
    constructor(regex){
        this.regex = regex;
    }
    get description() {
        return `value must match regex ${this.regex.source}`;
    }
    isValid(value) {
        return !value || this.regex.test(value);
    }
}
module.exports.RegexConstraint = $7e9cee950eba220a$var$RegexConstraint;
class $7e9cee950eba220a$var$GeneralValidationError {
    constructor(error){
        this.error = error;
    }
    toString() {
        return this.error;
    }
}
module.exports.GeneralValidationError = $7e9cee950eba220a$var$GeneralValidationError;
class $7e9cee950eba220a$var$ConstraintViolation {
    constructor(fieldName, value, constraints){
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    toString() {
        const constraintSummary = this.constraints.map((c)=>`  - ${c.description}`).join('\n');
        return `'${this.value}' is not a valid value for ${this.fieldName} as it violates the following constraints:\n${constraintSummary}`;
    }
}
module.exports.ConstraintViolation = $7e9cee950eba220a$var$ConstraintViolation;
function $7e9cee950eba220a$var$lengthBetween(min, max) {
    return new $7e9cee950eba220a$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $7e9cee950eba220a$var$lengthBetween;
function $7e9cee950eba220a$var$pattern(regex) {
    return new $7e9cee950eba220a$var$RegexConstraint(regex);
}
module.exports.pattern = $7e9cee950eba220a$var$pattern;
function $7e9cee950eba220a$var$validateField(object, fieldName, constraints) {
    const value = object[fieldName];
    const violatedConstraints = constraints.map((c)=>{
        return c.isValid(value) ? undefined : c;
    }).filter($aB0SS.isDefined);
    return violatedConstraints.length > 0 ? new $7e9cee950eba220a$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $7e9cee950eba220a$var$validateField;

});
parcelRegister("aB0SS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasValueAtKey = module.exports.hasPresentKey = module.exports.isFilled = module.exports.isDefined = module.exports.isPresent = void 0;
function $7b6e0ba147b061df$var$isPresent(t) {
    return t !== undefined && t !== null;
}
module.exports.isPresent = $7b6e0ba147b061df$var$isPresent;
function $7b6e0ba147b061df$var$isDefined(t) {
    return t !== undefined;
}
module.exports.isDefined = $7b6e0ba147b061df$var$isDefined;
function $7b6e0ba147b061df$var$isFilled(t) {
    return t !== null;
}
module.exports.isFilled = $7b6e0ba147b061df$var$isFilled;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a defined non-null value under the key `k`.
 *
 * @example
 * ```ts
 * const filesWithUrl = files.filter(file => file.url);
 * files[0].url // In this case, TS might still treat this as undefined/null
 *
 * const filesWithUrl = files.filter(hasPresentKey("url"));
 * files[0].url // TS will know that this is present
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $7b6e0ba147b061df$var$hasPresentKey(k) {
    return function(a) {
        return a[k] !== undefined && a[k] !== null;
    };
}
module.exports.hasPresentKey = $7b6e0ba147b061df$var$hasPresentKey;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a specific value V under a key `k`.
 *
 * @example
 * ```ts
 * type File = { type: "image", imageUrl: string } | { type: "pdf", pdfUrl: string };
 * const files: File[] = [];
 *
 * const imageFiles = files.filter(file => file.type === "image");
 * files[0].type // In this case, TS will still treat it  as `"image" | "pdf"`
 *
 * const filesWithUrl = files.filter(hasValueKey("type", "image" as const));
 * files[0].type // TS will now know that this is "image"
 * files[0].imageUrl // TS will know this is present, because already it excluded the other union members.
 *
 * Note: the cast `as const` is necessary, otherwise TS will only know that type is a string.
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $7b6e0ba147b061df$var$hasValueAtKey(k, v) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(a) {
        return a[k] === v;
    };
}
module.exports.hasValueAtKey = $7b6e0ba147b061df$var$hasValueAtKey;

});


parcelRegister("8T6Ee", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kQInL = parcelRequire("kQInL");
var $67889de6c03493da$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($67889de6c03493da$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
class $67889de6c03493da$var$AppFamilyAriError extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
    }
}
module.exports.AppFamilyAriError = $67889de6c03493da$var$AppFamilyAriError;
class $67889de6c03493da$var$NotAppFamilyAriError extends $67889de6c03493da$var$AppFamilyAriError {
    constructor(ari, reason){
        super(`ari is not a valid App family ari: ${ari.toString()} as ${reason}`);
        this.reason = reason;
    }
}
module.exports.NotAppFamilyAriError = $67889de6c03493da$var$NotAppFamilyAriError;
class $67889de6c03493da$var$NotExpectedAppFamilyAriTypeError extends $67889de6c03493da$var$AppFamilyAriError {
    constructor(type, ari, cause){
        super(`App family ari (${ari.toString()}) is not of expected type: ${type}`, cause);
        this.cause = cause;
    }
}
module.exports.NotExpectedAppFamilyAriTypeError = $67889de6c03493da$var$NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $67889de6c03493da$var$parseAppAri(ari) {
    return $kQInL.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $67889de6c03493da$var$parseAppAri;
function $67889de6c03493da$var$createAppAri(json) {
    return new $kQInL.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $67889de6c03493da$var$createAppAri;

});
parcelRegister("kQInL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8T6Ee = parcelRequire("8T6Ee");

var $jbrzS = parcelRequire("jbrzS");

var $aRXoY = parcelRequire("aRXoY");
const $f2db175f2d527230$var$versionPrefix = ';v=';
const $f2db175f2d527230$var$uuidRegExpString = '[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}';
const $f2db175f2d527230$var$uuidConstraints = [
    $aRXoY.pattern(new RegExp(`^${$f2db175f2d527230$var$uuidRegExpString}$`, 'i'))
];
const $f2db175f2d527230$var$extensionGroupIdConstraints = [
    $aRXoY.pattern(new RegExp(`^(${$f2db175f2d527230$var$uuidRegExpString}|static)$`, 'i'))
];
class $f2db175f2d527230$var$AppFamilyAriImpl {
    constructor(json){
        this.json = json;
        this.validate();
    }
    get appId() {
        return this.json.appId;
    }
    get environmentId() {
        return this.json.environmentId;
    }
    get version() {
        return this.json.version;
    }
    get extensionGroupId() {
        return this.json.extensionGroupId;
    }
    get extensionKey() {
        return this.json.extensionKey;
    }
    toJSON() {
        return this.json;
    }
    static parse(ari) {
        const { resourceOwner: resourceOwner, resourceType: resourceType, resourceId: resourceId } = ari;
        if (resourceOwner !== $8T6Ee.AppFamilyAri.resourceOwner) throw new $8T6Ee.NotAppFamilyAriError(ari, `resourceOwner (${resourceOwner}) must be ${$8T6Ee.AppFamilyAri.resourceOwner}`);
        if (!resourceType || $8T6Ee.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $8T6Ee.NotAppFamilyAriError(ari, `resourceType must be one of ${$8T6Ee.AppFamilyAri.appFamilyResourceTypes}`);
        if (!resourceId) throw new $8T6Ee.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        const versionIndex = resourceId.indexOf($f2db175f2d527230$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($f2db175f2d527230$var$versionPrefix) > versionIndex) throw new $8T6Ee.NotAppFamilyAriError(ari, 'can only include one version suffix');
        const [mainResourceId, version] = resourceId.split($f2db175f2d527230$var$versionPrefix);
        const segments = mainResourceId.split('/').map($f2db175f2d527230$var$stripToUndefined);
        if (segments.length > 4) throw new $8T6Ee.NotAppFamilyAriError(ari, `no path segments can be added after extensionKey ${segments.slice(4)}`);
        const [appId, environmentId, providedExtensionGroupId, extensionKey] = segments;
        if (!appId) throw new $8T6Ee.NotAppFamilyAriError(ari, 'appId must be included');
        const extensionGroupId = providedExtensionGroupId || (resourceType === $8T6Ee.AppFamilyAri.extensionGroupResourceType || resourceType === $8T6Ee.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $8T6Ee.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId, extensionGroupId, extensionKey must all be provided for resourceType ${$8T6Ee.AppFamilyAri.extensionResourceType}`);
        else if (resourceType === $8T6Ee.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId, extensionGroupId must all be provided for resourceType ${$8T6Ee.AppFamilyAri.extensionGroupResourceType}`);
        else if (resourceType === $8T6Ee.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$8T6Ee.AppFamilyAri.environmentResourceType}`);
        else if (resourceType === $8T6Ee.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$8T6Ee.AppFamilyAri.environmentResourceType}`);
        return new $f2db175f2d527230$var$AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    }
    asAppAri() {
        return this.returnIf(()=>this.isAppAri(), 'app');
    }
    asAppEnvironmentAri() {
        return this.returnIf(()=>this.isAppEnvironmentAri(), 'environment');
    }
    asExtensionGroupAri() {
        return this.returnIf(()=>this.isExtensionGroupAri(), 'extension-group');
    }
    asExtensionAri() {
        return this.returnIf(()=>this.isExtensionAri(), 'extension');
    }
    isAppAri() {
        return !this.isAtLeastAppEnvironmentAri;
    }
    isAppEnvironmentAri() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    }
    isExtensionGroupAri() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    }
    isExtensionAri() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    }
    returnIf(check, type) {
        if (!check()) throw new $8T6Ee.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    }
    get isAtLeastAppEnvironmentAri() {
        return this.environmentId !== undefined;
    }
    get isAtLeastExtensionGroupAri() {
        return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
    }
    validate() {
        const constraintViolations = [
            $aRXoY.validateField(this, 'environmentId', $f2db175f2d527230$var$uuidConstraints),
            $aRXoY.validateField(this, 'appId', $f2db175f2d527230$var$uuidConstraints),
            $aRXoY.validateField(this, 'extensionGroupId', $f2db175f2d527230$var$extensionGroupIdConstraints)
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $jbrzS.InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
    }
    toAri() {
        const resourceOwner = $8T6Ee.AppFamilyAri.resourceOwner;
        const { appId: appId, environmentId: environmentId, extensionGroupId: extensionGroupId, extensionKey: extensionKey, version: version } = this.toJSON();
        function withVersion(segments) {
            const path = segments.join('/');
            if (!version) return path;
            else return `${path}${$f2db175f2d527230$var$versionPrefix}${version}`;
        }
        if (this.isExtensionAri()) return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    }
    toString() {
        return this.toAri().toString();
    }
}
module.exports.AppFamilyAriImpl = $f2db175f2d527230$var$AppFamilyAriImpl;
function $f2db175f2d527230$var$stripToUndefined(str) {
    if (!str) return undefined;
    const trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});



parcelRegister("g3zK9", function(module, exports) {

$parcel$export(module.exports, "getAutomationStack", () => $fad0c3bb22e40c28$export$6123178d3f5fb24d);
const $fad0c3bb22e40c28$var$AUTOMATION_LOCAL_STORAGE_PREFIX = 'automationPlatform';
const $fad0c3bb22e40c28$var$AUTOMATION_LOCAL_STORAGE_STACK = 'automationStack';
const $fad0c3bb22e40c28$var$AUTOMATION_DEV_STACK_URL = 'https://localhost:8082/devStack.json';
const $fad0c3bb22e40c28$var$getAutomationProdStackUrl = (cloudId)=>`/gateway/api/automation/internal-api/jira/${cloudId}/pro/rest/environments`;
const $fad0c3bb22e40c28$var$getLatestPreProdStack = async (cloudId)=>{
    try {
        const response = await fetch($fad0c3bb22e40c28$var$getAutomationProdStackUrl(cloudId));
        const stacksResponse = await response.json();
        const preProdStacks = stacksResponse.prod.otherStacks.filter(({ releasedSuccessfully: releasedSuccessfully })=>!releasedSuccessfully).map(({ stack: stack })=>stack);
        const [latestPreProdStack = null] = preProdStacks;
        return latestPreProdStack;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`Failed to fetch pre-prod stack from ${$fad0c3bb22e40c28$var$getAutomationProdStackUrl(cloudId)} with error: ${e}`);
        return null;
    }
};
const $fad0c3bb22e40c28$var$_getAutomationKeyFromLocalStorage = (key)=>{
    return window.localStorage.getItem(`${$fad0c3bb22e40c28$var$AUTOMATION_LOCAL_STORAGE_PREFIX}:${key}`);
};
const $fad0c3bb22e40c28$var$getAutomationDevStackFromLocalServer = async ()=>{
    try {
        const devStackResponse = await fetch($fad0c3bb22e40c28$var$AUTOMATION_DEV_STACK_URL);
        const devStack = await devStackResponse.json();
        return devStack.name;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`Failed to fetch dev stack from ${$fad0c3bb22e40c28$var$AUTOMATION_DEV_STACK_URL} with error: ${e}`);
        return null;
    }
};
const $fad0c3bb22e40c28$export$48cdb3ba720a47f6 = ()=>$fad0c3bb22e40c28$var$_getAutomationKeyFromLocalStorage($fad0c3bb22e40c28$var$AUTOMATION_LOCAL_STORAGE_STACK);
const $fad0c3bb22e40c28$export$6123178d3f5fb24d = async (env, cloudId)=>{
    if (env === 'prod') return 'pro';
    if (env === 'pre-prod') {
        const stack = await $fad0c3bb22e40c28$var$getLatestPreProdStack(cloudId);
        return stack ?? 'pro';
    }
    // We fetch the dev stack name from local server (barrel webpack dev server) if it's available.
    // However, this requires that devWatch is running locally.
    // To use manual triggers without running devWatch, set the local storage value to your stack name e.g. devltan3. The full key is: automationPlatform:automationStack
    const stackOverride = await $fad0c3bb22e40c28$var$getAutomationDevStackFromLocalServer() || $fad0c3bb22e40c28$export$48cdb3ba720a47f6();
    return stackOverride || 'staging';
};

});



parcelRegister("gSw9T", function(module, exports) {

$parcel$export(module.exports, "UserInputForm", () => $2d4c6f1389454e60$export$a3f697c029ab2691);
$parcel$export(module.exports, "default", () => $2d4c6f1389454e60$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $eCeGD = parcelRequire("eCeGD");

var $efXp3 = parcelRequire("efXp3");
var $qfj8c = parcelRequire("qfj8c");
var $3lQ26 = parcelRequire("3lQ26");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $cFwyy = parcelRequire("cFwyy");

var $1vBpb = parcelRequire("1vBpb");

var $dZuta = parcelRequire("dZuta");

var $6WPAN = parcelRequire("6WPAN");

var $7mBJV = parcelRequire("7mBJV");

var $g9On4 = parcelRequire("g9On4");

var $bDNlV = parcelRequire("bDNlV");
const $2d4c6f1389454e60$export$a3f697c029ab2691 = (props)=>{
    (0, $gKZoD.di)((0, $dZuta.default), (0, $eCeGD.default), (0, $qfj8c.ErrorMessage), (0, $efXp3.default), (0, $3lQ26.default), (0, $1R1Ge.default), (0, $7QSqG.default), (0, $juxqI.default), (0, $jgVsb.default), (0, $gofOI.default), (0, $6WPAN.default), (0, $g9On4.default), (0, $bDNlV.default));
    const { selectedRule: selectedRule, clearSelectedRule: clearSelectedRule, invokeRule: invokeRule, onInputsModalOpened: onInputsModalOpened, onInputsModalClosed: onInputsModalClosed } = props;
    const { rule: rule, objects: objects } = selectedRule;
    const { userInputPrompts: userInputPrompts } = rule;
    const getTypeOfInput = (key, prompts)=>prompts.find(({ variableName: variableName })=>variableName === key)?.inputType;
    const generateInputValue = (inputType, data)=>{
        switch(inputType){
            case (0, $1vBpb.UserInputType).DROPDOWN:
                return {
                    inputType: inputType,
                    value: data ? data.value : ''
                };
            case (0, $1vBpb.UserInputType).NUMBER:
                return {
                    inputType: inputType,
                    value: Number(data)
                };
            default:
                return {
                    inputType: inputType,
                    value: data
                };
        }
    };
    const handleSubmit = (data)=>{
        const output = Object.entries(data).reduce((acc, [key, value])=>{
            const inputType = getTypeOfInput(key, userInputPrompts);
            if (!inputType) return acc;
            acc[key] = generateInputValue(inputType, value);
            return acc;
        }, {});
        return invokeRule(rule.id, objects, output);
    };
    const handleOpen = ()=>{
        if (onInputsModalOpened) onInputsModalOpened();
    };
    const handleClose = ()=>{
        clearSelectedRule();
        if (onInputsModalClosed) onInputsModalClosed();
    };
    const generateUserInputForm = (inputPrompt)=>{
        switch(inputPrompt.inputType){
            case (0, $1vBpb.UserInputType).TEXT:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bDNlV.default), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            case (0, $1vBpb.UserInputType).NUMBER:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6WPAN.default), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            case (0, $1vBpb.UserInputType).DROPDOWN:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g9On4.default), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            case (0, $1vBpb.UserInputType).BOOLEAN:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dZuta.default), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            case (0, $1vBpb.UserInputType).PARAGRAPH:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7mBJV.default), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            default:
                return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("br", {}),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $qfj8c.ErrorMessage), {
                            children: (0, $cFwyy.default).errorInputTypeIsNotSupported.defaultMessage
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("br", {})
                    ]
                });
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1R1Ge.default), {
        "data-testid": "automation-platform.ui.manual-rules-container.manual-triggers-form.modal",
        onClose: handleClose,
        onOpenComplete: handleOpen,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $efXp3.default), {
            onSubmit: handleSubmit,
            children: ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("form", {
                    ...formProps,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jgVsb.default), {
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gofOI.default), {
                                children: rule.name
                            })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7QSqG.default), {
                            children: [
                                (0, $cFwyy.default).inputRequiredForAction.defaultMessage,
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3lQ26.default), {
                                    children: userInputPrompts.map(generateUserInputForm)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $juxqI.default), {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                                    appearance: "subtle",
                                    onClick: handleClose,
                                    isDisabled: submitting,
                                    children: (0, $cFwyy.default).cancelButtonTitle.defaultMessage
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                                    appearance: "primary",
                                    type: "submit",
                                    isLoading: submitting,
                                    autoFocus: true,
                                    children: (0, $cFwyy.default).continueButtonTitle.defaultMessage
                                })
                            ]
                        })
                    ]
                })
        })
    });
};
var $2d4c6f1389454e60$export$2e2bcd8739ae039 = $2d4c6f1389454e60$export$a3f697c029ab2691;

});
parcelRegister("3lQ26", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e71eeb72c100e3$export$2e2bcd8739ae039);
/* form-section.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");
const $b3e71eeb72c100e3$var$formSectionDescriptionStyles = null;
const $b3e71eeb72c100e3$var$formSectionWrapperStyles = null;
const $b3e71eeb72c100e3$var$FormSectionWrapper = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/design-system/use-primitives
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1pfh1ejb"
        ]),
        children: children
    });
};
const $b3e71eeb72c100e3$var$FormSectionDescription = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/design-system/use-primitives
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1pfhu2gc"
        ]),
        children: children
    });
};
/**
 * __Form section__.
 *
 * A form section is used to define a section of a form layout. This contains a section title, content
 * and a description of the section.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const $b3e71eeb72c100e3$var$FormSection = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)($b3e71eeb72c100e3$var$FormSectionWrapper, {
        children: [
            title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                size: "medium",
                children: title
            }),
            description && /*#__PURE__*/ (0, $2OMIu.jsx)($b3e71eeb72c100e3$var$FormSectionDescription, {
                children: description
            }),
            children
        ]
    });
};
var $b3e71eeb72c100e3$export$2e2bcd8739ae039 = $b3e71eeb72c100e3$var$FormSection;

});

parcelRegister("cFwyy", function(module, exports) {

$parcel$export(module.exports, "default", () => $455d55ebd61a4abd$export$2e2bcd8739ae039);
const $455d55ebd61a4abd$var$messages = {
    successFlag: {
        id: 'automation-platform.common.success-flag',
        defaultMessage: 'Your automation is in progress',
        description: 'Text for a success flag when an automation rule has been triggered'
    },
    failureFlagTitle: {
        id: 'automation-platform.common.failure-flag-title',
        defaultMessage: 'Oops we ran into a problem',
        description: 'Title for an error flag when an automation rule failed to be triggered'
    },
    failureFlagDescription: {
        id: 'automation-platform.common.failure-flag-description',
        defaultMessage: "There was a problem and we couldn't run the automation '{0}'",
        description: 'Description for an error flag when an automation rule failed to be triggered'
    },
    partialFailureFlagDescription: {
        id: 'automation-platform.common.partial-failure-flag-description',
        defaultMessage: "Couldn't run the automation against issues {0}, please ensure you have permission to view these issues",
        description: 'Description for an error flag when some issues failed to invoke because user does not have view permission'
    },
    errorInputMustNotBeEmpty: {
        id: 'automation-platform.common.error-input-must-not-be-empty',
        defaultMessage: 'Input must not be empty',
        description: 'The error message to show the value of a required field is empty'
    },
    errorInputCharacterLimitReached: {
        id: 'automation-platform.common.error-input-character-limit-reached',
        defaultMessage: 'Provided value exceeds the character limit for the field.',
        description: 'The error message to show that the character limit has been reached for the field'
    },
    inputRequiredForAction: {
        id: 'automation-platform.common.input-required-for-action',
        defaultMessage: 'Your input is required to complete this action',
        description: 'The title of the modal for user inputs'
    },
    errorInputTypeIsNotSupported: {
        id: 'automation-platform.common.error-input-type-is-not-supported',
        defaultMessage: 'Input type not supported yet',
        description: 'The error message to show when the type of user input is not recognised'
    },
    errorValueIsNotValidNumber: {
        id: 'automation-platform.common.error-value-is-not-valid-number',
        defaultMessage: 'The value is not a valid number',
        description: 'The error message for when the type of user input is number but the value is not a valid number'
    },
    cancelButtonTitle: {
        id: 'automation-platform.common.cancel-button-title',
        defaultMessage: 'Cancel',
        description: 'The cancel button title'
    },
    continueButtonTitle: {
        id: 'automation-platform.common.continue-button-title',
        defaultMessage: 'Continue',
        description: 'The continue button title'
    }
};
var $455d55ebd61a4abd$export$2e2bcd8739ae039 = $455d55ebd61a4abd$var$messages;

});

parcelRegister("1vBpb", function(module, exports) {

$parcel$export(module.exports, "UserInputType", () => $7ba154a8ce2ccf9e$export$955ccc93b55d5904);
var $7ba154a8ce2ccf9e$export$955ccc93b55d5904 = /*#__PURE__*/ function(UserInputType) {
    UserInputType["NUMBER"] = "NUMBER";
    UserInputType["TEXT"] = "TEXT";
    UserInputType["BOOLEAN"] = "BOOLEAN";
    UserInputType["DROPDOWN"] = "DROPDOWN";
    UserInputType["PARAGRAPH"] = "PARAGRAPH";
    return UserInputType;
}({});
const $7ba154a8ce2ccf9e$export$4b79f735ed858abe = 'business';
const $7ba154a8ce2ccf9e$export$417275bac62d38d2 = 'software';
const $7ba154a8ce2ccf9e$export$9c9c9eaf8c092006 = 'service_desk';
const $7ba154a8ce2ccf9e$export$e9fe9a39cc7f5103 = 'product_discovery';
const $7ba154a8ce2ccf9e$export$e9c56aa3b027d98f = 'customer_service';

});

parcelRegister("dZuta", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae94375b49c6df33$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $kkJfY = parcelRequire("kkJfY");

var $hp1g9 = parcelRequire("hp1g9");
const $ae94375b49c6df33$var$BooleanInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $gKZoD.di)((0, $kkJfY.default), (0, $hp1g9.default));
    const { variableName: variableName, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hp1g9.default), {
        name: variableName,
        defaultIsChecked: defaultValue || false,
        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kkJfY.default), {
                ...fieldProps,
                label: displayName
            })
    });
};
var $ae94375b49c6df33$export$2e2bcd8739ae039 = $ae94375b49c6df33$var$BooleanInputPrompt;

});
parcelRegister("hp1g9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ccbe97401ecc0bf$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7O4UO = parcelRequire("7O4UO");
/**
 * __Checkbox field__
 *
 * A checkbox field is a form field that lets users select an item. Users can check or uncheck the checkbox.
 *
 * - [Examples] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Code] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Usage] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 */ const $9ccbe97401ecc0bf$var$CheckboxField = (props)=>{
    const { children: children, defaultIsChecked: defaultIsChecked = false, value: value, ...rest } = props;
    // Maintains a memoised list of the default values
    const defaultValue = (0, $5uXOq.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7O4UO.default), {
        ...rest,
        defaultValue: defaultValue,
        transform: (event, currentValue)=>event.currentTarget.checked && currentValue ? [
                ...currentValue,
                value
            ] : currentValue.filter((v)=>v !== value),
        children: ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    isChecked: !!fieldValue.find((v)=>v === value),
                    value: value
                },
                ...others
            })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7O4UO.default), {
        ...rest,
        defaultValue: defaultIsChecked,
        transform: (event)=>event.currentTarget.checked,
        children: ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    isChecked: fieldValue,
                    value: value
                },
                ...others
            })
    });
};
$9ccbe97401ecc0bf$var$CheckboxField.defaultProps = {
    defaultIsChecked: false
};
var $9ccbe97401ecc0bf$export$2e2bcd8739ae039 = $9ccbe97401ecc0bf$var$CheckboxField;

});


parcelRegister("6WPAN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e22492a7312b03b7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");

var $kY99m = parcelRequire("kY99m");

var $cFwyy = parcelRequire("cFwyy");
var $e22492a7312b03b7$export$b8e9cd941e8016ac = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    Errors["INVALID_NUMBER"] = "INVALID_NUMBER";
    return Errors;
}({});
const $e22492a7312b03b7$export$c6cbc3bbef9e5a54 = (isRequired, value)=>{
    if (isRequired && !value) return "EMPTY";
    if (value && Number.isNaN(Number(value))) return "INVALID_NUMBER";
    return undefined;
};
const $e22492a7312b03b7$var$NumberInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $gKZoD.di)((0, $qfj8c.ErrorMessage), (0, $7O4UO.default), (0, $kY99m.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const generateErrorMessage = (error)=>{
        switch(error){
            case "EMPTY":
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $qfj8c.ErrorMessage), {
                    children: (0, $cFwyy.default).errorInputMustNotBeEmpty.defaultMessage
                });
            case "INVALID_NUMBER":
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $qfj8c.ErrorMessage), {
                    children: (0, $cFwyy.default).errorValueIsNotValidNumber.defaultMessage
                });
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7O4UO.default), {
        "aria-required": required,
        name: variableName,
        label: displayName,
        defaultValue: defaultValue,
        isRequired: required,
        validate: (value)=>$e22492a7312b03b7$export$c6cbc3bbef9e5a54(required, value),
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kY99m.default), {
                        ...fieldProps
                    }),
                    generateErrorMessage(error)
                ]
            })
    }, variableName);
};
var $e22492a7312b03b7$export$2e2bcd8739ae039 = $e22492a7312b03b7$var$NumberInputPrompt;

});

parcelRegister("7mBJV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c0425f45ac938ac$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");

var $6LCpJ = parcelRequire("6LCpJ");

var $cFwyy = parcelRequire("cFwyy");
var $0c0425f45ac938ac$var$Errors = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    Errors["CHARACTER_LIMIT"] = "CHARACTER_LIMIT";
    return Errors;
}($0c0425f45ac938ac$var$Errors || {});
const $0c0425f45ac938ac$var$MAX_PARAGRAPH_CHARACTER_LIMIT = 5000;
const $0c0425f45ac938ac$var$ParagraphInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $gKZoD.di)((0, $qfj8c.ErrorMessage), (0, $7O4UO.default), (0, $6LCpJ.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const validate = (value)=>{
        if (required && !value) return "EMPTY";
        if (value && value?.trim().length === 0) return "EMPTY";
        if (value && value.length > $0c0425f45ac938ac$var$MAX_PARAGRAPH_CHARACTER_LIMIT) return "CHARACTER_LIMIT";
        return undefined;
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7O4UO.default), {
        name: variableName,
        label: displayName,
        defaultValue: defaultValue,
        isRequired: required,
        validate: validate,
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6LCpJ.default), {
                        ...fieldProps
                    }),
                    error === "EMPTY" && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $qfj8c.ErrorMessage), {
                        children: (0, $cFwyy.default).errorInputMustNotBeEmpty.defaultMessage
                    }),
                    error === "CHARACTER_LIMIT" && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $qfj8c.ErrorMessage), {
                        children: (0, $cFwyy.default).errorInputCharacterLimitReached.defaultMessage
                    })
                ]
            })
    });
};
var $0c0425f45ac938ac$export$2e2bcd8739ae039 = $0c0425f45ac938ac$var$ParagraphInputPrompt;

});
parcelRegister("6LCpJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $934f91ac04cc5aeb$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $VSDnB = parcelRequire("VSDnB");
const $934f91ac04cc5aeb$var$packageName = "platform-pkg";
const $934f91ac04cc5aeb$var$packageVersion = "0.0.0-use.local";
const $934f91ac04cc5aeb$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $934f91ac04cc5aeb$var$packageName,
    packageVersion: $934f91ac04cc5aeb$var$packageVersion
};
const $934f91ac04cc5aeb$var$lineHeightBase = 20;
const $934f91ac04cc5aeb$var$lineHeightCompact = 16;
const $934f91ac04cc5aeb$var$compactVerticalPadding = 2;
const $934f91ac04cc5aeb$var$verticalPadding = 6;
const $934f91ac04cc5aeb$var$transitionDuration = '0.2s';
const $934f91ac04cc5aeb$var$borderWidth = 2;
const $934f91ac04cc5aeb$var$baseStyles = null;
const $934f91ac04cc5aeb$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp821elr _1ltx1j9a _1bqs13gt _z1pvsyzs _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _17km1v6z _wg601v6z _858u1p6i _jomrr01l _7ehiq049 _186j1p6i _qu18syzs",
    subtle: "_1dqonqa1 _kp823acm _1ltx18uv _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _wg601v6z _17km1v6z _858u1p6i _jomrr01l _7ehiq049",
    none: "_1dqoglyw _kp823acm _1ltx18uv _19wt3acm _12ym18uv _19qkv77o _zedr12x7 _1dbiv77o _1etu12x7 _1itd12x7 _wg6012x7 _1a4912x7 _17km12x7 _858u3acm _jomr18uv _7ehinruj"
};
const $934f91ac04cc5aeb$var$fontStyles = {
    default: "_ect41gqc",
    monospace: "_ect41odn _1tn22smr _14mdudxr",
    large: "_11c81ixg _1tn22smr"
};
const $934f91ac04cc5aeb$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $934f91ac04cc5aeb$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $934f91ac04cc5aeb$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $934f91ac04cc5aeb$var$InnerTextArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const ourRef = (0, $5uXOq.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $5uXOq.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$934f91ac04cc5aeb$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$934f91ac04cc5aeb$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $5uXOq.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rko1sit _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazj3m3 _slp31hna _153g78r2 _usy4mag2 _1a2sr6rt _vbqb9jg2 _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra78r2 _ibjd10ko _6zpvr6rt _19k01y1w _1idr1wmz _1lep9jg2 _nmhq1fiz _1n388sxn _1luh194a _ndzbr01l _1vj01cu8",
            $934f91ac04cc5aeb$var$appearanceStyles[appearance],
            (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && $934f91ac04cc5aeb$var$fontStyles['large'],
            $934f91ac04cc5aeb$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $934f91ac04cc5aeb$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $lD23V.default)($934f91ac04cc5aeb$var$lineHeightCompact * minimumRows + $934f91ac04cc5aeb$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $lD23V.default)($934f91ac04cc5aeb$var$lineHeightBase * minimumRows + $934f91ac04cc5aeb$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $934f91ac04cc5aeb$var$TextArea = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($934f91ac04cc5aeb$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$934f91ac04cc5aeb$var$TextArea.displayName = 'TextArea';
var $934f91ac04cc5aeb$export$2e2bcd8739ae039 = $934f91ac04cc5aeb$var$TextArea;

});


parcelRegister("g9On4", function(module, exports) {

$parcel$export(module.exports, "default", () => $b944eed42d17fa4b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");

var $7K5PP = parcelRequire("7K5PP");

var $cFwyy = parcelRequire("cFwyy");
var $b944eed42d17fa4b$var$Errors = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    return Errors;
}($b944eed42d17fa4b$var$Errors || {});
const $b944eed42d17fa4b$var$SelectInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $gKZoD.di)((0, $qfj8c.ErrorMessage), (0, $7O4UO.default), (0, $7K5PP.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const validate = (value)=>{
        if (required && !value) return "EMPTY";
        return undefined;
    };
    const selectOptions = defaultValue.map((value)=>({
            label: value,
            value: value
        }));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7O4UO.default), {
        name: variableName,
        label: displayName,
        isRequired: required,
        validate: validate,
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K5PP.default), {
                        isClearable: true,
                        isSearchable: true,
                        options: selectOptions,
                        menuPosition: "fixed",
                        ...fieldProps
                    }),
                    error === "EMPTY" && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $qfj8c.ErrorMessage), {
                        children: (0, $cFwyy.default).errorInputMustNotBeEmpty.defaultMessage
                    })
                ]
            })
    });
};
var $b944eed42d17fa4b$export$2e2bcd8739ae039 = $b944eed42d17fa4b$var$SelectInputPrompt;

});

parcelRegister("bDNlV", function(module, exports) {

$parcel$export(module.exports, "default", () => $95844140411f95a2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");

var $kY99m = parcelRequire("kY99m");

var $cFwyy = parcelRequire("cFwyy");
var $95844140411f95a2$var$Errors = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    return Errors;
}($95844140411f95a2$var$Errors || {});
const $95844140411f95a2$var$TextInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $gKZoD.di)((0, $qfj8c.ErrorMessage), (0, $7O4UO.default), (0, $kY99m.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const validate = (value)=>required && !value ? "EMPTY" : undefined;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7O4UO.default), {
        name: variableName,
        label: displayName,
        defaultValue: defaultValue,
        isRequired: required,
        validate: validate,
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kY99m.default), {
                        ...fieldProps
                    }),
                    error === "EMPTY" && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $qfj8c.ErrorMessage), {
                        children: (0, $cFwyy.default).errorInputMustNotBeEmpty.defaultMessage
                    })
                ]
            })
    });
};
var $95844140411f95a2$export$2e2bcd8739ae039 = $95844140411f95a2$var$TextInputPrompt;

});



parcelRegister("k9To8", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef3572ada154aadf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ef3572ada154aadf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    successFlag: {
        "id": "automation-platform.common.success-flag",
        "defaultMessage": "Your automation is in progress"
    },
    failureFlagTitle: {
        "id": "automation-platform.common.failure-flag-title",
        "defaultMessage": "Oops we ran into a problem"
    },
    failureFlagDescription: {
        "id": "automation-platform.common.failure-flag-description",
        "defaultMessage": "There was a problem and we couldn't run the automation \"{0}\""
    },
    partialFailureFlagDescription: {
        "id": "automation-platform.common.partial-failure-flag-description",
        "defaultMessage": "Couldn't run the automation against issues \"{0}\", please ensure you have permission to view these issues"
    },
    errorInputMustNotBeEmpty: {
        "id": "automation-platform.common.error-input-must-not-be-empty",
        "defaultMessage": "Input must not be empty"
    },
    errorInputCharacterLimitReached: {
        "id": "automation-platform.common.error-input-character-limit-reached",
        "defaultMessage": "Provided value exceeds the character limit for the field."
    },
    inputRequiredForAction: {
        "id": "automation-platform.common.input-required-for-action",
        "defaultMessage": "Your input is required to complete this action"
    },
    errorInputTypeIsNotSupported: {
        "id": "automation-platform.common.error-input-type-is-not-supported",
        "defaultMessage": "Input type not supported yet"
    },
    errorValueIsNotValidNumber: {
        "id": "automation-platform.common.error-value-is-not-valid-number",
        "defaultMessage": "The value is not a valid number"
    },
    cancelButtonTitle: {
        "id": "automation-platform.common.cancel-button-title",
        "defaultMessage": "Cancel"
    },
    continueButtonTitle: {
        "id": "automation-platform.common.continue-button-title",
        "defaultMessage": "Continue"
    }
});

});


parcelRegister("7lu0s", function(module, exports) {

$parcel$export(module.exports, "ActionsMenu", () => $fc8e573f30eba755$export$dcd7272559c21ebc);
/* index-old.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $42CjB = parcelRequire("42CjB");

var $5LWLA = parcelRequire("5LWLA");

var $4ldhu = parcelRequire("4ldhu");

var $kEVMo = parcelRequire("kEVMo");

var $9UCCQ = parcelRequire("9UCCQ");

var $jgJNO = parcelRequire("jgJNO");

var $hrfsZ = parcelRequire("hrfsZ");

var $4R6GH = parcelRequire("4R6GH");

var $9LkAS = parcelRequire("9LkAS");

var $2vSU6 = parcelRequire("2vSU6");

var $gwIPs = parcelRequire("gwIPs");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $bN8dM = parcelRequire("bN8dM");

var $dCm1o = parcelRequire("dCm1o");

var $jTAKY = parcelRequire("jTAKY");

var $4mO32 = parcelRequire("4mO32");

var $1eyaH = parcelRequire("1eyaH");

var $47gW9 = parcelRequire("47gW9");

var $hlI3h = parcelRequire("hlI3h");


var $7ATHt = parcelRequire("7ATHt");

var $3ihJD = parcelRequire("3ihJD");

var $1MVgQ = parcelRequire("1MVgQ");

var $2JIM8 = parcelRequire("2JIM8");

var $lB5s6 = parcelRequire("lB5s6");

var $iejfI = parcelRequire("iejfI");
// when this mounts. This is how we ensure lazy load behaviour of the menu.
const $fc8e573f30eba755$var$FetchRulesContainer = (props)=>{
    const { triggerFetch: triggerFetch, children: children } = props;
    (0, $5uXOq.useEffect)(()=>{
        triggerFetch(); // Ignore exhaustive dep here to ensure no call to useEffect on re-render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $fc8e573f30eba755$var$tooltipOptions = {
    position: 'top',
    hideTooltipOnClick: true
};
const $fc8e573f30eba755$var$customModifiers = [
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: {
                top: 65
            }
        }
    }
];
const $fc8e573f30eba755$var$RecurWorkItemContainerEmpty = ({ children: children })=>children;
const $fc8e573f30eba755$export$f48224de87d33a65 = ()=>(0, $5uXOq.useState)(false);
const $fc8e573f30eba755$var$EMPTY_OBJECT = {};
const $fc8e573f30eba755$export$dcd7272559c21ebc = (props)=>{
    const { transitions: transitions, onSelect: onSelect, rules: rules, executeRule: executeRule, executingRule: executingRule, triggerFetch: triggerFetch, initialised: initialised, issueKey: issueKey, issueId: issueId, projectType: projectType, baseAutomationUrl: baseAutomationUrl, canManageAutomations: canManageAutomations } = props;
    const [activePopupKey, setActivePopupKey] = (0, $5uXOq.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = $fc8e573f30eba755$export$f48224de87d33a65();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const menuContainerRef = (0, $5uXOq.useRef)(null);
    const updatePopupPositionRef = (0, $5uXOq.useRef)(null);
    const { entryPointReferenceSubject: recurringWorkEntryPointRef, entryPointActions: recurringWorkEntryPointActions } = (0, $4mO32.useEntryPoint)((0, $jTAKY.asyncRecurWorkFormEntryPoint), $fc8e573f30eba755$var$EMPTY_OBJECT);
    const recurringWorkTriggerRef = (0, $47gW9.useEntryPointButtonTrigger)(recurringWorkEntryPointActions);
    const canSeeRecurringWorkToggle = canManageAutomations && (projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.CORE_PROJECT)) && (0, $6s1PB.expVal)('jira_recurring_work_oncomplete_admin_experiment', 'showRecurringWorkToggle', false) && !(0, $6s1PB.expVal)('jira-recur-single-work-item-on-schedule', 'showRecurringWorkPopup', false);
    const canSeeRecurringWorkPopup = (projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.CORE_PROJECT)) && (0, $6s1PB.expVal)('jira-recur-single-work-item-on-schedule', 'showRecurringWorkPopup', false);
    const canSeeRecurringWorkPopupWithNewTrigger = canSeeRecurringWorkPopup && (0, $4R6GH.fg)('jira-recur-single-work-item-on-sched-due-date-gate');
    const onTriggerClick = (0, $5uXOq.useCallback)(()=>{
        if (!isOpen) {
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'menu',
                action: 'opened'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'manualRulesActionsMenu', {
                userType: canManageAutomations ? 'admin' : 'endUser'
            });
        }
        if (isOpen) setActivePopupKey(null);
        setIsOpen(!isOpen);
    }, [
        canManageAutomations,
        createAnalyticsEvent,
        isOpen,
        setIsOpen
    ]); // fallback placements added as per atlaskit dropdown-menu
    const fallbackPlacements = [
        'bottom',
        'bottom-end',
        'top-start',
        'top',
        'top-end',
        'auto'
    ];
    const onBackForRecurWorkPopup = (0, $5uXOq.useCallback)(()=>{
        setActivePopupKey(null);
        setTimeout(()=>{
            // this will only work while 'jira-recur-single-work-item-on-sched-due-date-gate' is enabled,
            // but that's ok because this function is only called when that gate is enabled.
            menuContainerRef?.current?.querySelector(`[data-testid='${(0, $lB5s6.RECUR_WORK_COMPONENT_TEST_ID_PREFIX)}${(0, $f60a10b809e51afa$export$6670546ab560a9dd)}']`)?.focus();
        }, 0);
    }, []);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
        setActivePopupKey(null);
    }, [
        setIsOpen,
        setActivePopupKey
    ]);
    const renderActivePopup = (0, $5uXOq.useCallback)(()=>{
        if (activePopupKey === (0, $lB5s6.POPUP_KEYS).recurWork) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2JIM8.RecurWorkContainer), {
            entryPointRef: recurringWorkEntryPointRef,
            issueKey: issueKey,
            onBack: (0, $4R6GH.fg)('jira-recur-single-work-item-on-sched-due-date-gate') ? onBackForRecurWorkPopup : ()=>setActivePopupKey(null),
            onClose: onClose
        });
    }, [
        activePopupKey,
        recurringWorkEntryPointRef,
        issueKey,
        onClose,
        onBackForRecurWorkPopup
    ]);
    const handleOpenRecurWorkPopup = (0, $5uXOq.useCallback)(()=>{
        setActivePopupKey((0, $lB5s6.POPUP_KEYS).recurWork);
    }, []);
    const RecurWorkItemContainer = canSeeRecurringWorkPopup || canSeeRecurringWorkPopupWithNewTrigger ? (0, $1eyaH.RecurWorkItemContainer) : $fc8e573f30eba755$var$RecurWorkItemContainerEmpty;
    (0, $5uXOq.useEffect)(()=>{
        (0, $4R6GH.fg)('jira-recur-single-work-item-on-sched-due-date-gate') && updatePopupPositionRef.current?.();
        if (activePopupKey === (0, $lB5s6.POPUP_KEYS).recurWork) globalThis.document.querySelector(`#${(0, $lB5s6.POPUP_ID)}`)?.focus();
    }, [
        activePopupKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RecurWorkItemContainer, {
        issueKey: issueKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        messageId: "issue-field-status.ui.status-view.actions.actions-menu.popup",
        messageType: "transactional",
        isOpen: isOpen,
        placement: "bottom-start",
        fallbackPlacements: fallbackPlacements,
        id: (0, $lB5s6.POPUP_ID),
        trigger: (triggerProps)=>{
            const trigger = (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                ...triggerProps,
                isSelected: isOpen,
                onClick: onTriggerClick,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($4ldhu))),
                isTooltipDisabled: false,
                tooltip: $fc8e573f30eba755$var$tooltipOptions,
                label: formatMessage((0, $3ihJD.default).automation),
                interactionName: "jira-issue-field-status.ui.status-view.actions.actions-menu.button"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...triggerProps,
                appearance: "subtle",
                isSelected: isOpen,
                onClick: onTriggerClick,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
                    label: "",
                    size: "small"
                }),
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
                    size: "medium",
                    glyph: (0, $hrfsZ.AutomationGlyph),
                    label: "",
                    secondaryColor: "none"
                }),
                interactionName: "jira-issue-field-status.ui.status-view.actions.actions-menu.button"
            }, formatMessage((0, $3ihJD.default).actions));
            return trigger;
        },
        onClose: onClose,
        content: ({ update: update })=>{
            if ((0, $4R6GH.fg)('jira-recur-single-work-item-on-sched-due-date-gate')) updatePopupPositionRef.current = update;
            return activePopupKey && (canSeeRecurringWorkPopup || canSeeRecurringWorkPopupWithNewTrigger) ? renderActivePopup() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ref: menuContainerRef,
                className: (0, $bwpsq.default)([
                    "_3fcw18uv _1reo1wug _18m91wug _c71l132o"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fc8e573f30eba755$export$b33066c493600138, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fc8e573f30eba755$var$FetchRulesContainer, {
                triggerFetch: triggerFetch
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1MVgQ.TransitionsSubMenu), {
                initialised: initialised,
                onSelect: onSelect,
                transitions: transitions,
                canManageAutomations: canManageAutomations
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ATHt.AutomationSubMenu), {
                initialised: initialised,
                rules: rules,
                transitions: transitions,
                executeRule: executeRule,
                issueKey: issueKey,
                issueId: issueId,
                executingRule: executingRule,
                baseAutomationUrl: baseAutomationUrl,
                canManageAutomations: canManageAutomations
            }))), canSeeRecurringWorkPopupWithNewTrigger && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hlI3h.RecurWorkComponent), {
                triggerType: (0, $f60a10b809e51afa$export$fec55ff920461811),
                testId: (0, $lB5s6.RECUR_WORK_COMPONENT_TEST_ID_PREFIX),
                buttonRef: recurringWorkTriggerRef,
                onClick: handleOpenRecurWorkPopup,
                issueKey: issueKey,
                recurWorkFormEntryPoint: "actionsMenu"
            }), !canSeeRecurringWorkPopupWithNewTrigger && canSeeRecurringWorkPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iejfI.RecurWorkMenuItem), {
                buttonRef: recurringWorkTriggerRef,
                onClick: handleOpenRecurWorkPopup,
                issueKey: issueKey,
                recurWorkFormEntryPoint: "actionsMenu"
            }), canSeeRecurringWorkToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bN8dM.RecurringIssueLinkItem), {
                issueKey: issueKey
            }), canManageAutomations && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9LkAS.default), {
                baseAutomationUrl: baseAutomationUrl
            }));
        },
        zIndex: (0, $gwIPs.layers).modal,
        shouldRenderToParent: true,
        modifiers: $fc8e573f30eba755$var$customModifiers,
        testId: "issue-field-status.ui.status-view.actions.actions-menu.popup"
    }));
};
const $fc8e573f30eba755$export$b33066c493600138 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $9UCCQ.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1wug _18m91wug _1ul9nklw _c71l1dft",
            __cmplp.className
        ])
    });
});
const $fc8e573f30eba755$var$menuContainerStyles = null;

});
parcelRegister("4ldhu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2251b011785916069b749fddb2c5cd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32936cf628dec798$var$_react = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $32936cf628dec798$var$_baseNew = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $32936cf628dec798$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $32936cf628dec798$var$AutomationIcon = (props)=>/*#__PURE__*/ $32936cf628dec798$var$_react.default.createElement($32936cf628dec798$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$32936cf628dec798$var$AutomationIcon.displayName = 'AutomationIcon';
var $32936cf628dec798$var$_default = module.exports.default = $32936cf628dec798$var$AutomationIcon;

});

parcelRegister("hrfsZ", function(module, exports) {

$parcel$export(module.exports, "AutomationGlyph", () => $7a6859ebc905c49b$export$3b6023946faff8bc);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");
const $7a6859ebc905c49b$export$3b6023946faff8bc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M14 5L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M14 5L7 12H17L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));

});

parcelRegister("9LkAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0eb68b9b7b7c2a06$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $23Uzi = parcelRequire("23Uzi");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $0eb68b9b7b7c2a06$export$a06f1c675e846f6f = ({ baseAutomationUrl: baseAutomationUrl })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $23Uzi.default), {
        baseAutomationUrl: baseAutomationUrl,
        onCreateAutomationFooterLinkClicked: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'link',
                action: 'clicked'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'manualRulesActionsMenu.adminFooter.createAutomation', {
                userType: 'admin'
            });
        },
        onManageAutomationsFooterLinkClicked: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'link',
                action: 'clicked'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'manualRulesActionsMenu.adminFooter.manageAutomations', {
                userType: 'admin'
            });
        },
        onAuditLogFooterLinkClicked: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'link',
                action: 'clicked'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'manualRulesActionsMenu.adminFooter.auditLog', {
                userType: 'admin'
            });
        }
    });
};
var $0eb68b9b7b7c2a06$export$2e2bcd8739ae039 = $0eb68b9b7b7c2a06$export$a06f1c675e846f6f;

});
parcelRegister("23Uzi", function(module, exports) {

$parcel$export(module.exports, "default", () => $54004c2cfe1fb1a6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $5LWLA = parcelRequire("5LWLA");

var $dZbEw = parcelRequire("dZbEw");

var $34OIV = parcelRequire("34OIV");

var $3Z96c = parcelRequire("3Z96c");
var $9UCCQ = parcelRequire("9UCCQ");

var $8M6yJ = parcelRequire("8M6yJ");

var $cVoxq = parcelRequire("cVoxq");
const $54004c2cfe1fb1a6$var$handleOptionalCallback = (optionalEvent)=>{
    if (optionalEvent) optionalEvent();
};
var $54004c2cfe1fb1a6$export$2e2bcd8739ae039 = ({ baseAutomationUrl: baseAutomationUrl, createAutomationComponentFilter: createAutomationComponentFilter, onCreateAutomationFooterLinkClicked: onCreateAutomationFooterLinkClicked, onManageAutomationsFooterLinkClicked: onManageAutomationsFooterLinkClicked, onAuditLogFooterLinkClicked: onAuditLogFooterLinkClicked })=>{
    (0, $gKZoD.di)((0, (/*@__PURE__*/$parcel$interopDefault($34OIV))), (0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), (0, $5LWLA.default), (0, $8M6yJ.MenuIcon), (0, $9UCCQ.default));
    const componentFilter = createAutomationComponentFilter ? `?componentFilterCriteria=${createAutomationComponentFilter}` : '';
    const createNewRuleUrl = `${baseAutomationUrl}#/rule/new/__NEW__TRIGGER${componentFilter}`;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9UCCQ.default), {
        hasSeparator: true,
        isList: true,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Z96c.default), {
                onClick: ()=>$54004c2cfe1fb1a6$var$handleOptionalCallback(onCreateAutomationFooterLinkClicked),
                href: createNewRuleUrl,
                testId: "create-automation-link",
                iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8M6yJ.MenuIcon), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                        label: "",
                        color: "currentColor"
                    })
                }),
                children: (0, $cVoxq.default).createAutomationItem.defaultMessage
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Z96c.default), {
                onClick: ()=>$54004c2cfe1fb1a6$var$handleOptionalCallback(onManageAutomationsFooterLinkClicked),
                href: baseAutomationUrl,
                testId: "manage-automations-link",
                iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8M6yJ.MenuIcon), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8M6yJ.ManageRulesGlyph), {})
                }),
                children: (0, $cVoxq.default).manageAutomationsItem.defaultMessage
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Z96c.default), {
                onClick: ()=>{
                    $54004c2cfe1fb1a6$var$handleOptionalCallback(onAuditLogFooterLinkClicked);
                },
                href: `${baseAutomationUrl}#tab/audit-log`,
                testId: "audit-log-link",
                iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8M6yJ.MenuIcon), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($34OIV))), {
                        label: "",
                        color: "currentColor"
                    })
                }),
                children: (0, $cVoxq.default).auditLogItem.defaultMessage
            })
        ]
    });
};

});
parcelRegister("8M6yJ", function(module, exports) {

$parcel$export(module.exports, "MenuIcon", () => $401a40ce500dda11$export$46e1d66043f363e6);
$parcel$export(module.exports, "TriggerIcon", () => $401a40ce500dda11$export$1cb264166623d4aa);
$parcel$export(module.exports, "ManualTriggerGlyph", () => $401a40ce500dda11$export$4514e29f70245d75);
$parcel$export(module.exports, "ManageRulesGlyph", () => $401a40ce500dda11$export$85ca00d4fc5d86c3);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4ldhu = parcelRequire("4ldhu");

var $ggICg = parcelRequire("ggICg");

var $dp8JX = parcelRequire("dp8JX");
const $401a40ce500dda11$export$46e1d66043f363e6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbzwfg _4t3izwfg _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $401a40ce500dda11$export$1cb264166623d4aa = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $401a40ce500dda11$export$46e1d66043f363e6, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz16rs _bfhk16iv",
            __cmplp.className
        ])
    });
});
const $401a40ce500dda11$export$4514e29f70245d75 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dp8JX))), {
        color: "currentColor",
        ...props
    });
const $401a40ce500dda11$export$85ca00d4fc5d86c3 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ggICg))), {
        label: "",
        ...props,
        color: "currentColor"
    });
const $401a40ce500dda11$export$3b6023946faff8bc = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ldhu))), {
        color: "currentColor",
        ...props
    });
const $401a40ce500dda11$export$fdd32c4638a0c3ae = (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                fill: "black",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M10.1838 4.78749C10.2664 4.61167 10.4433 4.49957 10.6375 4.5L17.0011 4.51406C17.1951 4.51449 17.3713 4.62709 17.4532 4.80294C17.5352 4.97879 17.508 5.18614 17.3835 5.33492L13.9446 9.44482H16.8597C17.0645 9.44482 17.2486 9.5697 17.3243 9.76C17.4 9.95029 17.352 10.1675 17.2032 10.3082L7.62319 19.3634C7.44433 19.5324 7.16903 19.5462 6.97421 19.3958C6.77938 19.2454 6.72297 18.9756 6.84122 18.7598L9.86254 13.2448H7C6.82891 13.2448 6.66969 13.1573 6.57795 13.0129C6.48621 12.8685 6.47469 12.6872 6.54741 12.5323L10.1838 4.78749Z",
                fill: "white"
            })
        ]
    });
const $401a40ce500dda11$export$9d08b452ddec60a4 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                fill: "white",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M10.1838 4.78749C10.2664 4.61167 10.4433 4.49957 10.6375 4.5L17.0011 4.51406C17.1951 4.51449 17.3713 4.62709 17.4532 4.80294C17.5352 4.97879 17.508 5.18614 17.3835 5.33492L13.9446 9.44482H16.8597C17.0645 9.44482 17.2486 9.5697 17.3243 9.76C17.4 9.95029 17.352 10.1675 17.2032 10.3082L7.62319 19.3634C7.44433 19.5324 7.16903 19.5462 6.97421 19.3958C6.77938 19.2454 6.72297 18.9756 6.84122 18.7598L9.86254 13.2448H7C6.82891 13.2448 6.66969 13.1573 6.57795 13.0129C6.48621 12.8685 6.47469 12.6872 6.54741 12.5323L10.1838 4.78749Z",
                fill: "black"
            })
        ]
    });

});
parcelRegister("dp8JX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8cbf4ab2d75c385e37fe01f50c4f5b5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c2463c982d0f116$var$_react = $9c2463c982d0f116$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9c2463c982d0f116$var$_baseNew = $9c2463c982d0f116$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $9c2463c982d0f116$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PresenterMode".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for presenter mode in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c2463c982d0f116$var$PresenterModeIcon = (props)=>/*#__PURE__*/ $9c2463c982d0f116$var$_react.default.createElement($9c2463c982d0f116$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.909 2.5a2.409 2.409 0 0 0-1.054 4.576l-.657 1.348a3.909 3.909 0 1 1 5.226-5.226l-1.348.657A2.41 2.41 0 0 0 4.909 2.5m-.19 2.22a.75.75 0 0 1 .786-.175l9 3.25a.75.75 0 0 1 .02 1.403l-3.822 1.505-1.505 3.822a.75.75 0 0 1-1.403-.02l-3.25-9a.75.75 0 0 1 .175-.785M6.5 6.498l2.032 5.629.896-2.277a.75.75 0 0 1 .423-.423l2.276-.896z" clip-rule="evenodd"/>`
    }, props));
$9c2463c982d0f116$var$PresenterModeIcon.displayName = 'PresenterModeIcon';
var $9c2463c982d0f116$var$_default = module.exports.default = $9c2463c982d0f116$var$PresenterModeIcon;

});


parcelRegister("cVoxq", function(module, exports) {

$parcel$export(module.exports, "default", () => $91468585851f89bb$export$2e2bcd8739ae039);
const $91468585851f89bb$var$messages = {
    manageAutomationsItem: {
        id: 'automation-platform.footer.manage-automations-item',
        defaultMessage: 'Manage automations',
        description: 'Label for the manage automations item which is a link to project automation'
    },
    createAutomationItem: {
        id: 'automation-platform.footer.create-automation-item',
        defaultMessage: 'Create automation',
        description: 'Label for the create automation item which is a link to rule creation in project automation'
    },
    auditLogItem: {
        id: 'automation-platform.footer.audit-log-item',
        defaultMessage: 'Audit log',
        description: 'Label for the audit log item which is a link to audit log in project automation'
    }
};
var $91468585851f89bb$export$2e2bcd8739ae039 = $91468585851f89bb$var$messages;

});



parcelRegister("bN8dM", function(module, exports) {

$parcel$export(module.exports, "RecurringIssueLinkItem", () => $1d9d15f8a8ec3203$export$f6bb1dd97cb7c68b);

var $5uXOq = parcelRequire("5uXOq");

var $8w53e = parcelRequire("8w53e");

var $aYAc3 = parcelRequire("aYAc3");

var $3Z96c = parcelRequire("3Z96c");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $fNobW = parcelRequire("fNobW");

var $dTlW6 = parcelRequire("dTlW6");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $8M6yJ = parcelRequire("8M6yJ");

var $2vSU6 = parcelRequire("2vSU6");

var $7CMCs = parcelRequire("7CMCs");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $l8ruj = parcelRequire("l8ruj");

var $93Yeu = parcelRequire("93Yeu");


var $4cWde = parcelRequire("4cWde");

var $kkND3 = parcelRequire("kkND3");

var $ixEpM = parcelRequire("ixEpM");

var $n4BWF = parcelRequire("n4BWF");
const $1d9d15f8a8ec3203$var$flagId = (0, $7HGHK.toFlagId)('jira-recurring-work-toggle-success-flag');
const $1d9d15f8a8ec3203$var$RecurringIssueLinkItem = ({ issueKey: issueKey })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const ruleIdRef = (0, $5uXOq.useRef)(null);
    const [isChecked, setIsChecked] = (0, $5uXOq.useState)(false);
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const hasMountedRef = (0, $5uXOq.useRef)(false);
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectId = (0, $93Yeu.useProjectId)(projectKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const isSimplified = (0, $93Yeu.useIsSimplifiedProject)(projectKey);
    const productKey = projectType && (0, $2vSU6.projectTypeToCanonicalId)(projectType)?.replace('jira-', '');
    if (!projectId) throw new Error('Could not retrieve projectId');
    // We need to memoize `analyticsEvent` otherwise it triggers the `useEffect` hooks below on mount
    const { analyticsEvent: analyticsEvent, analyticsAttributes: analyticsAttributes } = (0, $5uXOq.useMemo)(()=>{
        return {
            analyticsEvent: createAnalyticsEvent({}),
            analyticsAttributes: {
                issueKey: issueKey
            }
        };
    }, [
        createAnalyticsEvent,
        issueKey
    ]);
    const { data: existingRuleData, loading: isFetchingRuleConfig } = (0, $4cWde.useFetchRule)(issueKey, projectId);
    const { loading: isCreateInProgress, fetch: sendSetAsRecurringRequest } = (0, $ixEpM.useSetRecurringIssue)(issueKey, projectId);
    const { loading: isDeleteInProgress, fetch: sendSetAsNonRecurringRequest } = (0, $kkND3.useSetNonRecurringIssue)(issueKey, projectId);
    const onToggleChange = ()=>{
        setIsChecked(!isChecked);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'recurringIssue toggled', {
            ...analyticsAttributes,
            actionTaken: isChecked ? 'disabled' : 'enabled',
            action: isChecked ? 'disabled' : 'enabled'
        });
    };
    const onClickSuccessFlagAction = (0, $5uXOq.useCallback)(()=>{
        dismissFlag($1d9d15f8a8ec3203$var$flagId);
        let automationRuleURL;
        if (projectType === (0, $2vSU6.SOFTWARE_PROJECT)) automationRuleURL = `/jira/${productKey}/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/automate#/rule/${ruleIdRef.current}`;
        else automationRuleURL = `/jira/${productKey}/projects/${projectKey}/settings/automation#/rule/${ruleIdRef.current}`;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(automationRuleURL, '_blank');
    }, [
        dismissFlag,
        isSimplified,
        productKey,
        projectKey,
        projectType
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isFetchingRuleConfig && existingRuleData !== undefined && !hasMountedRef.current) {
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'recurringIssueMenuItem viewed', analyticsAttributes);
            hasMountedRef.current = true;
        }
    }, [
        analyticsAttributes,
        analyticsEvent,
        existingRuleData,
        isFetchingRuleConfig
    ]);
    // Create recurring rule when toggle is enabled
    (0, $5uXOq.useEffect)(()=>{
        if (isCreateInProgress) return;
        const createTemplateFn = async ()=>{
            const response = await sendSetAsRecurringRequest();
            ruleIdRef.current = response?.ruleId ?? null;
            if (response === undefined) {
                setIsChecked(false);
                return;
            }
            showFlag({
                messageId: 'recurring-issue-action.ui.show-flag.success',
                messageType: 'transactional',
                id: $1d9d15f8a8ec3203$var$flagId,
                type: 'success',
                title: formatMessage((0, $n4BWF.default).successFlagTitle, {
                    issueKey: issueKey
                }),
                description: (0, $n4BWF.default).successFlagContent,
                actions: [
                    {
                        content: (0, $n4BWF.default).successFlagAction,
                        onClick: onClickSuccessFlagAction
                    }
                ]
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'recurringRule created', {
                ...analyticsAttributes,
                ruleId: ruleIdRef.current
            });
        };
        if (!ruleIdRef.current && isChecked) createTemplateFn();
    }, [
        analyticsAttributes,
        analyticsEvent,
        formatMessage,
        isChecked,
        isCreateInProgress,
        issueKey,
        onClickSuccessFlagAction,
        sendSetAsRecurringRequest,
        showFlag
    ]);
    // Delete recurring rule when toggle is disabled
    (0, $5uXOq.useEffect)(()=>{
        if (isDeleteInProgress) return;
        const deleteTemplateFn = async ()=>{
            if (typeof ruleIdRef.current !== 'number' && typeof ruleIdRef.current !== 'string') return;
            const response = await sendSetAsNonRecurringRequest({
                ruleId: ruleIdRef.current
            });
            if (response === undefined) {
                setIsChecked(true);
                return;
            }
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'recurringRule deleted', {
                ...analyticsAttributes,
                ruleId: ruleIdRef.current
            });
            ruleIdRef.current = null;
        };
        // We need this condition to avoid unnecessary calls when the hook runs
        if (ruleIdRef.current && !isChecked) deleteTemplateFn();
    }, [
        analyticsAttributes,
        analyticsEvent,
        isChecked,
        isDeleteInProgress,
        sendSetAsNonRecurringRequest
    ]);
    // Setting initial toggle state based on first fetch
    (0, $5uXOq.useEffect)(()=>{
        ruleIdRef.current = existingRuleData?.ruleId || null;
        const ruleState = existingRuleData?.ruleState || null;
        const hasExistingRule = !isFetchingRuleConfig && !!ruleIdRef.current;
        const isToggleChecked = ruleState !== (0, $293e667ed8adc5c0$export$8cd212c10b4124d2) && hasExistingRule;
        setIsChecked(isToggleChecked);
    }, [
        existingRuleData?.ruleId,
        existingRuleData?.ruleState,
        isFetchingRuleConfig
    ]);
    const getTooltipContent = (ruleState)=>{
        switch(ruleState){
            case 0, $293e667ed8adc5c0$export$8cd212c10b4124d2:
                return formatMessage((0, $n4BWF.default).ruleDisabledTooltip);
            case 0, $293e667ed8adc5c0$export$26f14159616d40a7:
                return formatMessage((0, $n4BWF.default).missingDeletePermissionTooltip);
            case 0, $293e667ed8adc5c0$export$e927a5d1b72f0b68:
            default:
                return '';
        }
    };
    const ruleState = existingRuleData?.ruleState || null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        testId: "recurring-issue-action.ui.set-recurring",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8M6yJ.MenuIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8w53e))), {
            label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $n4BWF.default).menuItemTextIssueTermRefresh : (0, $n4BWF.default).menuItemText)
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        as: "span",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        alignBlock: "center",
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        htmlFor: "recurring-issue-menu-item-label"
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $n4BWF.default).menuItemTextIssueTermRefresh : (0, $n4BWF.default).menuItemText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: "new"
    }, formatMessage((0, $n4BWF.default).newLozenge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "fetch-recurring-issue-rule-config-loading",
        hold: isFetchingRuleConfig
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: getTooltipContent(ruleState)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTlW6.default), {
        id: "recurring-issue-menu-item-label",
        isChecked: isChecked,
        isDisabled: ruleState === (0, $293e667ed8adc5c0$export$8cd212c10b4124d2) || ruleState === (0, $293e667ed8adc5c0$export$26f14159616d40a7) || isFetchingRuleConfig || isCreateInProgress || isDeleteInProgress,
        onChange: onToggleChange
    })))));
};
const $1d9d15f8a8ec3203$export$f6bb1dd97cb7c68b = ({ issueKey: issueKey })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "recurring-issue-link-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "recurring-issue-link-item-wrapper",
        packageName: (0, $293e667ed8adc5c0$export$b8b9d90f9e5bd72b),
        teamName: (0, $293e667ed8adc5c0$export$d57b6b390e78d90f),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1d9d15f8a8ec3203$var$RecurringIssueLinkItem, {
        issueKey: issueKey
    })));
};

});
parcelRegister("dTlW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3db77843cf29c460$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $eJbwP = parcelRequire("eJbwP");

var $2jwCH = parcelRequire("2jwCH");

var $VSDnB = parcelRequire("VSDnB");

var $lahQ6 = parcelRequire("lahQ6");
const $3db77843cf29c460$var$basicStyles = null;
const $3db77843cf29c460$var$borderStyles = null;
const $3db77843cf29c460$var$iconStyles = null;
const $3db77843cf29c460$var$sizeStyles = {
    regular: "_2rkopxbi _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rkov47k _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
const $3db77843cf29c460$var$noop = (0, $eGmKJ.default);
const $3db77843cf29c460$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $3db77843cf29c460$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
}; /**
    * __Toggle__
    *
    * A toggle is used to view or switch between enabled or disabled states.
    *
    * - [Examples](https://atlassian.design/components/toggle/examples)
    * - [Code](https://atlassian.design/components/toggle/code)
    * - [Usage](https://atlassian.design/components/toggle/usage)
    */ 
const $3db77843cf29c460$var$Toggle = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $3db77843cf29c460$var$noop, onChange: providedChange = $3db77843cf29c460$var$noop, onFocus: providedFocus = $3db77843cf29c460$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $5uXOq.useState)(defaultChecked);
    const [isKeyboardUsed, setIsKeyboardUsed] = (0, $5uXOq.useState)(true);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (id && wrapperRef.current && wrapperRef.current.parentElement) {
            /*
      	DSP-21524 Handling the click on <label> that is linked via "for" attribute.
      	By default click on the label fires absolutely same onclick event as click on the input element.
      	To differentiate keyboard click from mouse we need this additional listener.
      */ const linkedLabel = wrapperRef.current.parentElement.querySelector(`label[for="${id}"]`);
            if (linkedLabel) {
                const unbind = (0, $cBeZP.bindAll)(linkedLabel, [
                    {
                        type: 'click',
                        listener: (event)=>{
                            setIsKeyboardUsed(false);
                            if (event?.detail > 1) /*
              DSP-21524 double or triple click on label initiating the text selection for label text and adds additional step to tab order.
              So here we set the isKeyboardUsed to true, to display focus ring on next Tab press
              */ setIsKeyboardUsed(true);
                        }
                    }
                ]);
                return unbind;
            }
        }
    }, [
        id,
        wrapperRef,
        isKeyboardUsed
    ]);
    const handleBlur = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isKeyboardUsed) setIsKeyboardUsed(true);
            providedOnBlur(event, analyticsEvent);
        },
        action: 'blur',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleFocus = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleChange = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const onLabelKeyDown = (event)=>{
        if ([
            ' ',
            'Tab',
            'Space'
        ].includes(event.key)) setIsKeyboardUsed(true);
    };
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined,
        // DSP-21524 Because label gets focus ring via focus-within and focus-within also triggers by mouse click we have to manually control the ring appearance.
        onKeyDown: onLabelKeyDown,
        onMouseDown: ()=>{
            setIsKeyboardUsed(false);
        }
    };
    const legacyIconSize = $3db77843cf29c460$var$iconSizeMap[size];
    const labelId = (0, $9KnKW.useId)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        ...controlProps,
        ref: wrapperRef,
        className: (0, $bwpsq.default)([
            "_v564kete _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1o8l _vchh18uv _kqswh2mm _1y1m1ntv _bfhk76s1 _syaz5w2r _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31q5u _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1bki1y1w _1flt1y1w _3xv21y1w _9471g4a2 _ucab5w2r _mqf815t7 _3dj215t7 _1dl915t7 _1div5w2r _1il8kb7n _y54d5w2r _irr353wy _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1plud4ly _1uo853wy _178c1y1w _16rslghj _ogf41r31 _1rtbnqa1 _5gg9t94y",
            isKeyboardUsed && "_jyzf194a _1r4mnqa1 _1t9pyh40",
            size === 'large' && !(0, $VSDnB.fg)('platform-visual-refresh-icons') && "_1n82gktf _19vpgktf",
            $3db77843cf29c460$var$sizeStyles[size]
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: labelId,
                hidden: true,
                children: label
            }) : null,
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": label ? labelId : undefined,
                "aria-describedby": descriptionId
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lahQ6.default), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJbwP))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-check-icon`,
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lahQ6.default), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2jwCH))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-cross-icon`,
                    size: "small"
                })
            })
        ]
    });
}));
$3db77843cf29c460$var$Toggle.displayName = 'Toggle';
var $3db77843cf29c460$export$2e2bcd8739ae039 = $3db77843cf29c460$var$Toggle;

});
parcelRegister("eJbwP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::666ec8073f4584891951ab85e48975eb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab8e35fd94105dfe$var$_react = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ab8e35fd94105dfe$var$_checkMark = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("bjo8S")));

var $ab8e35fd94105dfe$var$_done = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("4DXCl")));
function $ab8e35fd94105dfe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab8e35fd94105dfe$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ab8e35fd94105dfe$var$_react.default.createElement($ab8e35fd94105dfe$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ab8e35fd94105dfe$var$_done.default
    }, props));
$ab8e35fd94105dfe$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ab8e35fd94105dfe$var$_default = module.exports.default = $ab8e35fd94105dfe$var$CheckMarkIcon;

});
parcelRegister("4DXCl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36190cbd288fec69$var$_react = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $36190cbd288fec69$var$_checkMark = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $36190cbd288fec69$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $36190cbd288fec69$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $36190cbd288fec69$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $36190cbd288fec69$var$_checkMark.default
    }));
$36190cbd288fec69$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $36190cbd288fec69$var$_default = module.exports.default = $36190cbd288fec69$var$EditorDoneIcon;

});


parcelRegister("lahQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca1cdaa1eb34599d$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
const $ca1cdaa1eb34599d$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $ca1cdaa1eb34599d$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: (0, $3JT92.cx)($ca1cdaa1eb34599d$var$styles.iconContainer, isHidden && (0, $VSDnB.fg)('platform-visual-refresh-icons') && $ca1cdaa1eb34599d$var$styles.hidden, size === 'regular' && $ca1cdaa1eb34599d$var$styles.iconContainerRegular, size === 'large' && $ca1cdaa1eb34599d$var$styles.iconContainerLarge, position === 'left' && $ca1cdaa1eb34599d$var$styles.left, position === 'right' && $ca1cdaa1eb34599d$var$styles.right),
        children: children
    });
};
var $ca1cdaa1eb34599d$export$2e2bcd8739ae039 = $ca1cdaa1eb34599d$var$IconContainer;

});


const $293e667ed8adc5c0$export$b8b9d90f9e5bd72b = 'jiraRecurringIssueAction';
const $293e667ed8adc5c0$export$d57b6b390e78d90f = 'a4t-pandora';
const $293e667ed8adc5c0$export$5544de0a15ad27ca = 'has_seen_recurring_work_popup_pulse';
const $293e667ed8adc5c0$export$8cd212c10b4124d2 = 'DISABLED';
const $293e667ed8adc5c0$export$e927a5d1b72f0b68 = 'ENABLED';
const $293e667ed8adc5c0$export$26f14159616d40a7 = 'MISSING_PERMS';

parcelRegister("4cWde", function(module, exports) {

$parcel$export(module.exports, "useFetchRule", () => $d00414541a84d8e6$export$880460242bdb832e);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $jJZqs = parcelRequire("jJZqs");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");


var $gtH2u = parcelRequire("gtH2u");

var $1KosL = parcelRequire("1KosL");
const $d00414541a84d8e6$export$880460242bdb832e = (issueKey, projectId)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const environment = (0, $2tT7R.useEnvironment)();
    const withAnalytics = (0, $1KosL.useWithAnalytics)();
    const hasFetched = (0, $5uXOq.useRef)(false);
    const fetchRule = (0, $5uXOq.useCallback)(async ()=>{
        // Fetch whether a rule is configured for this issue
        const ruleConfig = await withAnalytics((0, $gtH2u.fetchRuleConfig)(issueKey), 'fetchRuleConfig');
        const ruleId = ruleConfig.value?.automationRuleId;
        const token = ruleConfig?.value && ruleConfig?.value.token;
        if (!ruleId) return Promise.resolve({
            ruleId: ruleId,
            token: token,
            ruleState: null
        });
        // If there's a rule configured for this issue, fetch the rule data
        try {
            const ruleData = await withAnalytics((0, $gtH2u.fetchRuleData)(environment, cloudId, projectId, ruleId), 'fetchRuleData');
            return {
                ruleId: ruleId,
                token: token,
                ruleState: ruleData?.state || null
            };
        } catch (error) {
            if (error instanceof (0, $jJZqs.default)) {
                // Rule exists but user doesn't have permission to update rule
                if (error.statusCode === 403) return Promise.resolve({
                    ruleId: ruleId,
                    token: token,
                    ruleState: (0, $293e667ed8adc5c0$export$26f14159616d40a7)
                });
                // Edge case where rule was deleted just before we fetch rule data
                if (error.statusCode === 404) return Promise.resolve({
                    ruleId: null,
                    token: null,
                    ruleState: null
                });
            }
            throw error;
        }
    }, [
        cloudId,
        environment,
        issueKey,
        projectId,
        withAnalytics
    ]);
    const { data: data, error: error, loading: loading, fetch: fetch } = (0, $ld2hZ.useService)(fetchRule);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasFetched.current) {
            fetch();
            hasFetched.current = true;
        }
    }, [
        fetch
    ]);
    return {
        data: data,
        error: error,
        loading: loading
    };
};

});
parcelRegister("gtH2u", function(module, exports) {

$parcel$export(module.exports, "fetchRuleConfig", () => $47c64632a262dacb$export$855c6b1cb98ab9b1);
$parcel$export(module.exports, "fetchRuleData", () => $47c64632a262dacb$export$f4e9dc16fd35a2a1);

var $c5wox = parcelRequire("c5wox");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $47c64632a262dacb$export$855c6b1cb98ab9b1 = async (issueKey)=>{
    const ruleConfigEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    try {
        return await (0, $eusud.performGetRequest)(ruleConfigEndpoint);
    } catch (error) {
        if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) return Promise.resolve({
            value: {
                automationRuleId: null,
                token: null
            }
        });
        throw error;
    }
};
const $47c64632a262dacb$export$f4e9dc16fd35a2a1 = async (environment, cloudId, projectId, ruleId)=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const ruleDataEndpoint = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleId}`;
    return (0, $eusud.performGetRequest)(ruleDataEndpoint);
};

});

parcelRegister("1KosL", function(module, exports) {

$parcel$export(module.exports, "useWithAnalytics", () => $4692130e7034e260$export$425c0fc4e690f4eb);

var $5uXOq = parcelRequire("5uXOq");

var $jJZqs = parcelRequire("jJZqs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $4692130e7034e260$var$getErrorAttributes = (error)=>{
    if (error instanceof Error) return {
        errorMessage: error.message,
        ...error instanceof (0, $jJZqs.default) && {
            statusCode: error.statusCode
        }
    };
    return {};
};
const $4692130e7034e260$export$425c0fc4e690f4eb = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)(async (requestPromise, requestName)=>{
        const analyticsEvent = createAnalyticsEvent({});
        try {
            const response = await requestPromise;
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${requestName} succeeded`);
            return response;
        } catch (err) {
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${requestName} failed`, $4692130e7034e260$var$getErrorAttributes(err));
            throw err;
        }
    }, [
        createAnalyticsEvent
    ]);
};

});


parcelRegister("kkND3", function(module, exports) {

$parcel$export(module.exports, "useSetNonRecurringIssue", () => $42a893e20dfddd6c$export$6b5521d15132bf28);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $hogU4 = parcelRequire("hogU4");

var $1KosL = parcelRequire("1KosL");
const $42a893e20dfddd6c$export$6b5521d15132bf28 = (issueKey, projectId)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const environment = (0, $2tT7R.useEnvironment)();
    const withAnalytics = (0, $1KosL.useWithAnalytics)();
    const setAsNonRecurringIssue = (0, $5uXOq.useCallback)(async ({ ruleId: ruleId })=>{
        const deleteTemplatePromise = withAnalytics((0, $hogU4.deleteTemplate)({
            environment: environment,
            cloudId: cloudId,
            projectId: projectId,
            ruleId: ruleId
        }), 'deleteTemplate');
        const removeIssueConfigPromise = withAnalytics((0, $hogU4.removeRuleConfig)({
            issueKey: issueKey
        }), 'removeRuleConfig');
        return Promise.all([
            deleteTemplatePromise,
            removeIssueConfigPromise
        ]);
    }, [
        cloudId,
        environment,
        issueKey,
        projectId,
        withAnalytics
    ]);
    return (0, $ld2hZ.useService)(setAsNonRecurringIssue);
};

});
parcelRegister("hogU4", function(module, exports) {

$parcel$export(module.exports, "deleteTemplate", () => $d88c579e6607dd85$export$eaca1c6e4717fe30);
$parcel$export(module.exports, "removeRuleConfig", () => $d88c579e6607dd85$export$1ca0c38b3ea286c);

var $c5wox = parcelRequire("c5wox");

var $eusud = parcelRequire("eusud");
const $d88c579e6607dd85$export$eaca1c6e4717fe30 = async ({ environment: environment, cloudId: cloudId, projectId: projectId, ruleId: ruleId })=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const DELETE_TEMPLATE_URL = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleId}`;
    return (0, $eusud.performDeleteRequest)(DELETE_TEMPLATE_URL);
};
const $d88c579e6607dd85$export$1ca0c38b3ea286c = async ({ issueKey: issueKey })=>{
    const ruleConfigEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    return (0, $eusud.performDeleteRequest)(ruleConfigEndpoint);
};

});


parcelRegister("ixEpM", function(module, exports) {

$parcel$export(module.exports, "useSetRecurringIssue", () => $a612b128af80cfc6$export$50f09d1757f3a27e);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $ld2hZ = parcelRequire("ld2hZ");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $9qaqT = parcelRequire("9qaqT");

var $1KosL = parcelRequire("1KosL");
const $a612b128af80cfc6$export$50f09d1757f3a27e = (issueKey, projectId)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const environment = (0, $2tT7R.useEnvironment)();
    const withAnalytics = (0, $1KosL.useWithAnalytics)();
    const setAsRecurringIssue = (0, $5uXOq.useCallback)(async ()=>{
        const recurrenceToken = (0, $7Jxgt.v4)();
        const createTemplateResponse = await withAnalytics((0, $9qaqT.createTemplate)({
            environment: environment,
            cloudId: cloudId,
            projectId: projectId,
            recurrenceToken: recurrenceToken
        }), 'createTemplate');
        const response = await withAnalytics((0, $9qaqT.setRuleConfig)({
            issueKey: issueKey,
            recurrenceToken: recurrenceToken,
            ruleId: createTemplateResponse.ruleId
        }), 'setRuleConfig');
        return {
            ...createTemplateResponse,
            ...response
        };
    }, [
        cloudId,
        environment,
        issueKey,
        projectId,
        withAnalytics
    ]);
    return (0, $ld2hZ.useService)(setAsRecurringIssue);
};

});
parcelRegister("9qaqT", function(module, exports) {

$parcel$export(module.exports, "createTemplate", () => $fadfd3926bb1a6b2$export$7b7ae612b60e1630);
$parcel$export(module.exports, "setRuleConfig", () => $fadfd3926bb1a6b2$export$b995d9091813d57d);

var $kV9ss = parcelRequire("kV9ss");

var $c5wox = parcelRequire("c5wox");

var $eusud = parcelRequire("eusud");
const $fadfd3926bb1a6b2$export$7b7ae612b60e1630 = async ({ environment: environment, cloudId: cloudId, projectId: projectId, recurrenceToken: recurrenceToken })=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const CREATE_TEMPLATE_URL = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/public/rest/v1/template/create`;
    const ruleHomeARI = (0, $kV9ss.JiraProjectAri).create({
        siteId: cloudId,
        projectId: String(projectId)
    });
    const payload = {
        ruleHome: ruleHomeARI,
        templateId: 'software_end_user_template_1',
        parameters: {
            recurrenceToken: {
                value: recurrenceToken,
                type: 'TEXT'
            }
        }
    };
    return (0, $eusud.performPostRequest)(CREATE_TEMPLATE_URL, {
        body: JSON.stringify(payload)
    });
};
const $fadfd3926bb1a6b2$export$b995d9091813d57d = async ({ issueKey: issueKey, ruleId: ruleId, recurrenceToken: recurrenceToken })=>{
    const ruleConfigEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    return (0, $eusud.performPutRequest)(ruleConfigEndpoint, {
        body: JSON.stringify({
            automationRuleId: ruleId,
            token: recurrenceToken
        })
    });
};

});


parcelRegister("n4BWF", function(module, exports) {

$parcel$export(module.exports, "default", () => $02dc11c256e529d3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $02dc11c256e529d3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    menuItemText: {
        "id": "set-recurring-issue-action-menu-item-title",
        "defaultMessage": "Clone when issue is done"
    },
    menuItemTextIssueTermRefresh: {
        "id": "set-recurring-issue-action-menu-item-title-issue-term-refresh",
        "defaultMessage": "Clone when work item is done"
    },
    newLozenge: {
        "id": "set-recurring-issue-action-menu-item-new-lozenge",
        "defaultMessage": "New"
    },
    ruleDisabledTooltip: {
        "id": "recurring-issue-action.rule-disabled-tooltip",
        "defaultMessage": "Contact your admin to turn on rule."
    },
    missingDeletePermissionTooltip: {
        "id": "recurring-issue-action.missing-delete-permission-tooltip",
        "defaultMessage": "Contact your admin to edit this rule."
    },
    successFlagTitle: {
        "id": "set-recurring-issue-action-menu-item-success-flag-title",
        "defaultMessage": "{issueKey} will clone when moved to any done status."
    },
    successFlagContent: {
        "id": "set-recurring-issue-action-menu-item-success-flag-content",
        "defaultMessage": "Attachments, start date and due date will not be included."
    },
    successFlagAction: {
        "id": "set-recurring-issue-action-menu-item-success-flag-action",
        "defaultMessage": "View rule"
    }
});

});


parcelRegister("jTAKY", function(module, exports) {

$parcel$export(module.exports, "asyncRecurWorkFormEntryPoint", () => $560e2f62c0e04f01$export$a3770cd78631a062);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $560e2f62c0e04f01$export$a3770cd78631a062 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("lRqFb")).then(({ RecurWorkForm: RecurWorkForm })=>RecurWorkForm), {
        moduleId: "5cac0ce7",
        moduleName: "RecurWorkForm",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lRqFb", function(module, exports) {

let $fea33af4d693b891$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fea33af4d693b891$var$load("7f1Go").then(()=>parcelRequire('7u01W'));

});


parcelRegister("1eyaH", function(module, exports) {

$parcel$export(module.exports, "RecurWorkItemContainer", () => $299cd71373520f02$export$32458a51e0870d6c);
$parcel$export(module.exports, "useRecurWorkItemState", () => $299cd71373520f02$export$5730c874dfb9803f);
$parcel$export(module.exports, "useRecurWorkItemActions", () => $299cd71373520f02$export$eb9ad4e1e739768e);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $93Yeu = parcelRequire("93Yeu");

var $cYlk7 = parcelRequire("cYlk7");

var $2YZCu = parcelRequire("2YZCu");

var $hVn1P = parcelRequire("hVn1P");

var $lQupu = parcelRequire("lQupu");
const $299cd71373520f02$var$RecurWorkItemStoreContainer = (0, $gg7kZ.createContainer)();
const $299cd71373520f02$export$32458a51e0870d6c = ({ children: children, issueKey: issueKey })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const environment = (0, $2tT7R.useEnvironment)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectId = (0, $93Yeu.useProjectId)(projectKey);
    const { data: currentUser } = (0, $cYlk7.useCurrentUser)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    if (!projectId) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jira-recur-work-item.src.controllers.RecurWorkItemContainer', 'Error initialising RecurWorkItemContainer, could not retrieve projectId');
        return children;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($299cd71373520f02$var$RecurWorkItemStoreContainer, {
        scope: `recur-${issueKey}`,
        issueKey: issueKey,
        environment: environment,
        cloudId: cloudId,
        currentUserAccountId: currentUser.user.accountId,
        projectId: projectId,
        createAnalyticsEvent: createAnalyticsEvent
    }, children);
};
const $299cd71373520f02$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'RecurWorkItemStore',
    initialState: (0, $lQupu.INITIAL_STATE),
    actions: $hVn1P.actions,
    containedBy: $299cd71373520f02$var$RecurWorkItemStoreContainer,
    handlers: {
        onInit: ()=>async ({ dispatch: dispatch })=>{
                await dispatch((0, $hVn1P.actions).fetch());
            }
    }
});
const $299cd71373520f02$export$6630e454597fb59c = (0, $3sQ5x.createHook)($299cd71373520f02$export$390f32400eaf98c9);
const $299cd71373520f02$export$5730c874dfb9803f = (0, $3sQ5x.createStateHook)($299cd71373520f02$export$390f32400eaf98c9);
const $299cd71373520f02$export$eb9ad4e1e739768e = (0, $3sQ5x.createActionsHook)($299cd71373520f02$export$390f32400eaf98c9);

});
parcelRegister("cYlk7", function(module, exports) {

$parcel$export(module.exports, "useCurrentUser", () => $cdd4ab536fcf9459$export$3901076af3749fa9);

var $5uXOq = parcelRequire("5uXOq");

var $lzeFL = parcelRequire("lzeFL");

var $9OXo1 = parcelRequire("9OXo1");

var $leRCk = parcelRequire("leRCk");
const $cdd4ab536fcf9459$var$useCurrentUserBasic = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return (0, $5uXOq.useMemo)(()=>({
            data: {
                user: {
                    accountId: tenantContext.atlassianAccountId,
                    isAdmin: tenantContext.isAdmin,
                    isAnonymous: tenantContext.isAnonymous,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    locale: tenantContext.locale || (0, $lzeFL.defaultLocale),
                    siteAdminStatus: tenantContext.siteAdminStatus,
                    userFullname: tenantContext.userFullname || ''
                }
            },
            loading: false,
            error: null
        }), [
        tenantContext.atlassianAccountId,
        tenantContext.isAdmin,
        tenantContext.isAnonymous,
        tenantContext.isSiteAdmin,
        tenantContext.locale,
        tenantContext.siteAdminStatus,
        tenantContext.userFullname
    ]);
};
const $cdd4ab536fcf9459$var$useCurrentUserFull = ()=>{
    const { data: dataBasic } = $cdd4ab536fcf9459$var$useCurrentUserBasic();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, $leRCk.useUserSubscriber)();
    (0, $5uXOq.useEffect)(()=>{
        tenantContext.atlassianAccountId && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fetch({
            params: {
                accountId: tenantContext.atlassianAccountId
            }
        }, false);
    }, [
        fetch,
        tenantContext.atlassianAccountId
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: {
                ...dataBasic,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                user: {
                    ...dataBasic.user,
                    ...data
                }
            },
            loading: loading,
            error: error
        }), [
        data,
        dataBasic,
        error,
        loading
    ]);
};
const $cdd4ab536fcf9459$export$3901076af3749fa9 = ()=>(0, $9OXo1.useTenantContext)().isAnonymous ? $cdd4ab536fcf9459$var$useCurrentUserBasic() : $cdd4ab536fcf9459$var$useCurrentUserFull(); // eslint-disable-line react-hooks/rules-of-hooks
const $cdd4ab536fcf9459$export$6414ebbbfff99d4c = ({ children: children })=>{
    const result = $cdd4ab536fcf9459$export$3901076af3749fa9();
    return children(result);
};

});

parcelRegister("hVn1P", function(module, exports) {

$parcel$export(module.exports, "actions", () => $a7f343d49f172fdb$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7Sl82 = parcelRequire("7Sl82");

var $l9xxv = parcelRequire("l9xxv");

var $bvhsR = parcelRequire("bvhsR");

var $c8g0F = parcelRequire("c8g0F");
const $a7f343d49f172fdb$export$5153917efea4a83d = (issueProperties)=>({ setState: setState })=>{
        setState({
            issueProperties: issueProperties
        });
    };
const $a7f343d49f172fdb$export$e324594224ef24da = {
    fetch: $7Sl82.fetch,
    setIssueProperties: $a7f343d49f172fdb$export$5153917efea4a83d,
    setAsNonRecurringIssue: $l9xxv.setAsNonRecurringIssue,
    setAsRecurringIssue: $bvhsR.setAsRecurringIssue,
    updateRule: $c8g0F.updateRule
};

});
parcelRegister("7Sl82", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $88fd35b220315252$export$e7aa7bc5c1b3cfb3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4R6GH = parcelRequire("4R6GH");

var $m8SHd = parcelRequire("m8SHd");

var $ahBjy = parcelRequire("ahBjy");

var $fAJ3G = parcelRequire("fAJ3G");

var $519t2 = parcelRequire("519t2");

var $cpjnU = parcelRequire("cpjnU");
const $88fd35b220315252$export$e7aa7bc5c1b3cfb3 = ()=>async ({ setState: setState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId, currentUserAccountId: currentUserAccountId })=>{
        setState({
            isFetching: true,
            errors: null
        });
        try {
            // First fetch issue-properties
            const { value: issueProperties } = await (0, $519t2.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $m8SHd.fetchIssueProperties)(issueKey), 'fetchIssueProperties');
            let ruleSummary;
            // Only fetch rule summary if a rule exists in issue-properties and not a grandfathered recur-on-complete rule
            if (issueProperties?.automationRuleUuid) {
                ruleSummary = await (0, $519t2.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $m8SHd.fetchRuleSummary)(environment, cloudId, projectId, issueProperties.automationRuleUuid), 'fetchRuleSummary');
                // If rule doesn't exist or is disabled, delete issue-properties
                if (!ruleSummary || ruleSummary?.ruleState === (0, $ahBjy.RuleState).DISABLED) {
                    await (0, $519t2.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $fAJ3G.deleteIssueProperties)({
                        issueKey: issueKey
                    }), 'deleteIssueProperties');
                    setState({
                        isFetching: false,
                        hasFetched: true,
                        issueProperties: null
                    });
                    return;
                }
            }
            let isRuleOwner;
            if ((0, $cpjnU.isRecurOnCompleteToggleRule)(issueProperties)) isRuleOwner = true;
            else if (ruleSummary) isRuleOwner = ruleSummary.authorAccountId === currentUserAccountId;
            else isRuleOwner = null;
            setState({
                isFetching: false,
                hasFetched: true,
                issueProperties: issueProperties,
                isRuleOwner: isRuleOwner,
                ...(0, $4R6GH.fg)('jira-recur-single-work-item-on-sched-due-date-gate') && {
                    hasBootstrapError: false
                }
            });
        } catch (error) {
            setState({
                isFetching: false,
                hasFetched: true,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    error
                ],
                hasBootstrapError: true
            });
        }
    };

});
parcelRegister("m8SHd", function(module, exports) {

$parcel$export(module.exports, "fetchIssueProperties", () => $85e12c64cfd21e7a$export$efa35964e975bd30);
$parcel$export(module.exports, "fetchRuleSummary", () => $85e12c64cfd21e7a$export$3cada9835f092161);

var $c5wox = parcelRequire("c5wox");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $85e12c64cfd21e7a$export$efa35964e975bd30 = async (issueKey)=>{
    const recurrenceConfigEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    try {
        return await (0, $eusud.performGetRequest)(recurrenceConfigEndpoint);
    } catch (error) {
        if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) return Promise.resolve({
            value: null
        });
        throw error;
    }
};
const $85e12c64cfd21e7a$export$3cada9835f092161 = async (environment, cloudId, projectId, ruleUuid)=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const summaryEndpoint = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}/summary`;
    try {
        return await (0, $eusud.performGetRequest)(summaryEndpoint);
    } catch (error) {
        if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) return null;
        throw error;
    }
};

});

parcelRegister("ahBjy", function(module, exports) {

$parcel$export(module.exports, "RuleState", () => $50cbc517c5c98dcf$export$c22ef3527b5f5563);
$parcel$export(module.exports, "CONDITION", () => $50cbc517c5c98dcf$export$1cfe08df32bc8f76);
$parcel$export(module.exports, "FORM_TITLE_ID", () => $50cbc517c5c98dcf$export$66f4c6e4b9206abf);
$parcel$export(module.exports, "SOFTWARE_END_USER_TEMPLATE_2", () => $50cbc517c5c98dcf$export$c07ca23c166d6344);
const $50cbc517c5c98dcf$export$c22ef3527b5f5563 = {
    DISABLED: 'DISABLED',
    ENABLED: 'ENABLED',
    MISSING_PERMS: 'MISSING_PERMS'
};
const $50cbc517c5c98dcf$export$1cfe08df32bc8f76 = {
    SCHEDULE: 'SCHEDULE',
    SCHEDULE_IF_COMPLETE: 'SCHEDULE_IF_COMPLETE'
};
const $50cbc517c5c98dcf$export$f7109619a5e9e0d6 = 'recurWorkItemForm';
const $50cbc517c5c98dcf$export$66f4c6e4b9206abf = 'recur-work-item-form-title';
const $50cbc517c5c98dcf$export$c07ca23c166d6344 = 'software_end_user_template_2';

});

parcelRegister("fAJ3G", function(module, exports) {

$parcel$export(module.exports, "deleteRule", () => $dcc2b085f6f8ace7$export$988cba38e738f27d);
$parcel$export(module.exports, "deleteIssueProperties", () => $dcc2b085f6f8ace7$export$3906c12f20991cd1);
$parcel$export(module.exports, "disableRule", () => $dcc2b085f6f8ace7$export$44bd9fdb7edbb04a);

var $c5wox = parcelRequire("c5wox");

var $eusud = parcelRequire("eusud");
const $dcc2b085f6f8ace7$export$988cba38e738f27d = async ({ environment: environment, cloudId: cloudId, projectId: projectId, ruleUuid: ruleUuid })=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const DELETE_RULE_URL = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}`;
    return (0, $eusud.performDeleteRequest)(DELETE_RULE_URL);
};
const $dcc2b085f6f8ace7$export$3906c12f20991cd1 = async ({ issueKey: issueKey })=>{
    const ruleConfigEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    return (0, $eusud.performDeleteRequest)(ruleConfigEndpoint);
};
const $dcc2b085f6f8ace7$export$44bd9fdb7edbb04a = async ({ environment: environment, cloudId: cloudId, projectId: projectId, ruleUuid: ruleUuid })=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const disableRuleEndpoint = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}/disable`;
    return (0, $eusud.performPatchRequest)(disableRuleEndpoint);
};

});

parcelRegister("519t2", function(module, exports) {

$parcel$export(module.exports, "callServiceWithAnalytics", () => $ad2a8aebaff4128f$export$7ad2acdaf7d8c23c);

var $jJZqs = parcelRequire("jJZqs");

var $8zOmE = parcelRequire("8zOmE");
const $ad2a8aebaff4128f$var$getErrorAttributes = (error)=>{
    if (error instanceof Error) return {
        errorMessage: error.message,
        ...error instanceof (0, $jJZqs.default) && {
            statusCode: error.statusCode
        }
    };
    return {};
};
const $ad2a8aebaff4128f$export$7ad2acdaf7d8c23c = async (analyticsEvent, requestPromise, requestName, attributes = {})=>{
    try {
        const response = await requestPromise;
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${requestName} succeeded`, {
            ...attributes
        });
        return response;
    } catch (err) {
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${requestName} failed`, {
            ...attributes,
            ...$ad2a8aebaff4128f$var$getErrorAttributes(err)
        });
        throw err;
    }
};

});

parcelRegister("cpjnU", function(module, exports) {

$parcel$export(module.exports, "mapFrequencyToRRule", () => $c35d2016d68e7b8d$export$e01411a3db8dd3d7);
$parcel$export(module.exports, "mapFrequencyToSmartOffsetValue", () => $c35d2016d68e7b8d$export$777fffdd861d4f20);
$parcel$export(module.exports, "getFrequencyFromRRule", () => $c35d2016d68e7b8d$export$71b17ee07540e13b);
$parcel$export(module.exports, "getRecurMenuItemLabel", () => $c35d2016d68e7b8d$export$c7198a7e75d4478b);
$parcel$export(module.exports, "getSuccessFlagContent", () => $c35d2016d68e7b8d$export$8eef89c3d24cb712);
$parcel$export(module.exports, "isRecurOnCompleteToggleRule", () => $c35d2016d68e7b8d$export$b57843f38b80b500);
$parcel$export(module.exports, "hasRuleChanged", () => $c35d2016d68e7b8d$export$8dc77b9e863f46b);
$parcel$export(module.exports, "applyUserTimezone", () => $c35d2016d68e7b8d$export$555109634e8a63b6);

var $ajpes = parcelRequire("ajpes");

var $1GF3c = parcelRequire("1GF3c");

var $gwejS = parcelRequire("gwejS");

var $7jns1 = parcelRequire("7jns1");

var $bbVsP = parcelRequire("bbVsP");
var $jpR5P = parcelRequire("jpR5P");

var $9eJ96 = parcelRequire("9eJ96");

var $5D9Ji = parcelRequire("5D9Ji");
const $c35d2016d68e7b8d$export$e01411a3db8dd3d7 = (timeframe, recurWeeklyConfig)=>{
    switch(timeframe){
        case 'DAILY':
            return {
                frequency: (0, $9eJ96.Frequencies).DAILY,
                interval: 1
            };
        case 'WEEKDAY':
            return {
                frequency: (0, $9eJ96.Frequencies).DAILY,
                byDay: [
                    (0, $9eJ96.Days).MO,
                    (0, $9eJ96.Days).TU,
                    (0, $9eJ96.Days).WE,
                    (0, $9eJ96.Days).TH,
                    (0, $9eJ96.Days).FR
                ],
                interval: 1
            };
        case 'WEEKLY':
            return {
                frequency: (0, $9eJ96.Frequencies).WEEKLY,
                byDay: recurWeeklyConfig,
                interval: 1
            };
        case 'FORTNIGHTLY':
            // There is no native FORTNIGHTLY frequency for ical, so we need to combine WEEKLY with interval 2
            return {
                frequency: (0, $9eJ96.Frequencies).WEEKLY,
                byDay: recurWeeklyConfig,
                interval: 2
            };
        default:
            throw new Error(`Unknown timeframe: ${timeframe}`);
    }
};
const $c35d2016d68e7b8d$export$777fffdd861d4f20 = (timeframe)=>{
    switch(timeframe){
        case 'DAILY':
            return '{{now.plusDays(1)}}';
        case 'WEEKDAY':
            return '{{now.plusBusinessDays(1)}}';
        case 'WEEKLY':
            return '{{now.plusWeeks(1)}}';
        case 'FORTNIGHTLY':
            return '{{now.plusWeeks(2)}}';
        default:
            throw new Error(`Could not calculate due date smart offset value: ${timeframe}`);
    }
};
const $c35d2016d68e7b8d$export$71b17ee07540e13b = (rrule)=>{
    if (rrule.frequency === (0, $9eJ96.Frequencies).DAILY) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(rrule.byDay, [
            (0, $9eJ96.Days).MO,
            (0, $9eJ96.Days).TU,
            (0, $9eJ96.Days).WE,
            (0, $9eJ96.Days).TH,
            (0, $9eJ96.Days).FR
        ])) return 'WEEKDAY';
        return 'DAILY';
    }
    if (rrule.frequency === (0, $9eJ96.Frequencies).WEEKLY) {
        if (rrule.interval === 2) return 'FORTNIGHTLY';
        return 'WEEKLY';
    }
};
const $c35d2016d68e7b8d$export$c7198a7e75d4478b = (rrule, isRecurOnComplete = false)=>{
    if (isRecurOnComplete) return (0, $5D9Ji.default).recursOnComplete;
    const frequency = $c35d2016d68e7b8d$export$71b17ee07540e13b(rrule);
    // Every business day (Monday to Friday)
    if (frequency === 'WEEKDAY') return (0, $5D9Ji.default).recursEveryWeekday;
    // Daily
    if (frequency === 'DAILY') return (0, $5D9Ji.default).recursDaily;
    // Fortnightly
    if (frequency === 'FORTNIGHTLY') return (0, $5D9Ji.default).recursEveryTwoWeeks;
    // Weekly
    if (frequency === 'WEEKLY') return (0, $5D9Ji.default).recursWeekly;
    return (0, $5D9Ji.default).setToRecur;
};
const $c35d2016d68e7b8d$var$byDayOptions = Object.values((0, $9eJ96.Days));
const $c35d2016d68e7b8d$var$getWeekDayNameFromByDay = (byDayValue, intl)=>{
    const dayIndex = $c35d2016d68e7b8d$var$byDayOptions.indexOf(byDayValue);
    if (dayIndex < 0) throw new Error(`Invalid ByDay value provided: ${byDayValue}. Valid options: ${$c35d2016d68e7b8d$var$byDayOptions}`);
    const firstDayOfWeek = (0, $1GF3c.default)(new Date(), {
        weekStartsOn: 1
    });
    const day = (0, $gwejS.default)(firstDayOfWeek, dayIndex);
    return intl.formatDate(day, {
        weekday: 'long'
    });
};
const $c35d2016d68e7b8d$export$5c6d45150d1588c0 = ({ byDayValues: byDayValues, intl: intl, standardizedLocale: standardizedLocale })=>new Intl.ListFormat(standardizedLocale, {
        style: 'long',
        type: 'conjunction'
    }).format(Array.from(byDayValues, (byDayValue)=>$c35d2016d68e7b8d$var$getWeekDayNameFromByDay(byDayValue, intl)));
const $c35d2016d68e7b8d$export$8eef89c3d24cb712 = ({ frequency: frequency, recurCondition: recurCondition, recurWeeklyConfig: recurWeeklyConfig, intl: intl, standardizedLocale: standardizedLocale, issueKey: issueKey, issueType: issueType })=>{
    const issueTypeLowercase = issueType.toLocaleLowerCase(standardizedLocale);
    switch(recurCondition){
        case 'SCHEDULE_IF_COMPLETE':
            switch(frequency){
                case 'DAILY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleIfCompleteDaily, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $5D9Ji.default).successFlagDescriptionRecurOnScheduleIfCompleteDaily, {
                            issueType: issueTypeLowercase
                        })
                    };
                case 'WEEKDAY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleIfCompleteWeekday, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $5D9Ji.default).successFlagDescriptionRecurOnScheduleIfCompleteWeekday, {
                            issueType: issueTypeLowercase
                        })
                    };
                case 'WEEKLY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleIfCompleteWeekly, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $5D9Ji.default).successFlagDescriptionRecurOnScheduleIfCompleteWeekly, {
                            issueType: issueTypeLowercase,
                            weekDayNames: $c35d2016d68e7b8d$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                case 'FORTNIGHTLY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleIfCompleteFortnightly, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $5D9Ji.default).successFlagDescriptionRecurOnScheduleIfCompleteFortnightly, {
                            issueType: issueTypeLowercase,
                            weekDayNames: $c35d2016d68e7b8d$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                default:
                    throw new Error(`Unknown frequency: ${frequency}`);
            }
        case 'SCHEDULE':
            switch(frequency){
                case 'DAILY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleDaily, {
                            issueKey: issueKey
                        })
                    };
                case 'WEEKDAY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleWeekday, {
                            issueKey: issueKey
                        })
                    };
                case 'WEEKLY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleWeekly, {
                            issueKey: issueKey,
                            weekDayNames: $c35d2016d68e7b8d$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                case 'FORTNIGHTLY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleFortnightly, {
                            issueKey: issueKey,
                            weekDayNames: $c35d2016d68e7b8d$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                default:
                    throw new Error(`Unknown frequency: ${frequency}`);
            }
        default:
            throw new Error(`Unknown recur condition: ${recurCondition}`);
    }
};
const $c35d2016d68e7b8d$export$b57843f38b80b500 = (issueProperties)=>{
    return !!issueProperties && !!issueProperties.token && (issueProperties.recurOnScheduleConfig === null || issueProperties.recurOnScheduleConfig === undefined);
};
const $c35d2016d68e7b8d$var$areByDaysEqual = ({ byDays: byDays, anotherByDays: anotherByDays })=>{
    // assumes lists have a consistent order
    if (byDays === undefined) return anotherByDays === undefined;
    if (anotherByDays === undefined) return false;
    if (byDays.length !== anotherByDays.length) return false;
    return byDays.every((byDay, index)=>byDay === anotherByDays[index]);
};
const $c35d2016d68e7b8d$var$areDatesEqual = (date1, date2)=>{
    if (date1 === undefined || date2 === undefined) return date1 === date2;
    // We only care about checking the date equality, not the time
    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
};
const $c35d2016d68e7b8d$export$8dc77b9e863f46b = ({ formInput: formInput, formOutput: formOutput })=>{
    // comparing 2 recur-on-schedule rules
    if (formInput.frequency !== formOutput.frequency || formInput.condition !== formOutput.condition || !$c35d2016d68e7b8d$var$areDatesEqual(formInput.endsOn, formOutput.endsOn)) return true;
    if (formInput.frequency === 'WEEKLY' || formInput.frequency === 'FORTNIGHTLY') return !$c35d2016d68e7b8d$var$areByDaysEqual({
        byDays: formInput.byDay,
        anotherByDays: formOutput.byDay
    });
    return false;
};
const $c35d2016d68e7b8d$export$555109634e8a63b6 = (date, browserTimezone, userTimezone)=>{
    const browserTimezoneOffsetMs = (0, $7jns1.default)(browserTimezone);
    const userTimezoneOffsetMs = (0, $7jns1.default)(userTimezone);
    return (0, $bbVsP.default)((0, $jpR5P.default)(date, browserTimezoneOffsetMs), userTimezoneOffsetMs);
};

});
parcelRegister("9eJ96", function(module, exports) {

$parcel$export(module.exports, "NEWLINE_REGEX", () => $1079d16957e265b2$export$665ca7211e0c33c);
$parcel$export(module.exports, "FOLD_LINES_REGEX", () => $1079d16957e265b2$export$4b7f22f32fbb5949);
$parcel$export(module.exports, "LF", () => $1079d16957e265b2$export$606cfc2a8896c91f);
$parcel$export(module.exports, "NewlineCharacters", () => $1079d16957e265b2$export$ccae594c20078277);
$parcel$export(module.exports, "NewlineCharacterValues", () => $1079d16957e265b2$export$c3edd2b21ac02f88);
$parcel$export(module.exports, "Frequencies", () => $1079d16957e265b2$export$895ee510b2e84ade);
$parcel$export(module.exports, "Days", () => $1079d16957e265b2$export$d3134eff2123aadb);
$parcel$export(module.exports, "BEGIN_VEVENT", () => $1079d16957e265b2$export$67de00e87412dc6f);
$parcel$export(module.exports, "END_VEVENT", () => $1079d16957e265b2$export$987d86d2e891c4cb);
$parcel$export(module.exports, "DTSTART", () => $1079d16957e265b2$export$fd1a0e011a586e26);
$parcel$export(module.exports, "RRULE", () => $1079d16957e265b2$export$d86ed937a45b0291);
$parcel$export(module.exports, "ICalSpecificationFields", () => $1079d16957e265b2$export$98eba4d8ff00c139);
$parcel$export(module.exports, "ICalSupportedFields", () => $1079d16957e265b2$export$38b1323f325ffd22);
$parcel$export(module.exports, "TZID", () => $1079d16957e265b2$export$5b9a78912028c06d);
$parcel$export(module.exports, "DTStartProperties", () => $1079d16957e265b2$export$20184b745430719e);
$parcel$export(module.exports, "FREQ", () => $1079d16957e265b2$export$fb124b4fa837b262);
$parcel$export(module.exports, "UNTIL", () => $1079d16957e265b2$export$4cc4f35131ed029c);
$parcel$export(module.exports, "INTERVAL", () => $1079d16957e265b2$export$7dea0e6e08f87a8a);
$parcel$export(module.exports, "BYHOUR", () => $1079d16957e265b2$export$a764ed9c4884f76d);
$parcel$export(module.exports, "BYMINUTE", () => $1079d16957e265b2$export$7a96578de7a037b6);
$parcel$export(module.exports, "BYSECOND", () => $1079d16957e265b2$export$55bcca3bd8d3041f);
$parcel$export(module.exports, "BYDAY", () => $1079d16957e265b2$export$f512ea3e90612d03);
$parcel$export(module.exports, "BYMONTH", () => $1079d16957e265b2$export$b3203f635d74ce88);
$parcel$export(module.exports, "BYMONTHDAY", () => $1079d16957e265b2$export$15623ad945e92c4c);
$parcel$export(module.exports, "RRuleProperties", () => $1079d16957e265b2$export$7898bd020dba0a27);
$parcel$export(module.exports, "MISSING", () => $1079d16957e265b2$export$64c81710c321f252);
$parcel$export(module.exports, "EMPTY", () => $1079d16957e265b2$export$ccb33e29d92c9a58);
$parcel$export(module.exports, "INVALID", () => $1079d16957e265b2$export$9a105a556e65c2c0);
$parcel$export(module.exports, "VALID", () => $1079d16957e265b2$export$f3abe3d006c81602);
const $1079d16957e265b2$export$665ca7211e0c33c = /\r?\n/;
const $1079d16957e265b2$export$4b7f22f32fbb5949 = /\r?\n[ \t]/g; // match line breaks followed by a whitespace character (space or tab)
const $1079d16957e265b2$export$ae9ea0d00d3d8982 = 'CRLF';
const $1079d16957e265b2$export$a1f3f1ef020bdc3a = '\r\n';
const $1079d16957e265b2$export$606cfc2a8896c91f = 'LF';
const $1079d16957e265b2$export$477fea8aa280bb1e = '\n';
const $1079d16957e265b2$export$ccae594c20078277 = {
    CRLF: $1079d16957e265b2$export$ae9ea0d00d3d8982,
    LF: $1079d16957e265b2$export$606cfc2a8896c91f
};
const $1079d16957e265b2$export$c3edd2b21ac02f88 = {
    [$1079d16957e265b2$export$ae9ea0d00d3d8982]: $1079d16957e265b2$export$a1f3f1ef020bdc3a,
    [$1079d16957e265b2$export$606cfc2a8896c91f]: $1079d16957e265b2$export$477fea8aa280bb1e
};
const $1079d16957e265b2$export$895ee510b2e84ade = {
    SECONDLY: 'SECONDLY',
    MINUTELY: 'MINUTELY',
    HOURLY: 'HOURLY',
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
const $1079d16957e265b2$export$d3134eff2123aadb = {
    MO: 'MO',
    TU: 'TU',
    WE: 'WE',
    TH: 'TH',
    FR: 'FR',
    SA: 'SA',
    SU: 'SU'
};
const $1079d16957e265b2$export$f62540a8bebc4ed3 = 'BEGIN';
const $1079d16957e265b2$export$32239d68d9c6cb49 = 'END';
const $1079d16957e265b2$export$67de00e87412dc6f = 'BEGIN:VEVENT';
const $1079d16957e265b2$export$987d86d2e891c4cb = 'END:VEVENT';
const $1079d16957e265b2$export$fd1a0e011a586e26 = 'DTSTART';
const $1079d16957e265b2$export$d86ed937a45b0291 = 'RRULE';
const $1079d16957e265b2$export$913055729e1380b2 = 'SUMMARY';
const $1079d16957e265b2$export$87d0ca22edb7493a = 'LOCATION';
const $1079d16957e265b2$export$d44826c816b5619b = 'DESCRIPTION';
const $1079d16957e265b2$export$c8b4a4d253b84ce0 = 'UID';
const $1079d16957e265b2$export$34694f8d8b23ee2a = 'SEQUENCE';
const $1079d16957e265b2$export$e50006273435e7d4 = 'STATUS';
const $1079d16957e265b2$export$36034111438e3f25 = 'TRANSP';
const $1079d16957e265b2$export$bb34f3538ba26c7e = 'PRIORITY';
const $1079d16957e265b2$export$30dbcad954808285 = 'DTEND';
const $1079d16957e265b2$export$bacc88974c736870 = 'DURATION';
const $1079d16957e265b2$export$da3a32b38cbf59ba = 'ATTACH';
const $1079d16957e265b2$export$5e0bdf8bba8d5088 = 'ATTENDEE';
const $1079d16957e265b2$export$a513ea61a7bee91c = 'CATEGORIES';
const $1079d16957e265b2$export$a29989082612d0d9 = 'COMMENT';
const $1079d16957e265b2$export$11038cc09fdccb91 = 'CONTACT';
const $1079d16957e265b2$export$133ffe3c8efbf133 = 'EXDATE';
const $1079d16957e265b2$export$7e27a94778a9d7d7 = 'EXRULE';
const $1079d16957e265b2$export$3d166b1dacd2503a = 'RDATE';
const $1079d16957e265b2$export$47a1d4cd38dddc05 = 'RELATED-TO';
const $1079d16957e265b2$export$4e841128923ef26 = 'RESOURCES';
const $1079d16957e265b2$export$1c0dd28c42f2741e = 'RECURRENCE-ID';
const $1079d16957e265b2$export$61abde59b50deb8e = 'URL';
const $1079d16957e265b2$export$ff39ebd4bb12b718 = 'CREATED';
const $1079d16957e265b2$export$2ebcefe61501d5fe = 'DTSTAMP';
const $1079d16957e265b2$export$90812500f628da64 = 'LAST-MODIFIED';
const $1079d16957e265b2$export$5409f4c14bda7ac = 'ORGANIZER';
const $1079d16957e265b2$export$9fe99b3b71be9378 = 'REQUEST-STATUS';
const $1079d16957e265b2$export$98eba4d8ff00c139 = {
    BEGIN: $1079d16957e265b2$export$f62540a8bebc4ed3,
    END: $1079d16957e265b2$export$32239d68d9c6cb49,
    BEGIN_VEVENT: $1079d16957e265b2$export$67de00e87412dc6f,
    END_VEVENT: $1079d16957e265b2$export$987d86d2e891c4cb,
    SUMMARY: $1079d16957e265b2$export$913055729e1380b2,
    LOCATION: $1079d16957e265b2$export$87d0ca22edb7493a,
    DESCRIPTION: $1079d16957e265b2$export$d44826c816b5619b,
    UID: $1079d16957e265b2$export$c8b4a4d253b84ce0,
    SEQUENCE: $1079d16957e265b2$export$34694f8d8b23ee2a,
    STATUS: $1079d16957e265b2$export$e50006273435e7d4,
    TRANSP: $1079d16957e265b2$export$36034111438e3f25,
    PRIORITY: $1079d16957e265b2$export$bb34f3538ba26c7e,
    DTSTART: $1079d16957e265b2$export$fd1a0e011a586e26,
    RRULE: $1079d16957e265b2$export$d86ed937a45b0291,
    DTEND: $1079d16957e265b2$export$30dbcad954808285,
    DURATION: $1079d16957e265b2$export$bacc88974c736870,
    ATTACH: $1079d16957e265b2$export$da3a32b38cbf59ba,
    ATTENDEE: $1079d16957e265b2$export$5e0bdf8bba8d5088,
    CATEGORIES: $1079d16957e265b2$export$a513ea61a7bee91c,
    COMMENT: $1079d16957e265b2$export$a29989082612d0d9,
    CONTACT: $1079d16957e265b2$export$11038cc09fdccb91,
    EXDATE: $1079d16957e265b2$export$133ffe3c8efbf133,
    EXRULE: $1079d16957e265b2$export$7e27a94778a9d7d7,
    RDATE: $1079d16957e265b2$export$3d166b1dacd2503a,
    RELATED_TO: $1079d16957e265b2$export$47a1d4cd38dddc05,
    RESOURCES: $1079d16957e265b2$export$4e841128923ef26,
    RECURRENCE_ID: $1079d16957e265b2$export$1c0dd28c42f2741e,
    URL: $1079d16957e265b2$export$61abde59b50deb8e,
    CREATED: $1079d16957e265b2$export$ff39ebd4bb12b718,
    DTSTAMP: $1079d16957e265b2$export$2ebcefe61501d5fe,
    LAST_MODIFIED: $1079d16957e265b2$export$90812500f628da64,
    ORGANIZER: $1079d16957e265b2$export$5409f4c14bda7ac,
    REQUEST_STATUS: $1079d16957e265b2$export$9fe99b3b71be9378
};
const $1079d16957e265b2$export$38b1323f325ffd22 = {
    DTSTART: $1079d16957e265b2$export$fd1a0e011a586e26,
    RRULE: $1079d16957e265b2$export$d86ed937a45b0291
};
const $1079d16957e265b2$export$5b9a78912028c06d = 'TZID';
const $1079d16957e265b2$export$20184b745430719e = {
    DTSTART: $1079d16957e265b2$export$fd1a0e011a586e26,
    TZID: $1079d16957e265b2$export$5b9a78912028c06d
};
const $1079d16957e265b2$export$fb124b4fa837b262 = 'FREQ';
const $1079d16957e265b2$export$4cc4f35131ed029c = 'UNTIL';
const $1079d16957e265b2$export$7dea0e6e08f87a8a = 'INTERVAL';
const $1079d16957e265b2$export$a764ed9c4884f76d = 'BYHOUR';
const $1079d16957e265b2$export$7a96578de7a037b6 = 'BYMINUTE';
const $1079d16957e265b2$export$55bcca3bd8d3041f = 'BYSECOND';
const $1079d16957e265b2$export$f512ea3e90612d03 = 'BYDAY';
const $1079d16957e265b2$export$b3203f635d74ce88 = 'BYMONTH';
const $1079d16957e265b2$export$15623ad945e92c4c = 'BYMONTHDAY';
const $1079d16957e265b2$export$7898bd020dba0a27 = {
    FREQ: $1079d16957e265b2$export$fb124b4fa837b262,
    UNTIL: $1079d16957e265b2$export$4cc4f35131ed029c,
    INTERVAL: $1079d16957e265b2$export$7dea0e6e08f87a8a,
    BYHOUR: $1079d16957e265b2$export$a764ed9c4884f76d,
    BYMINUTE: $1079d16957e265b2$export$7a96578de7a037b6,
    BYSECOND: $1079d16957e265b2$export$55bcca3bd8d3041f,
    BYDAY: $1079d16957e265b2$export$f512ea3e90612d03,
    BYMONTH: $1079d16957e265b2$export$b3203f635d74ce88,
    BYMONTHDAY: $1079d16957e265b2$export$15623ad945e92c4c
};
const $1079d16957e265b2$export$64c81710c321f252 = 'MISSING';
const $1079d16957e265b2$export$ccb33e29d92c9a58 = 'EMPTY';
const $1079d16957e265b2$export$9a105a556e65c2c0 = 'INVALID';
const $1079d16957e265b2$export$f3abe3d006c81602 = 'VALID';

});

parcelRegister("5D9Ji", function(module, exports) {

$parcel$export(module.exports, "default", () => $f056e68da25dd6c2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f056e68da25dd6c2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    formTitle: {
        "id": "recur-work-item.form-title",
        "defaultMessage": "Set to recur"
    },
    saveButtonText: {
        "id": "recur-work-item.save-button-text",
        "defaultMessage": "Save"
    },
    cancelButtonText: {
        "id": "recur-work-item.cancel-button-text",
        "defaultMessage": "Cancel"
    },
    deleteButtonText: {
        "id": "recur-work-item.delete-button-text",
        "defaultMessage": "Delete"
    },
    recurFieldsLabel: {
        "id": "recur-work-item.recur-fields-label",
        "defaultMessage": "Recur"
    },
    setToRecur: {
        "id": "recur-work-item.set-to-recur",
        "defaultMessage": "Set to recur"
    },
    recursDaily: {
        "id": "recur-work-item.recurs-daily",
        "defaultMessage": "Recurs daily"
    },
    recursEveryWeekday: {
        "id": "recur-work-item.recurs-every-weekday",
        "defaultMessage": "Every weekday (Monday to Friday)"
    },
    recursWeekly: {
        "id": "recur-work-item.recurs-weekly",
        "defaultMessage": "Recurs weekly"
    },
    recursEveryTwoWeeks: {
        "id": "recur-work-item.recurs-every-two-weeks",
        "defaultMessage": "Recurs every 2 weeks"
    },
    recursOnComplete: {
        "id": "recur-work-item.recurs-on-complete",
        "defaultMessage": "Recurs when completed"
    },
    successFlagTitleRecurOnScheduleIfCompleteDaily: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-daily",
        "defaultMessage": "{issueKey} recurs every day"
    },
    successFlagTitleRecurOnScheduleIfCompleteWeekday: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-weekday",
        "defaultMessage": "{issueKey} recurs every weekday"
    },
    successFlagTitleRecurOnScheduleIfCompleteWeekly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-weekly",
        "defaultMessage": "{issueKey} recurs every week"
    },
    successFlagTitleRecurOnScheduleIfCompleteFortnightly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-fortnightly",
        "defaultMessage": "{issueKey} recurs every 2 weeks"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteDaily: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-daily",
        "defaultMessage": "This {issueType} recurs daily when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteWeekday: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-weekday",
        "defaultMessage": "This {issueType} recurs every weekday when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteWeekly: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-weekly",
        "defaultMessage": "This {issueType} recurs weekly on {weekDayNames} when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteFortnightly: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-fortnightly",
        "defaultMessage": "This {issueType} recurs every 2 weeks on {weekDayNames} when completed"
    },
    successFlagTitleRecurOnScheduleDaily: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-daily",
        "defaultMessage": "{issueKey} recurs every day"
    },
    successFlagTitleRecurOnScheduleWeekday: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-weekday",
        "defaultMessage": "{issueKey} recurs every weekday"
    },
    successFlagTitleRecurOnScheduleWeekly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-weekly",
        "defaultMessage": "{issueKey} recurs every week on {weekDayNames}"
    },
    successFlagTitleRecurOnScheduleFortnightly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-fortnightly",
        "defaultMessage": "{issueKey} recurs every 2 weeks on {weekDayNames}"
    },
    goBackLabel: {
        "id": "recur-work-item.go-back-label",
        "defaultMessage": "Go back"
    },
    errorFlagReloadPageButton: {
        "id": "recur-work-item.error-flag-reload-page-button",
        "defaultMessage": "Reload page"
    },
    errorFlagDescription: {
        "id": "recur-work-item.error-flag-description",
        "defaultMessage": "If this keeps happening, share this information with your admin, who should <link>contact support</link>."
    },
    errorFlagTitle: {
        "id": "recur-work-item.error-flag-title",
        "defaultMessage": "Something went wrong on our end"
    }
});

});



parcelRegister("l9xxv", function(module, exports) {

$parcel$export(module.exports, "setAsNonRecurringIssue", () => $867e9b1c0261db63$export$7b76980c59e9a391);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8zOmE = parcelRequire("8zOmE");

var $lQupu = parcelRequire("lQupu");

var $fAJ3G = parcelRequire("fAJ3G");

var $519t2 = parcelRequire("519t2");
const $867e9b1c0261db63$export$7b76980c59e9a391 = ({ isProjectAdmin: isProjectAdmin, isRuleOwner: isRuleOwner, isSiteAdmin: isSiteAdmin, skipDeletingIssueProperties: skipDeletingIssueProperties = false })=>async ({ setState: setState, getState: getState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId })=>{
        const { issueProperties: issueProperties, errors: errors, isUpdatingRule: isUpdatingRule } = getState();
        // this can't be !automationRuleUuid because recur-on-complete rules won't have an
        // automationRuleUuid, but they will have issueProperties
        if (!issueProperties) {
            const error = new Error('User is trying to delete a rule before the rule data has been stored.');
            setState({
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        if (!isSiteAdmin && !isProjectAdmin && !isRuleOwner) {
            const error = new Error('User does not have permission to set issue as non-recurring.');
            setState({
                // TODO: decide if we want to be appending to this list or overwriting it
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        const { automationRuleUuid: ruleUuid, templateId: templateId, recurOnScheduleConfig: recurOnScheduleConfig } = issueProperties;
        if (skipDeletingIssueProperties && !ruleUuid) // nothing to do
        return;
        setState({
            isDeletingRule: true
        });
        const analyticsEvent = createAnalyticsEvent({});
        // delete or disable the rule if we know the rule UUID
        if (ruleUuid) try {
            if (isRuleOwner || isSiteAdmin) {
                await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $fAJ3G.deleteRule)({
                    environment: environment,
                    cloudId: cloudId,
                    projectId: projectId,
                    ruleUuid: ruleUuid
                }), 'deleteRule');
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'recurringRule deleted', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: ruleUuid,
                    templateId: templateId,
                    recurCondition: recurOnScheduleConfig?.recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
            } else {
                await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $fAJ3G.disableRule)({
                    environment: environment,
                    cloudId: cloudId,
                    projectId: projectId,
                    ruleUuid: ruleUuid
                }), 'disableRule');
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'recurringRule disabled', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: ruleUuid,
                    templateId: templateId,
                    recurCondition: recurOnScheduleConfig?.recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
            }
        } catch (error) {
            // abort if the rule cannot be deleted/disabled
            setState({
                isDeletingRule: false,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        if (skipDeletingIssueProperties) {
            // we only get here if we've successfully deleted/disabled a recur-on-schedule rule.
            // it's not possible to re-enable disabled rules, so we can assume that the rule will
            // no longer generate future work items. this means that the issue's issue properties
            // are no longer important to store.
            setState({
                isDeletingRule: false,
                ...(0, $lQupu.NO_RULE_PARTIAL_STATE)
            });
            return;
        }
        try {
            await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $fAJ3G.deleteIssueProperties)({
                issueKey: issueKey
            }), 'deleteIssueProperties');
            setState({
                isDeletingRule: false,
                ...(0, $lQupu.NO_RULE_PARTIAL_STATE)
            });
        } catch (error) {
            if (!ruleUuid) {
                // in this case, we haven't deleted or disabled the rule, so the rule can still generate
                // future work items. we leave the rule stored in state unchanged and rethrow the error.
                setState({
                    isDeletingRule: false,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error
                    ]
                });
                throw error;
            }
            // don't rethrow because from the user's perspective, the work item is no longer recurring.
            setState({
                isDeletingRule: false,
                ...(0, $lQupu.NO_RULE_PARTIAL_STATE),
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
        }
    };

});
parcelRegister("lQupu", function(module, exports) {

$parcel$export(module.exports, "INITIAL_STATE", () => $6bdecc95b0135cf9$export$36d128238e6b60f5);
$parcel$export(module.exports, "NO_RULE_PARTIAL_STATE", () => $6bdecc95b0135cf9$export$a1b15f9b9ceb0f70);
const $6bdecc95b0135cf9$export$36d128238e6b60f5 = {
    hasFetched: false,
    isFetching: false,
    isCreatingRule: false,
    isDeletingRule: false,
    isUpdatingRule: false,
    errors: null,
    hasBootstrapError: false,
    isRuleOwner: null,
    issueProperties: null
};
const $6bdecc95b0135cf9$export$a1b15f9b9ceb0f70 = {
    isRuleOwner: null,
    issueProperties: null
};

});


parcelRegister("bvhsR", function(module, exports) {

$parcel$export(module.exports, "setAsRecurringIssue", () => $fe7808073e642503$export$5d9cc8e9f9314f21);

var $7Jxgt = parcelRequire("7Jxgt");

var $8zOmE = parcelRequire("8zOmE");

var $cS75I = parcelRequire("cS75I");

var $ahBjy = parcelRequire("ahBjy");

var $519t2 = parcelRequire("519t2");
const $fe7808073e642503$export$5d9cc8e9f9314f21 = ({ recurOnScheduleConfig: { rRule: rRule, recurCondition: recurCondition, dueDateOffsetSmartValue: dueDateOffsetSmartValue } })=>async ({ setState: setState, getState: getState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId })=>{
        const { errors: errors, isUpdatingRule: isUpdatingRule } = getState();
        setState({
            isCreatingRule: true
        });
        const recurrenceToken = (0, $7Jxgt.v4)();
        const templateId = (0, $ahBjy.SOFTWARE_END_USER_TEMPLATE_2);
        const analyticsEvent = createAnalyticsEvent({});
        try {
            const createTemplateResponse = await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $cS75I.createTemplate)({
                environment: environment,
                cloudId: cloudId,
                projectId: projectId,
                recurrenceToken: recurrenceToken,
                recurCondition: recurCondition,
                rRule: rRule,
                dueDateOffsetSmartValue: dueDateOffsetSmartValue
            }), 'createTemplate');
            if (createTemplateResponse?.ruleUuid) {
                await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $cS75I.setIssueProperties)({
                    issueKey: issueKey,
                    recurrenceToken: recurrenceToken,
                    ruleUuid: createTemplateResponse.ruleUuid,
                    recurCondition: recurCondition,
                    rRule: rRule,
                    templateId: templateId,
                    dueDateOffsetSmartValue: dueDateOffsetSmartValue
                }), 'setIssueProperties');
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'recurringRule created', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: createTemplateResponse.ruleUuid,
                    templateId: templateId,
                    recurCondition: recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
                const issueProperties = {
                    automationRuleUuid: createTemplateResponse.ruleUuid,
                    token: recurrenceToken,
                    templateId: templateId,
                    recurOnScheduleConfig: {
                        rRule: rRule,
                        dueDateOffsetSmartValue: dueDateOffsetSmartValue,
                        recurCondition: recurCondition
                    }
                };
                setState({
                    isCreatingRule: false,
                    issueProperties: issueProperties,
                    isRuleOwner: true
                });
            } else throw new Error('New rule failed to be created.');
        } catch (error) {
            setState({
                isCreatingRule: false,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
    };

});
parcelRegister("cS75I", function(module, exports) {

$parcel$export(module.exports, "createTemplate", () => $d425ed86c31f35f6$export$7b7ae612b60e1630);
$parcel$export(module.exports, "setIssueProperties", () => $d425ed86c31f35f6$export$5153917efea4a83d);

var $kV9ss = parcelRequire("kV9ss");

var $c5wox = parcelRequire("c5wox");

var $eusud = parcelRequire("eusud");

var $ahBjy = parcelRequire("ahBjy");
const $d425ed86c31f35f6$export$7b7ae612b60e1630 = async ({ environment: environment, cloudId: cloudId, projectId: projectId, recurrenceToken: recurrenceToken, recurCondition: recurCondition, rRule: rRule, dueDateOffsetSmartValue: dueDateOffsetSmartValue })=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const CREATE_TEMPLATE_URL = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/public/rest/v1/template/create`;
    const ruleHomeARI = (0, $kV9ss.JiraProjectAri).create({
        siteId: cloudId,
        projectId: String(projectId)
    });
    const payload = {
        ruleHome: ruleHomeARI,
        templateId: (0, $ahBjy.SOFTWARE_END_USER_TEMPLATE_2),
        parameters: {
            recurrenceToken: {
                value: recurrenceToken,
                type: 'TEXT'
            },
            rRule: {
                value: rRule,
                type: 'TEXT'
            },
            dueDateOffsetSmartValue: {
                value: dueDateOffsetSmartValue,
                type: 'TEXT'
            },
            recurCondition: {
                value: recurCondition,
                type: 'TEXT'
            }
        }
    };
    return (0, $eusud.performPostRequest)(CREATE_TEMPLATE_URL, {
        body: JSON.stringify(payload)
    });
};
const $d425ed86c31f35f6$export$5153917efea4a83d = async ({ issueKey: issueKey, ruleUuid: ruleUuid, recurrenceToken: recurrenceToken, recurCondition: recurCondition, rRule: rRule, templateId: templateId, dueDateOffsetSmartValue: dueDateOffsetSmartValue })=>{
    const issuePropertiesEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    const requestBody = {
        automationRuleUuid: ruleUuid,
        token: recurrenceToken,
        templateId: templateId,
        recurOnScheduleConfig: {
            rRule: rRule,
            dueDateOffsetSmartValue: dueDateOffsetSmartValue,
            recurCondition: recurCondition
        }
    };
    return (0, $eusud.performPutRequest)(issuePropertiesEndpoint, {
        body: JSON.stringify(requestBody)
    });
};

});


parcelRegister("c8g0F", function(module, exports) {

$parcel$export(module.exports, "updateRule", () => $257e932348ccd8c0$export$b2ebf395d72c5a4c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8zOmE = parcelRequire("8zOmE");

var $fAJ3G = parcelRequire("fAJ3G");

var $519t2 = parcelRequire("519t2");

var $bvhsR = parcelRequire("bvhsR");

var $l9xxv = parcelRequire("l9xxv");
const $257e932348ccd8c0$export$b2ebf395d72c5a4c = ({ isProjectAdmin: isProjectAdmin, isRuleOwner: isRuleOwner, isSiteAdmin: isSiteAdmin, recurOnScheduleConfig: recurOnScheduleConfig })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey })=>{
        const { issueProperties: issueProperties, errors: errors } = getState();
        if (!issueProperties) {
            // if there is no existing rule, then create a new rule and update issue properties
            await dispatch((0, $bvhsR.setAsRecurringIssue)({
                recurOnScheduleConfig: recurOnScheduleConfig
            }));
            return;
        }
        const { automationRuleUuid: ruleUuid, templateId: templateId } = issueProperties;
        setState({
            isUpdatingRule: true
        });
        try {
            await dispatch((0, $l9xxv.setAsNonRecurringIssue)({
                isProjectAdmin: isProjectAdmin,
                isRuleOwner: isRuleOwner,
                isSiteAdmin: isSiteAdmin,
                // we'll update issue properties later
                skipDeletingIssueProperties: true
            }));
        } catch (error) {
            // don't need to save the error to state because setAsNonRecurringIssue should already do this
            setState({
                isUpdatingRule: false
            });
            throw error;
        }
        // create the new rule
        try {
            await dispatch((0, $bvhsR.setAsRecurringIssue)({
                recurOnScheduleConfig: recurOnScheduleConfig
            }));
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'recurringRule updated', {
                issueKey: // TODO: add ruleId attribute
                issueKey,
                ruleUuid: ruleUuid,
                templateId: templateId,
                recurCondition: recurOnScheduleConfig?.recurCondition,
                isUpdateForExistingRule: true
            });
            setState({
                isUpdatingRule: false
            });
        } catch (error) {
            // if we fail to create the rule and update issue properties, then we need to go back and remove the
            // original recurring rule config from issue properties
            try {
                setState({
                    isDeletingRule: true
                });
                await (0, $519t2.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $fAJ3G.deleteIssueProperties)({
                    issueKey: issueKey
                }), 'deleteIssueProperties');
                setState({
                    isDeletingRule: false,
                    isUpdatingRule: false,
                    issueProperties: null,
                    isRuleOwner: null,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error
                    ]
                });
            } catch (anotherError) {
                // we've made no changes to the rule config since we called `setAsNonRecurringIssue` above,
                // so we don't need to update ruleSummary or issueProperties.
                setState({
                    isDeletingRule: false,
                    isUpdatingRule: false,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error,
                        anotherError
                    ]
                });
                throw anotherError;
            }
            // we've just successfully deleted the existing rule; we haven't actually created a new one.
            throw error;
        }
    };

});



parcelRegister("hlI3h", function(module, exports) {

$parcel$export(module.exports, "RecurWorkComponent", () => $a0dd7a40f22d6a78$export$7a99200ca764e8f);

var $5uXOq = parcelRequire("5uXOq");

var $kJpBP = parcelRequire("kJpBP");

var $aYAc3 = parcelRequire("aYAc3");

var $bpC55 = parcelRequire("bpC55");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $34Rrn = parcelRequire("34Rrn");

var $2Yv61 = parcelRequire("2Yv61");

var $e4yMr = parcelRequire("e4yMr");

var $eCeGD = parcelRequire("eCeGD");

var $1I7E8 = parcelRequire("1I7E8");

var $jpopi = parcelRequire("jpopi");

var $cNd4s = parcelRequire("cNd4s");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $8M6yJ = parcelRequire("8M6yJ");

var $dVMqV = parcelRequire("dVMqV");

var $2YZCu = parcelRequire("2YZCu");

var $cpjnU = parcelRequire("cpjnU");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $1eyaH = parcelRequire("1eyaH");

var $4anLj = parcelRequire("4anLj");

var $93Yeu = parcelRequire("93Yeu");

var $17Gip = parcelRequire("17Gip");

var $7mPT9 = parcelRequire("7mPT9");

const $a0dd7a40f22d6a78$var$messages = (0, $7VHMR.defineMessages)({
    ruleDidNotLoad: {
        "id": "recur-work-work-item-trigger.popup.rule-did-not-load",
        "defaultMessage": "Rule did not load. Try refreshing the page."
    },
    userNotPermittedToEdit: {
        "id": "recur-work-work-item-trigger.popup.user-not-permitted-to-edit",
        "defaultMessage": "<link>Contact your administrator</link> to edit this rule."
    },
    newLozengeLabel: {
        "id": "recur-work-work-item-trigger.new-lozenge-label",
        "defaultMessage": "New"
    }
});
const $a0dd7a40f22d6a78$export$534fc570264a52a4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ triggerType: triggerType, shouldFitContainer: shouldFitContainer, iconBefore: IconBefore, iconAfter: IconAfter, children: children, menuItemMessage: menuItemMessage, shouldShowNewLozenge: shouldShowNewLozenge, hasRule: hasRule, ...rest }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (triggerType === (0, $f60a10b809e51afa$export$b887e88d8d0739f6)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        ...rest,
        iconAfter: IconAfter,
        shouldFitContainer: shouldFitContainer,
        ref: ref,
        interactionName: "jira-issue-field.ui.recur-work.button",
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.075"
    }, IconBefore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconBefore, {
        label: ""
    }) : undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $a0dd7a40f22d6a78$var$ellipsisOverflowStyle,
            hasRule ? $a0dd7a40f22d6a78$var$defaultTextStyle : $a0dd7a40f22d6a78$var$subtleTextStyle
        ]
    }, formatMessage(menuItemMessage)), shouldShowNewLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a0dd7a40f22d6a78$var$lozengeStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: "new"
    }, formatMessage($a0dd7a40f22d6a78$var$messages.newLozengeLabel)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        ...rest,
        iconBefore: IconBefore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8M6yJ.MenuIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconBefore, {
            label: ""
        })) : undefined,
        ...IconAfter && {
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconAfter, {
                label: ""
            })
        },
        ref: ref,
        interactionName: "jira-issue-field.ui.recur-work-menu-item.button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.075"
    }, formatMessage(menuItemMessage), shouldShowNewLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: "new"
    }, formatMessage($a0dd7a40f22d6a78$var$messages.newLozengeLabel))));
});
const $a0dd7a40f22d6a78$export$7a99200ca764e8f = ({ triggerType: triggerType, buttonRef: buttonRef, onClick: onClick, issueKey: issueKey, recurWorkFormEntryPoint: recurWorkFormEntryPoint, testId: testId, shouldShowNewLozenge: shouldShowNewLozenge })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isProjectAdmin = (0, $4anLj.useIsProjectAdmin)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const [{ canEditIssues: canEditIssues }] = (0, $17Gip.useProjectPermissions)(projectKey);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { issueProperties: issueProperties, hasFetched: hasFetched, hasBootstrapError: hasBootstrapError, isRuleOwner: isRuleOwner, isFetching: isFetching, isDeletingRule: isDeletingRule, isCreatingRule: isCreatingRule, isUpdatingRule: isUpdatingRule } = (0, $1eyaH.useRecurWorkItemState)();
    const { fetch: refetch } = (0, $1eyaH.useRecurWorkItemActions)();
    const [isPopupOpen, setIsPopupOpen] = (0, $5uXOq.useState)(false);
    const hasMountedRef = (0, $5uXOq.useRef)(false);
    const hasFiredViewedEventRef = (0, $5uXOq.useRef)(false);
    const buttonRefForNonEditableRule = (0, $5uXOq.useRef)(null);
    const userPermittedToEdit = canEditIssues && (isSiteAdmin || isProjectAdmin || issueProperties && isRuleOwner || !issueProperties);
    (0, $5uXOq.useEffect)(()=>{
        if (hasFetched && !(isFetching || isDeletingRule || isCreatingRule || isUpdatingRule)) refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasFiredViewedEventRef.current && hasFetched) {
            hasFiredViewedEventRef.current = true;
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'menuItem viewed', 'recurOnSchedulePopup', {
                canViewRecurOnSchedulePopup: userPermittedToEdit && !hasBootstrapError,
                recurWorkFormEntryPoint: recurWorkFormEntryPoint
            });
        }
    }, [
        hasFetched,
        createAnalyticsEvent,
        userPermittedToEdit,
        recurWorkFormEntryPoint,
        hasBootstrapError
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // prevent focusing on mount, only when it changes from open -> closed
        if (!hasMountedRef.current) {
            hasMountedRef.current = true;
            return;
        }
        if (!isPopupOpen) buttonRefForNonEditableRule.current?.focus();
    }, [
        isPopupOpen
    ]);
    const ruleFailedToLoad = hasFetched && hasBootstrapError;
    const menuItemMessage = (0, $5uXOq.useMemo)(()=>{
        const isRecurOnComplete = (0, $cpjnU.isRecurOnCompleteToggleRule)(issueProperties);
        let parsedrRule;
        try {
            parsedrRule = (0, $dVMqV.parse)(issueProperties?.recurOnScheduleConfig?.rRule);
        } catch (err) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('jira-issue-field-status.src.ui.status-view.actions.actions-menu.recur-work-menu-item', 'Error parsing rRule string', // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            err);
        }
        const rrule = parsedrRule?.event?.rrule ?? {};
        return (0, $cpjnU.getRecurMenuItemLabel)(rrule, isRecurOnComplete);
    }, [
        issueProperties
    ]);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'menuItem clicked', 'recurOnSchedulePopup', {
            recurWorkFormEntryPoint: recurWorkFormEntryPoint
        });
        onClick();
    }, [
        createAnalyticsEvent,
        onClick,
        recurWorkFormEntryPoint
    ]);
    if (ruleFailedToLoad || !userPermittedToEdit) {
        const popupMessage = ruleFailedToLoad ? formatMessage($a0dd7a40f22d6a78$var$messages.ruleDidNotLoad) : formatMessage($a0dd7a40f22d6a78$var$messages.userNotPermittedToEdit, {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                    href: "/jira/contact-administrator"
                }, chunks)
        });
        const dataTestId = ruleFailedToLoad ? `${testId}.warn-button-item` : `${testId}.info-button-item`;
        const Icon = ruleFailedToLoad ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($34Rrn))), {
            color: "var(--ds-icon-warning, #E56910)",
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Yv61))), {
            color: "var(--ds-icon-discovery, #8270DB)",
            label: ""
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
            isOpen: isPopupOpen,
            onClose: ()=>{
                setIsPopupOpen(false);
            },
            placement: "top",
            shouldRenderToParent: true,
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    padding: "space.200",
                    onKeyDown: (event)=>{
                        const keyPressed = event.key.toLowerCase();
                        if (keyPressed === 'escape' || keyPressed === 'esc') {
                            // stop propagation is required so that once the user has tabbed into the popup,
                            // pressing escape doesn't close the parent component (i.e. the date picker or
                            // the actions menu)
                            event.stopPropagation();
                            setIsPopupOpen(false);
                        }
                    }
                }, popupMessage),
            trigger: ({ ref: ref, ...triggerProps })=>{
                const mergedRefs = (0, $7mPT9.mergeRefs)(buttonRefForNonEditableRule, ref);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a0dd7a40f22d6a78$export$534fc570264a52a4, {
                    ...triggerProps,
                    ref: mergedRefs,
                    triggerType: triggerType,
                    onClick: ()=>{
                        setIsPopupOpen(!isPopupOpen);
                    },
                    iconBefore: ()=>Icon,
                    testId: dataTestId,
                    shouldShowNewLozenge: shouldShowNewLozenge,
                    menuItemMessage: menuItemMessage,
                    hasRule: !!issueProperties
                });
            }
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a0dd7a40f22d6a78$export$534fc570264a52a4, {
        triggerType: triggerType,
        ref: buttonRef,
        onClick: handleClick,
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($jpopi))),
        iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bpC55))), {
                ...iconProps,
                size: "small"
            }),
        shouldFitContainer: true,
        testId: `${testId}${(0, $f60a10b809e51afa$export$6670546ab560a9dd)}`,
        shouldShowNewLozenge: shouldShowNewLozenge,
        menuItemMessage: menuItemMessage,
        hasRule: !!issueProperties
    });
};
const $a0dd7a40f22d6a78$var$ellipsisOverflowStyle = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $a0dd7a40f22d6a78$var$defaultTextStyle = (0, $8CUq3.xcss)({
    color: 'color.text'
});
const $a0dd7a40f22d6a78$var$subtleTextStyle = (0, $8CUq3.xcss)({
    color: 'color.text.subtle'
});
const $a0dd7a40f22d6a78$var$lozengeStyle = (0, $8CUq3.xcss)({
    flexShrink: 0
});

});
parcelRegister("jpopi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a88758e67a65d8683bdcd5e828d8b686>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e21348dd48989821$var$_react = $e21348dd48989821$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e21348dd48989821$var$_baseNew = $e21348dd48989821$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e21348dd48989821$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Repeat".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for setting objects to recur (eg Work items, Forms)
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e21348dd48989821$var$RepeatIcon = (props)=>/*#__PURE__*/ $e21348dd48989821$var$_react.default.createElement($e21348dd48989821$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m8.78 3.72-3-3-1.06 1.06L6.44 3.5H4.5a4.5 4.5 0 0 0 0 9h1V11h-1a3 3 0 0 1 0-6h1.94L4.72 6.72l1.06 1.06 3-3a.75.75 0 0 0 0-1.06M11.5 5a3 3 0 1 1 0 6H9.56l1.72-1.72-1.06-1.06-3 3a.75.75 0 0 0 0 1.06l3 3 1.06-1.06-1.72-1.72h1.94a4.5 4.5 0 1 0 0-9h-1V5z" clip-rule="evenodd"/>`
    }, props));
$e21348dd48989821$var$RepeatIcon.displayName = 'RepeatIcon';
var $e21348dd48989821$var$_default = module.exports.default = $e21348dd48989821$var$RepeatIcon;

});

parcelRegister("cNd4s", function(module, exports) {

$parcel$export(module.exports, "useIsSiteAdmin", () => $3ad4a3e53b34f026$export$f9f8a5cdb0c565ef);

var $9OXo1 = parcelRequire("9OXo1");
const $3ad4a3e53b34f026$export$f9f8a5cdb0c565ef = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isSiteAdmin || false;
};

});

parcelRegister("dVMqV", function(module, exports) {

$parcel$export(module.exports, "parse", () => $8e2e4182ac5ec8be$export$98e6a39c04603d36);

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $9eJ96 = parcelRequire("9eJ96");

var $aYpRI = parcelRequire("aYpRI");

var $17IU1 = parcelRequire("17IU1");
const $8e2e4182ac5ec8be$export$81d5764ba309551d = {
    dtstart: undefined,
    rrule: undefined
};
const $8e2e4182ac5ec8be$export$f7f85e789005e4b9 = {
    frequency: undefined,
    interval: undefined,
    byMonthDay: undefined,
    byMonth: undefined,
    byDay: undefined,
    byHour: undefined,
    byMinute: undefined,
    bySecond: undefined,
    until: undefined
};
function $8e2e4182ac5ec8be$var$getImmutableEmptyEvent() {
    return {
        ...$8e2e4182ac5ec8be$export$81d5764ba309551d
    };
}
function $8e2e4182ac5ec8be$var$getImmutableEmptyRRule() {
    return {
        ...$8e2e4182ac5ec8be$export$f7f85e789005e4b9
    };
}
function $8e2e4182ac5ec8be$var$parseDateTime(line) {
    const { dateTimeString: dateTimeString, timezone: timezone } = (0, $aYpRI.extractTZID)(line);
    const date = dateTimeString.trim() ? (0, $eZDAP.default)(dateTimeString.trim()) : undefined;
    if (date && (0, $jovBr.default)(date)) return {
        date: date,
        timezone: timezone
    };
    return undefined;
}
function $8e2e4182ac5ec8be$var$parseMultiValue(value, validator, mapper) {
    return value?.split(',')?.filter(validator).map(mapper) ?? [];
}
function $8e2e4182ac5ec8be$var$getParser(parsers, toKey) {
    return (propertyKey)=>{
        const parserKey = toKey(propertyKey?.toUpperCase());
        return parserKey ? parsers[parserKey] : undefined;
    };
}
const $8e2e4182ac5ec8be$var$recurrenceRuleParsers = {
    [(0, $9eJ96.FREQ)]: (rule, value)=>{
        if ((0, $aYpRI.isValidFrequency)(value)) return Object.assign(rule, {
            frequency: value
        });
        return rule;
    },
    [(0, $9eJ96.INTERVAL)]: (rule, value)=>{
        if ((0, $aYpRI.isValidInterval)(value)) {
            const interval = Number(value);
            return Object.assign(rule, {
                interval: interval
            });
        }
        return rule;
    },
    [(0, $9eJ96.BYMONTH)]: (rule, value)=>{
        const byMonth = $8e2e4182ac5ec8be$var$parseMultiValue(value, (0, $aYpRI.isValidMonth), Number);
        return Object.assign(rule, {
            byMonth: byMonth
        });
    },
    [(0, $9eJ96.BYMONTHDAY)]: (rule, value)=>{
        const byMonthDay = $8e2e4182ac5ec8be$var$parseMultiValue(value, (0, $aYpRI.isValidMonthDay), Number);
        return Object.assign(rule, {
            byMonthDay: byMonthDay
        });
    },
    [(0, $9eJ96.BYDAY)]: (rule, value)=>{
        const byDay = $8e2e4182ac5ec8be$var$parseMultiValue(value, (0, $aYpRI.isValidByDayValue), String);
        return Object.assign(rule, {
            byDay: byDay
        });
    },
    [(0, $9eJ96.BYHOUR)]: (rule, value)=>{
        const byHour = $8e2e4182ac5ec8be$var$parseMultiValue(value, (0, $aYpRI.isValidHour), Number);
        return Object.assign(rule, {
            byHour: byHour
        });
    },
    [(0, $9eJ96.BYMINUTE)]: (rule, value)=>{
        const byMinute = $8e2e4182ac5ec8be$var$parseMultiValue(value, (0, $aYpRI.isValidMinute), Number);
        return Object.assign(rule, {
            byMinute: byMinute
        });
    },
    [(0, $9eJ96.BYSECOND)]: (rule, value)=>{
        const bySecond = $8e2e4182ac5ec8be$var$parseMultiValue(value, (0, $aYpRI.isValidSecond), Number);
        return Object.assign(rule, {
            bySecond: bySecond
        });
    },
    /**
	 * The value of the UNTIL rule part MUST have the same value type as the "DTSTART" property.
	 * If the "DTSTART" property is specified as a date with local time, then the UNTIL rule part MUST also be specified as a date with local time.
	 * If the "DTSTART" property is specified as a date with UTC time or a date with local time and time zone reference, then the UNTIL rule part MUST be specified as a date with UTC time.
	 * Reference: [RFC 5545 specification for RRULE](https://datatracker.ietf.org/doc/html/rfc5545#section-3.3.10)
	 */ [(0, $9eJ96.UNTIL)]: (rule, value)=>{
        const until = (0, $eZDAP.default)(value);
        return Object.assign(rule, {
            until: (0, $jovBr.default)(until) ? until : undefined
        });
    }
};
const $8e2e4182ac5ec8be$var$getRuleParser = $8e2e4182ac5ec8be$var$getParser($8e2e4182ac5ec8be$var$recurrenceRuleParsers, (0, $aYpRI.toRuleProperty));
function $8e2e4182ac5ec8be$var$parseRecurrenceRule(line) {
    const ruleParts = line.split(':');
    const rules = ruleParts.slice(1).join(':').split(';');
    return rules.reduce((rule, property)=>{
        const [key, value] = property?.split('=');
        const parser = $8e2e4182ac5ec8be$var$getRuleParser(key);
        if (parser) return parser(rule, value);
        return rule;
    }, $8e2e4182ac5ec8be$var$getImmutableEmptyRRule());
}
const $8e2e4182ac5ec8be$var$eventParsers = {
    [(0, $9eJ96.DTSTART)]: (event, line)=>{
        const dtstart = $8e2e4182ac5ec8be$var$parseDateTime(line);
        return Object.assign(event, {
            dtstart: dtstart
        });
    },
    [(0, $9eJ96.RRULE)]: (event, line)=>{
        return Object.assign(event, {
            rrule: $8e2e4182ac5ec8be$var$parseRecurrenceRule(line)
        });
    }
};
const $8e2e4182ac5ec8be$var$getEventParser = $8e2e4182ac5ec8be$var$getParser($8e2e4182ac5ec8be$var$eventParsers, (0, $aYpRI.toICalField));
function $8e2e4182ac5ec8be$export$98e6a39c04603d36(iCalString) {
    const validationResults = (0, $17IU1.validate)(iCalString);
    if (!validationResults.isValid) return {
        ...validationResults,
        event: undefined
    };
    const event = iCalString?.replace((0, $9eJ96.FOLD_LINES_REGEX), '')?.split((0, $9eJ96.NEWLINE_REGEX))?.reduce((entity, line)=>{
        const trimmedLine = line?.trim();
        const property = trimmedLine?.split(':')?.[0]?.split(';')?.[0];
        const parser = $8e2e4182ac5ec8be$var$getEventParser(property);
        if (parser) return parser(entity, trimmedLine);
        return entity;
    }, $8e2e4182ac5ec8be$var$getImmutableEmptyEvent()) ?? undefined;
    return {
        ...validationResults,
        event: event
    };
}

});
parcelRegister("aYpRI", function(module, exports) {

$parcel$export(module.exports, "isString", () => $6d6cc808da293e3f$export$844ec244b1367d54);
$parcel$export(module.exports, "isNumber", () => $6d6cc808da293e3f$export$7e4aa119212bc614);
$parcel$export(module.exports, "isValidFrequency", () => $6d6cc808da293e3f$export$e4b0ccfd811c5f2a);
$parcel$export(module.exports, "isValidInterval", () => $6d6cc808da293e3f$export$1e497596c4c1da4e);
$parcel$export(module.exports, "isValidByDayValue", () => $6d6cc808da293e3f$export$8f8ef4406ade3e1b);
$parcel$export(module.exports, "isValidMonth", () => $6d6cc808da293e3f$export$9ca0186054ade692);
$parcel$export(module.exports, "isValidMonthDay", () => $6d6cc808da293e3f$export$76fa0aaa669329ba);
$parcel$export(module.exports, "isValidHour", () => $6d6cc808da293e3f$export$8039dc2a357e7bd5);
$parcel$export(module.exports, "isValidMinute", () => $6d6cc808da293e3f$export$f5f06c31fe5f5f48);
$parcel$export(module.exports, "isValidSecond", () => $6d6cc808da293e3f$export$f1d5b2f47f6eefbf);
$parcel$export(module.exports, "toDTStartProperty", () => $6d6cc808da293e3f$export$3e42ebbc2aaae59e);
$parcel$export(module.exports, "toRuleProperty", () => $6d6cc808da293e3f$export$6cd27d83ed07d519);
$parcel$export(module.exports, "isICalField", () => $6d6cc808da293e3f$export$44d7b50cf3c64bfb);
$parcel$export(module.exports, "toICalField", () => $6d6cc808da293e3f$export$1d256e213d35f1ce);
$parcel$export(module.exports, "toICalSupportedField", () => $6d6cc808da293e3f$export$5ce5ba2d94b3dc8b);
$parcel$export(module.exports, "toNewLineCharacter", () => $6d6cc808da293e3f$export$d2af3c6f67b82f45);
$parcel$export(module.exports, "extractTZID", () => $6d6cc808da293e3f$export$75774fe827de017b);
$parcel$export(module.exports, "formatValidationResult", () => $6d6cc808da293e3f$export$ffb0c8d5edd1dbde);

var $9eJ96 = parcelRequire("9eJ96");
function $6d6cc808da293e3f$export$844ec244b1367d54(value) {
    return typeof value === 'string';
}
function $6d6cc808da293e3f$export$7e4aa119212bc614(value) {
    return typeof value === 'number';
}
const $6d6cc808da293e3f$export$5776f4809341b9a6 = (value)=>$6d6cc808da293e3f$export$844ec244b1367d54(value) || $6d6cc808da293e3f$export$7e4aa119212bc614(value) ? !Number.isNaN(Number(value)) && Number(value) >= 0 : false;
function $6d6cc808da293e3f$export$e4b0ccfd811c5f2a(frequency) {
    return $6d6cc808da293e3f$export$844ec244b1367d54(frequency) ? frequency in (0, $9eJ96.Frequencies) : false;
}
function $6d6cc808da293e3f$export$1e497596c4c1da4e(interval) {
    if ($6d6cc808da293e3f$export$844ec244b1367d54(interval) || $6d6cc808da293e3f$export$7e4aa119212bc614(interval)) {
        const intervalNumber = Number(interval);
        return $6d6cc808da293e3f$export$5776f4809341b9a6(intervalNumber) && intervalNumber > 0;
    }
    return false;
}
function $6d6cc808da293e3f$export$8f8ef4406ade3e1b(day) {
    return $6d6cc808da293e3f$export$844ec244b1367d54(day) ? day in (0, $9eJ96.Days) : false;
}
function $6d6cc808da293e3f$export$b4280dbfdd3f6b25(days) {
    return days.every($6d6cc808da293e3f$export$8f8ef4406ade3e1b) ? days : [];
}
function $6d6cc808da293e3f$export$9ca0186054ade692(month) {
    if ($6d6cc808da293e3f$export$844ec244b1367d54(month) || $6d6cc808da293e3f$export$7e4aa119212bc614(month)) {
        const monthNumber = Number(month);
        return $6d6cc808da293e3f$export$5776f4809341b9a6(month) && monthNumber >= 1 && monthNumber <= 12;
    }
    return false;
}
function $6d6cc808da293e3f$export$76fa0aaa669329ba(day) {
    if ($6d6cc808da293e3f$export$844ec244b1367d54(day) || $6d6cc808da293e3f$export$7e4aa119212bc614(day)) {
        const dayNumber = Number(day);
        return $6d6cc808da293e3f$export$5776f4809341b9a6(dayNumber) && dayNumber >= 1 && dayNumber <= 31;
    }
    return false;
}
function $6d6cc808da293e3f$export$8039dc2a357e7bd5(hour) {
    if ($6d6cc808da293e3f$export$844ec244b1367d54(hour) || $6d6cc808da293e3f$export$7e4aa119212bc614(hour)) {
        const hourNumber = Number(hour);
        return $6d6cc808da293e3f$export$5776f4809341b9a6(hourNumber) && hourNumber >= 0 && hourNumber <= 23;
    }
    return false;
}
function $6d6cc808da293e3f$export$f5f06c31fe5f5f48(minute) {
    if ($6d6cc808da293e3f$export$844ec244b1367d54(minute) || $6d6cc808da293e3f$export$7e4aa119212bc614(minute)) {
        const minuteNumber = Number(minute);
        return $6d6cc808da293e3f$export$5776f4809341b9a6(minuteNumber) && minuteNumber >= 0 && minuteNumber <= 59;
    }
    return false;
}
function $6d6cc808da293e3f$export$f1d5b2f47f6eefbf(second) {
    if ($6d6cc808da293e3f$export$844ec244b1367d54(second) || $6d6cc808da293e3f$export$7e4aa119212bc614(second)) {
        const secondNumber = Number(second);
        return $6d6cc808da293e3f$export$5776f4809341b9a6(secondNumber) && secondNumber >= 0 && secondNumber <= 59;
    }
    return false;
}
function $6d6cc808da293e3f$var$isProperty(key, properties) {
    return key in properties;
}
function $6d6cc808da293e3f$var$toProperty(key, properties) {
    return $6d6cc808da293e3f$var$isProperty(key, properties) ? key : undefined;
}
function $6d6cc808da293e3f$export$3e42ebbc2aaae59e(key) {
    return $6d6cc808da293e3f$var$toProperty(key, (0, $9eJ96.DTStartProperties));
}
function $6d6cc808da293e3f$export$6cd27d83ed07d519(key) {
    return $6d6cc808da293e3f$var$toProperty(key, (0, $9eJ96.RRuleProperties));
}
function $6d6cc808da293e3f$export$44d7b50cf3c64bfb(key) {
    return $6d6cc808da293e3f$var$isProperty(key?.toUpperCase(), (0, $9eJ96.ICalSpecificationFields));
}
function $6d6cc808da293e3f$export$1d256e213d35f1ce(key) {
    return $6d6cc808da293e3f$var$toProperty(key, (0, $9eJ96.ICalSpecificationFields));
}
function $6d6cc808da293e3f$export$5ce5ba2d94b3dc8b(key) {
    return $6d6cc808da293e3f$var$toProperty(key, (0, $9eJ96.ICalSupportedFields));
}
function $6d6cc808da293e3f$export$ffe15610ce589a6d(key) {
    return $6d6cc808da293e3f$var$isProperty(key, (0, $9eJ96.NewlineCharacters));
}
function $6d6cc808da293e3f$export$d2af3c6f67b82f45(key) {
    if ($6d6cc808da293e3f$export$ffe15610ce589a6d(key)) return (0, $9eJ96.NewlineCharacterValues)[key];
    return (0, $9eJ96.NewlineCharacterValues)[0, $9eJ96.LF];
}
function $6d6cc808da293e3f$export$75774fe827de017b(dtString) {
    if (dtString.includes('TZID=')) {
        const parts = dtString.split(':');
        return {
            dateTimeString: parts?.slice?.(1).join?.(':')?.trim(),
            timezone: parts?.[0]?.split('=')?.[1]?.trim()
        };
    }
    return {
        dateTimeString: dtString?.split?.(':')?.slice?.(1)?.join?.(':')?.trim(),
        timezone: undefined
    };
}
function $6d6cc808da293e3f$export$728db6aa583e4f8(errors) {
    return errors.map((error)=>Object.entries(error).map(([key, value])=>`${key}:${value}`).join(',')).join('; ');
}
function $6d6cc808da293e3f$export$ffb0c8d5edd1dbde(result) {
    const status = result?.isValid ? (0, $9eJ96.VALID) : (0, $9eJ96.INVALID);
    const output = [
        `[ICalendar ${status}]`
    ];
    if (result?.errors) output.push($6d6cc808da293e3f$export$728db6aa583e4f8(result.errors));
    return output.join(' ').trim();
}

});

parcelRegister("17IU1", function(module, exports) {

$parcel$export(module.exports, "validate", () => $3ee0ecea5bc6d39f$export$a22775fa5e2eebd9);

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $9eJ96 = parcelRequire("9eJ96");

var $aYpRI = parcelRequire("aYpRI");
const $3ee0ecea5bc6d39f$var$isValidMultiValue = (value, validator)=>{
    return value.split(',').every(validator);
};
const $3ee0ecea5bc6d39f$var$getValidator = (fieldKey, toProperty, validators)=>{
    const validatorKey = toProperty(fieldKey?.toUpperCase());
    return validatorKey ? validators[validatorKey] : undefined;
};
const $3ee0ecea5bc6d39f$var$ruleValidators = {
    [(0, $9eJ96.FREQ)]: (value)=>(0, $aYpRI.isValidFrequency)(value),
    [(0, $9eJ96.INTERVAL)]: (value)=>(0, $aYpRI.isValidInterval)(value),
    [(0, $9eJ96.BYHOUR)]: (value)=>$3ee0ecea5bc6d39f$var$isValidMultiValue(value, (0, $aYpRI.isValidHour)),
    [(0, $9eJ96.BYMINUTE)]: (value)=>$3ee0ecea5bc6d39f$var$isValidMultiValue(value, (0, $aYpRI.isValidMinute)),
    [(0, $9eJ96.BYSECOND)]: (value)=>$3ee0ecea5bc6d39f$var$isValidMultiValue(value, (0, $aYpRI.isValidSecond)),
    [(0, $9eJ96.BYDAY)]: (value)=>$3ee0ecea5bc6d39f$var$isValidMultiValue(value, (0, $aYpRI.isValidByDayValue)),
    [(0, $9eJ96.BYMONTHDAY)]: (value)=>$3ee0ecea5bc6d39f$var$isValidMultiValue(value, (0, $aYpRI.isValidMonthDay)),
    [(0, $9eJ96.BYMONTH)]: (value)=>$3ee0ecea5bc6d39f$var$isValidMultiValue(value, (0, $aYpRI.isValidMonth)),
    [(0, $9eJ96.UNTIL)]: (value)=>{
        const date = (0, $eZDAP.default)(value);
        return (0, $jovBr.default)(date);
    }
};
const $3ee0ecea5bc6d39f$var$getRuleValidators = (fieldKey)=>$3ee0ecea5bc6d39f$var$getValidator(fieldKey, (0, $aYpRI.toRuleProperty), $3ee0ecea5bc6d39f$var$ruleValidators);
const $3ee0ecea5bc6d39f$var$datetimeValidators = {
    [(0, $9eJ96.DTSTART)]: (value)=>{
        const date = (0, $eZDAP.default)(value);
        return (0, $jovBr.default)(date);
    },
    [(0, $9eJ96.TZID)]: (value)=>/^[A-Za-z_]+\/[A-Za-z_]+$/.test(value)
};
const $3ee0ecea5bc6d39f$var$getDateTimeValidator = (fieldKey)=>$3ee0ecea5bc6d39f$var$getValidator(fieldKey, (0, $aYpRI.toDTStartProperty), $3ee0ecea5bc6d39f$var$datetimeValidators);
function $3ee0ecea5bc6d39f$var$validateDateTime(fieldKey, dtString) {
    const { dateTimeString: dateTimeString, timezone: timezone } = (0, $aYpRI.extractTZID)(dtString);
    const invalidProperties = [];
    const datetime = dateTimeString.trim();
    const datetimeValidator = $3ee0ecea5bc6d39f$var$getDateTimeValidator(fieldKey);
    if (!datetimeValidator || !datetimeValidator(datetime)) invalidProperties.push({
        [fieldKey]: dateTimeString
    });
    if (timezone !== undefined) {
        const timezoneValidator = $3ee0ecea5bc6d39f$var$datetimeValidators[0, $9eJ96.TZID];
        if (!timezone || !timezoneValidator(timezone)) invalidProperties.push({
            TZID: timezone || ''
        });
    }
    return {
        isValid: invalidProperties.length === 0,
        errors: invalidProperties
    };
}
function $3ee0ecea5bc6d39f$export$e27934b757bd86db(dtstartString) {
    return $3ee0ecea5bc6d39f$var$validateDateTime((0, $9eJ96.DTSTART), dtstartString);
}
function $3ee0ecea5bc6d39f$export$ab7531293d65d454(rruleString) {
    if (!rruleString?.toUpperCase().startsWith(`${(0, $9eJ96.RRULE)}:`)) return {
        isValid: false,
        errors: [
            {
                RRULE: rruleString
            }
        ]
    };
    const ruleBody = rruleString.split(':')?.[1];
    if (!ruleBody) return {
        isValid: false,
        errors: [
            {
                RRULE: rruleString
            }
        ]
    };
    const rules = ruleBody.split(';');
    let hasFrequency = false;
    const invalidProperties = [];
    const isValidRecurrenceRule = rules.every((rule)=>{
        const [key, value] = rule.split('=');
        const upperCaseKey = key?.toUpperCase();
        if (!key || !value) {
            invalidProperties.push({
                [key || 'invalidKey']: value || 'invalidValue'
            });
            return false;
        }
        const validator = $3ee0ecea5bc6d39f$var$getRuleValidators(upperCaseKey);
        if (!validator || !validator(value)) {
            invalidProperties.push({
                [key]: value
            });
            return false;
        }
        if (upperCaseKey === (0, $9eJ96.FREQ)) hasFrequency = true;
        return true;
    });
    if (!hasFrequency && invalidProperties.length === 0) invalidProperties.push({
        FREQ: (0, $9eJ96.MISSING)
    });
    return {
        isValid: isValidRecurrenceRule && hasFrequency,
        errors: invalidProperties
    };
}
const $3ee0ecea5bc6d39f$var$eventSupportedFieldValidators = {
    [(0, $9eJ96.DTSTART)]: $3ee0ecea5bc6d39f$export$e27934b757bd86db,
    [(0, $9eJ96.RRULE)]: $3ee0ecea5bc6d39f$export$ab7531293d65d454
};
const $3ee0ecea5bc6d39f$var$getICalSupportedFieldValidator = (fieldKey)=>{
    const validatorKey = (0, $aYpRI.toICalSupportedField)(fieldKey?.toUpperCase());
    return validatorKey ? $3ee0ecea5bc6d39f$var$eventSupportedFieldValidators[validatorKey] : undefined;
};
function $3ee0ecea5bc6d39f$export$a22775fa5e2eebd9(iCalString) {
    if (!iCalString || iCalString.trim() === '') return {
        isValid: false,
        errors: [
            {
                ICAL_STRING: (0, $9eJ96.EMPTY)
            }
        ]
    };
    const errors = iCalString?.replace((0, $9eJ96.FOLD_LINES_REGEX), '')?.split((0, $9eJ96.NEWLINE_REGEX))?.map((line)=>line.trim())?.filter(Boolean)?.flatMap((line)=>{
        const [property] = line?.split(':')?.[0]?.split(';');
        const upperCaseProperty = property?.toUpperCase();
        const validator = $3ee0ecea5bc6d39f$var$getICalSupportedFieldValidator(upperCaseProperty);
        if (validator) {
            const validationResult = validator(line);
            return validationResult.isValid ? [] : validationResult.errors;
        }
        return (0, $aYpRI.isICalField)(upperCaseProperty) ? [] : [
            {
                ICAL_STRING: (0, $9eJ96.INVALID)
            }
        ];
    }) ?? [];
    return {
        isValid: errors.length === 0,
        errors: errors
    };
}

});


parcelRegister("4anLj", function(module, exports) {

$parcel$export(module.exports, "useIsProjectAdmin", () => $28cdc31165a564f1$export$9facd8d31b938a25);

var $dAfqg = parcelRequire("dAfqg");
const $28cdc31165a564f1$export$9facd8d31b938a25 = ()=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    return !!data?.isProjectAdmin;
};

});

const $f60a10b809e51afa$export$b887e88d8d0739f6 = 'BUTTON';
const $f60a10b809e51afa$export$fec55ff920461811 = 'MENU_ITEM';
const $f60a10b809e51afa$export$6670546ab560a9dd = '.ui.button-item';


parcelRegister("7ATHt", function(module, exports) {

$parcel$export(module.exports, "AutomationSubMenu", () => $a3e590e14dbef084$export$e5156046660dc32a);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $4mNf3 = parcelRequire("4mNf3");

var $5LWLA = parcelRequire("5LWLA");

var $eZJjh = parcelRequire("eZJjh");

var $3bDjY = parcelRequire("3bDjY");

var $bUmQV = parcelRequire("bUmQV");

var $cmvab = parcelRequire("cmvab");

var $9JG4b = parcelRequire("9JG4b");

var $1noc6 = parcelRequire("1noc6");

var $bMvRM = parcelRequire("bMvRM");

var $koVbs = parcelRequire("koVbs");

var $dXq4S = parcelRequire("dXq4S");

var $2OMDV = parcelRequire("2OMDV");

var $koeKL = parcelRequire("koeKL");

var $9g7AR = parcelRequire("9g7AR");

var $iB7zz = parcelRequire("iB7zz");
const $a3e590e14dbef084$export$c0117b1abc6c64e3 = (0, $2OMDV.AnalyticsEventToProps)('dropdownItem', {
    onClick: 'clicked'
})((0, $6B7KL.default));
const $a3e590e14dbef084$export$41fc372f12f35c64 = ({ issueId: issueId, executingRule: executingRule, rules: rules, onExecuteRule: onExecuteRule })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const issueAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId ? issueId.toString() : ''
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, rules.map((rule)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            key: rule.id,
            content: rule.name
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3e590e14dbef084$export$c0117b1abc6c64e3, {
            testId: `issue-field-status.ui.status-view.actions.actions-menu.rule-${rule.id}`,
            role: "button",
            onClick: ()=>onExecuteRule(rule.id, [
                    issueAri
                ]),
            elemBefore: executingRule === rule.id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1noc6.MenuIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
                size: "small"
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1noc6.TriggerIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
                size: "small",
                glyph: (0, $1noc6.ManualTriggerGlyph),
                label: ""
            }))
        }, rule.name))));
};
const $a3e590e14dbef084$export$e5156046660dc32a = (props)=>{
    const { initialised: initialised, rules: rules, transitions: transitions, baseAutomationUrl: baseAutomationUrl, canManageAutomations: canManageAutomations, executeRule: executeRule, executingRule: executingRule, issueKey: issueKey, issueId: issueId } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const shouldShowRulesList = initialised && rules.length > 0;
    const shouldShowEmptyState = initialised && rules.length === 0 && transitions.length === 0;
    if (!initialised) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9g7AR.Skeleton), null);
    if (shouldShowRulesList) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, canManageAutomations && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4mNf3.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        alignItems: "center",
        gap: "space.100"
    }, formatMessage((0, $iB7zz.default).manualRules), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cmvab.PaidFeatureAwarenessRenderer), {
        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9JG4b.PaidFeatureAwarenessPremiumLozenge), null),
        placement: "automation.submenu"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3e590e14dbef084$export$41fc372f12f35c64, {
        rules: rules,
        onExecuteRule: executeRule,
        issueKey: issueKey,
        issueId: issueId,
        executingRule: executingRule
    }));
    if (shouldShowEmptyState) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4mNf3.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        alignItems: "center",
        gap: "space.100"
    }, formatMessage((0, $iB7zz.default).manualRules), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cmvab.PaidFeatureAwarenessRenderer), {
        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9JG4b.PaidFeatureAwarenessPremiumLozenge), null),
        placement: "automation.submenu"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bMvRM.ManualRulesEmptyState), {
        baseAutomationUrl: baseAutomationUrl,
        canManageAutomations: canManageAutomations,
        createAutomationComponentFilter: "QUICK_ACTIONS"
    })));
    return null;
};
var $a3e590e14dbef084$export$2e2bcd8739ae039 = $a3e590e14dbef084$export$e5156046660dc32a;

});
parcelRegister("cmvab", function(module, exports) {

$parcel$export(module.exports, "PaidFeatureAwarenessRenderer", () => $3d319632a25c0850$export$64aa988820df8e0f);

var $b6HdT = parcelRequire("b6HdT");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $hYRTO = parcelRequire("hYRTO");

var $cLXfT = parcelRequire("cLXfT");

var $k9JTq = parcelRequire("k9JTq");

var $5oBMG = parcelRequire("5oBMG");

var $ldyPw = parcelRequire("ldyPw");


var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $koeKL = parcelRequire("koeKL");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
const $3d319632a25c0850$export$dc50189dfb775e17 = (props)=>{
    const { component: component } = props;
    const cloudId = (0, $koeKL.useCloudId)();
    const hamsProductKey = (0, $cLXfT.getHamsProductKey)((0, $c06e1abca7c13910$export$1346c9aa3cbb477d));
    const data = (0, $8Uumt.useLazyLoadQuery)((0, $b6HdT.default), {
        cloudId: cloudId,
        hamsProductKey: hamsProductKey
    });
    const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
    const hasPaymentDetails = entitlement?.transactionAccount?.isBillToPresent === true;
    if (hasPaymentDetails !== false) return props.fallback;
    return (0, $6s1PB.expValEquals)('persistent_paid_feature_awareness_ab', 'cohort', 'variation', 'not-enrolled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "paidFeatureAwareness",
        attributes: {
            placement: props.placement
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), component) : props.fallback;
};
const $3d319632a25c0850$export$43f5a9f3669b7084 = (props)=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions.software;
    const productEntitlementDetails = (0, $5oBMG.useProductEntitlementDetails)();
    const jswEntitlementDetails = productEntitlementDetails?.[0, $c06e1abca7c13910$export$1346c9aa3cbb477d];
    const trialEndTime = jswEntitlementDetails?.trialEndTime;
    const currentDate = (0, $5uXOq.useMemo)(()=>Date.now(), []);
    const isOnJSWTrial = Boolean(trialEndTime && currentDate < trialEndTime);
    /** Eligibility criteria (in order of evaluation)
   * - FG must be on
   * - Must be on JSW Premium Trial
   * - Must not have payment details entered (obtained via query)
   * - Must be in variation for experiment (fire exposure at this point)
   */ const isOnJswPremiumTrial = jswEdition === (0, $ldyPw.PREMIUM_EDITION) && isOnJSWTrial;
    return isOnJswPremiumTrial ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3d319632a25c0850$export$dc50189dfb775e17, props) : props.fallback;
};
const $3d319632a25c0850$export$64aa988820df8e0f = (props)=>{
    const { fallback: fallback = null, ...rest } = props;
    return (0, $4R6GH.fg)('persistent_paid_feature_awareness') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "paidFeatureAwarenessBoundary",
        packageName: "@atlassian/jira-paid-feature-awareness-renderer",
        fallback: fallback ? ()=>fallback : 'unmount',
        teamName: "growth-tako",
        sendToPrivacyUnsafeSplunk: true,
        attributes: {
            placement: props.placement
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
        name: "paid-feature-awareness-renderer-placeholder",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3d319632a25c0850$export$43f5a9f3669b7084, {
        fallback: fallback,
        ...rest
    }))) : fallback;
};

});
parcelRegister("b6HdT", function(module, exports) {

$parcel$export(module.exports, "default", () => $96fb09f2fb680d6a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c65e158836bb825b8b10729b53579e23>>
 * @relayHash dd332bbc60ac1be709db56083c130987
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 41d0bebb795cea640c8555aa4316be536054f8f7c4f0550009867fc14f76adf5
const $96fb09f2fb680d6a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isBillToPresent"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "uiGetPaymentDetailsEnteredQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "uiGetPaymentDetailsEnteredQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "41d0bebb795cea640c8555aa4316be536054f8f7c4f0550009867fc14f76adf5",
            "metadata": {},
            "name": "uiGetPaymentDetailsEnteredQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$96fb09f2fb680d6a$var$node.hash = "cd9ff36ba318610ca3a732f7742e9802";
var $96fb09f2fb680d6a$export$2e2bcd8739ae039 = $96fb09f2fb680d6a$var$node;

});

parcelRegister("cLXfT", function(module, exports) {

$parcel$export(module.exports, "getHamsProductKey", () => $be23717f2b4b385d$export$413aba2429285627);
$parcel$export(module.exports, "getHamsProductKeyForProject", () => $be23717f2b4b385d$export$74f585c1245fa1a4);


var $1laI5 = parcelRequire("1laI5");
const $be23717f2b4b385d$export$413aba2429285627 = (applicationKey)=>{
    // JPD key does not have '.ondemand'
    if (applicationKey === (0, $c06e1abca7c13910$export$202f50ee62667e32)) return applicationKey;
    return `${applicationKey}.ondemand`;
};
const $be23717f2b4b385d$export$74f585c1245fa1a4 = (project)=>{
    const application = (0, $1laI5.projectToApplicationKey)(project);
    return $be23717f2b4b385d$export$413aba2429285627(application);
};

});
const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';

parcelRegister("1laI5", function(module, exports) {

$parcel$export(module.exports, "getTrialDaysLeft", () => $39ed199f3e5d9f33$export$954628993bf3188e);
$parcel$export(module.exports, "projectToApplicationKey", () => $39ed199f3e5d9f33$export$1af4fd6f5c543149);

var $2vSU6 = parcelRequire("2vSU6");

const $39ed199f3e5d9f33$export$9dbbf537dffaafc7 = (timestamp)=>new Date(timestamp).setUTCHours(0, 0, 0, 0);
const $39ed199f3e5d9f33$export$954628993bf3188e = (trialEndTime)=>trialEndTime && Math.ceil(($39ed199f3e5d9f33$export$9dbbf537dffaafc7(trialEndTime) - Date.now()) / 86400000);
const $39ed199f3e5d9f33$export$271517afaa0c15eb = (trialEndTime)=>{
    const trialDaysLeft = $39ed199f3e5d9f33$export$954628993bf3188e(trialEndTime);
    // Technically we do not know whether user is in grace period or not, but if user is able to access the Jira with no payment details
    // and is trialEndTime is missing or over we assume that site is in grace period
    return !trialDaysLeft || trialDaysLeft < 0;
};
const $39ed199f3e5d9f33$export$1af4fd6f5c543149 = (project)=>{
    switch(project){
        // With spork, we should update core projects as it they were Software projects
        case 0, $2vSU6.SOFTWARE_PROJECT:
        case 0, $2vSU6.CORE_PROJECT:
            return 0, $c06e1abca7c13910$export$1346c9aa3cbb477d;
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return 0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61;
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
            return 0, $c06e1abca7c13910$export$202f50ee62667e32;
        default:
            throw new Error(`Unsupported project: ${project}`);
    }
};

});


parcelRegister("5oBMG", function(module, exports) {

$parcel$export(module.exports, "useProductEntitlementDetails", () => $3295ae4955475ae4$export$e02d6385b5d47f5d);

var $9OXo1 = parcelRequire("9OXo1");
const $3295ae4955475ae4$export$e02d6385b5d47f5d = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.productEntitlementDetails || null;
};

});

// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("9JG4b", function(module, exports) {

$parcel$export(module.exports, "PaidFeatureAwarenessStandardLozenge", () => $2cc69a400fe5eaed$export$7ffe6b10a925635e);
$parcel$export(module.exports, "PaidFeatureAwarenessPremiumLozenge", () => $2cc69a400fe5eaed$export$c759caf4220d9852);

var $5uXOq = parcelRequire("5uXOq");

var $aYAc3 = parcelRequire("aYAc3");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $6J1YC = parcelRequire("6J1YC");
const $2cc69a400fe5eaed$export$7ffe6b10a925635e = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $6J1YC.default).standardTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: "new"
    }, formatMessage((0, $6J1YC.default).standardLozenge)));
};
const $2cc69a400fe5eaed$export$c759caf4220d9852 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $6J1YC.default).premiumTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: "new"
    }, formatMessage((0, $6J1YC.default).premiumLozenge)));
};

});
parcelRegister("6J1YC", function(module, exports) {

$parcel$export(module.exports, "default", () => $93f00b26671642aa$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $93f00b26671642aa$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    standardLozenge: {
        "id": "paid-feature-awareness.standard-lozenge",
        "defaultMessage": "Standard"
    },
    premiumLozenge: {
        "id": "paid-feature-awareness.premium-lozenge",
        "defaultMessage": "Premium"
    },
    standardGemTooltip: {
        "id": "paid-feature-awareness.standard-gem-tooltip",
        "defaultMessage": "This is a Standard and Premium plan feature"
    },
    standardTooltip: {
        "id": "paid-feature-awareness.standard-lozenge-tooltip",
        "defaultMessage": "This is a Standard plan feature"
    },
    premiumTooltip: {
        "id": "paid-feature-awareness.premium-tooltip",
        "defaultMessage": "This is a Premium plan feature"
    },
    automationTooltip: {
        "id": "paid-feature-awareness.automation-tooltip",
        "defaultMessage": "Automations varies by plan. Free: 100 rule runs/mo; Standard: 1,700 rule runs/mo; Premium: 1000 rule runs per user/mo"
    }
});

});


parcelRegister("1noc6", function(module, exports) {

$parcel$export(module.exports, "ManualTriggerGlyph", () => $6325cb76caa5baa0$export$4514e29f70245d75);
$parcel$export(module.exports, "MenuIcon", () => $6325cb76caa5baa0$export$46e1d66043f363e6);
$parcel$export(module.exports, "TriggerIcon", () => $6325cb76caa5baa0$export$1cb264166623d4aa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7paD5 = parcelRequire("7paD5");
const $6325cb76caa5baa0$export$4514e29f70245d75 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: 24,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m21.192 19.778-4.9498-4.9498c-0.3905-0.3905-1.0237-0.3905-1.4142 0-0.3905 0.3906-0.3905 1.0237 0 1.4143l4.9498 4.9497c0.3905 0.3905 1.0237 0.3905 1.4142 0s0.3905-1.0237 0-1.4142z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m8.7738 8.1319 11.685 4.305c0.2591 0.0955 0.3917 0.3829 0.2963 0.6421-0.025 0.0679-0.0645 0.1295-0.1156 0.1807l-7.3802 7.3801c-0.1952 0.1953-0.5118 0.1953-0.7071 0-0.0511-0.0512-0.0906-0.1128-0.1156-0.1807l-4.3051-11.685c-0.09546-0.25911 0.03721-0.54656 0.29632-0.64202 0.11157-0.0411 0.23414-0.0411 0.34571 0z",
        clipRule: "evenodd",
        fill: "currentColor",
        fillRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m4.2218 4.2218c1.9526-1.9526 5.1184-1.9526 7.0711 0 0.5977 0.59776 1.0125 1.3092 1.2443 2.0648 0.1974 0.6437-0.4389 1.1502-1.0873 0.96899l-0.2172-0.06069c-0.3475-0.09709-0.6037-0.38008-0.7563-0.70702-0.1439-0.30836-0.3432-0.59728-0.59773-0.85184-1.1716-1.1716-3.0711-1.1716-4.2426 0-1.1716 1.1716-1.1716 3.0711 0 4.2426 0.2547 0.25469 0.54381 0.45399 0.85236 0.59799 0.32725 0.1527 0.61051 0.4091 0.70752 0.7569l0.06045 0.2168c0.18082 0.6483-0.32561 1.2843-0.96914 1.087-0.75578-0.2317-1.4675-0.6466-2.0654-1.2445-1.9526-1.9526-1.9526-5.1184 0-7.071z",
        clipRule: "evenodd",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $6325cb76caa5baa0$export$85ca00d4fc5d86c3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
        size: "small",
        ...props
    });
const $6325cb76caa5baa0$export$3b6023946faff8bc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M10.3789 4.62256C9.99914 4.62173 9.65331 4.84087 9.49192 5.18458L6.11523 12.3762C5.97308 12.679 5.9956 13.0334 6.17494 13.3157C6.35428 13.598 6.66553 13.7691 7 13.7691H8.79182L6.40251 18.1304C6.17135 18.5523 6.28163 19.0798 6.66249 19.3738C7.04335 19.6677 7.58152 19.6408 7.93117 19.3103L16.8269 10.902C17.1178 10.6269 17.2117 10.2023 17.0637 9.83032C16.9157 9.45832 16.5558 9.21418 16.1555 9.21418H14.547L17.0353 6.24031C17.2787 5.94947 17.3319 5.5441 17.1717 5.20034C17.0116 4.85658 16.6671 4.63646 16.2879 4.63562L10.3789 4.62256Z",
        stroke: "currentColor",
        strokeWidth: "1.95489",
        strokeLinejoin: "round"
    }));
const $6325cb76caa5baa0$export$fdd32c4638a0c3ae = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M10.1838 4.78749C10.2664 4.61167 10.4433 4.49957 10.6375 4.5L17.0011 4.51406C17.1951 4.51449 17.3713 4.62709 17.4532 4.80294C17.5352 4.97879 17.508 5.18614 17.3835 5.33492L13.9446 9.44482H16.8597C17.0645 9.44482 17.2486 9.5697 17.3243 9.76C17.4 9.95029 17.352 10.1675 17.2032 10.3082L7.62319 19.3634C7.44433 19.5324 7.16903 19.5462 6.97421 19.3958C6.77938 19.2454 6.72297 18.9756 6.84122 18.7598L9.86254 13.2448H7C6.82891 13.2448 6.66969 13.1573 6.57795 13.0129C6.48621 12.8685 6.47469 12.6872 6.54741 12.5323L10.1838 4.78749Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }));
const $6325cb76caa5baa0$export$9d08b452ddec60a4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M10.1838 4.78749C10.2664 4.61167 10.4433 4.49957 10.6375 4.5L17.0011 4.51406C17.1951 4.51449 17.3713 4.62709 17.4532 4.80294C17.5352 4.97879 17.508 5.18614 17.3835 5.33492L13.9446 9.44482H16.8597C17.0645 9.44482 17.2486 9.5697 17.3243 9.76C17.4 9.95029 17.352 10.1675 17.2032 10.3082L7.62319 19.3634C7.44433 19.5324 7.16903 19.5462 6.97421 19.3958C6.77938 19.2454 6.72297 18.9756 6.84122 18.7598L9.86254 13.2448H7C6.82891 13.2448 6.66969 13.1573 6.57795 13.0129C6.48621 12.8685 6.47469 12.6872 6.54741 12.5323L10.1838 4.78749Z",
        fill: "var(--ds-text, #172B4D)"
    }));
const $6325cb76caa5baa0$export$46e1d66043f363e6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _1bsb1tcg _4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $6325cb76caa5baa0$export$1cb264166623d4aa = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $6325cb76caa5baa0$export$46e1d66043f363e6, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz17hp _bfhkn729",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bMvRM", function(module, exports) {

$parcel$export(module.exports, "ManualRulesEmptyState", () => $8d9f2e4f90fecd15$export$e17d6e5a8bfa991e);

var $5uXOq = parcelRequire("5uXOq");

var $8R2Rd = parcelRequire("8R2Rd");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $8d9f2e4f90fecd15$export$e17d6e5a8bfa991e = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { baseAutomationUrl: baseAutomationUrl, createAutomationComponentFilter: createAutomationComponentFilter, canManageAutomations: canManageAutomations } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8R2Rd.ManualRulesEmptyState), {
        canManageAutomations: canManageAutomations,
        baseAutomationUrl: baseAutomationUrl,
        createAutomationComponentFilter: createAutomationComponentFilter,
        onEmptyStateCreateAutomationButtonClicked: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'button',
                action: 'clicked'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'manualRulesActionsMenu.emptyState.createAutomationButton', {
                userType: 'admin'
            });
        },
        onEmptyStateSeeTemplatesLinkClicked: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'button',
                action: 'clicked'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'manualRulesActionsMenu.emptyState.seeTemplatesLink', {
                userType: 'admin'
            });
        }
    });
};

});
parcelRegister("8R2Rd", function(module, exports) {

$parcel$export(module.exports, "ManualRulesEmptyState", () => $d5314fb0f6e7a6e8$export$e17d6e5a8bfa991e);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1GGwS = parcelRequire("1GGwS");

var $e4yMr = parcelRequire("e4yMr");

var $iKivd = parcelRequire("iKivd");

var $gLArq = parcelRequire("gLArq");

var $itjg4 = parcelRequire("itjg4");
const $d5314fb0f6e7a6e8$var$handleOptionalCallback = (optionalEvent)=>{
    if (optionalEvent) optionalEvent();
};
const $d5314fb0f6e7a6e8$export$e17d6e5a8bfa991e = (props)=>{
    const { baseAutomationUrl: baseAutomationUrl, canManageAutomations: canManageAutomations, createAutomationComponentFilter: createAutomationComponentFilter, onEmptyStateCreateAutomationButtonClicked: onEmptyStateCreateAutomationButtonClicked, onEmptyStateSeeTemplatesLinkClicked: onEmptyStateSeeTemplatesLinkClicked } = props;
    const componentFilter = createAutomationComponentFilter ? `?componentFilterCriteria=${createAutomationComponentFilter}` : '';
    const createNewRuleUrl = `${baseAutomationUrl}#/rule/new/__NEW__TRIGGER${componentFilter}`;
    const automationTemplateLibraryUrl = canManageAutomations ? `${baseAutomationUrl}#/tab/rule-library` : 'https://www.atlassian.com/software/jira/automation-template-library#/rule-list?systemLabelId=all&page=1&pageSize=20&sortKey=name&sortOrder=ASC';
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $itjg4.ManualRuleEmptyState), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $itjg4.EmptyStateIconContainer), {
                children: (0, $iKivd.emptyStateIcon)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $itjg4.Message), {
                children: (0, $gLArq.default).emptyStateMessage.defaultMessage
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $itjg4.Links), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $itjg4.ActionLink), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1GGwS.default), {
                            appearance: "default",
                            onClick: ()=>{
                                $d5314fb0f6e7a6e8$var$handleOptionalCallback(onEmptyStateCreateAutomationButtonClicked);
                            },
                            href: createNewRuleUrl,
                            isDisabled: !canManageAutomations,
                            testId: "empty-state-create-automation-button",
                            title: canManageAutomations ? undefined : (0, $gLArq.default).createAutomationsButtonTitle.defaultMessage,
                            children: (0, $gLArq.default).addManuallyTriggeredAutomation.defaultMessage
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $itjg4.ActionLink), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4yMr.default), {
                            onClick: ()=>{
                                $d5314fb0f6e7a6e8$var$handleOptionalCallback(onEmptyStateSeeTemplatesLinkClicked);
                            },
                            href: automationTemplateLibraryUrl,
                            testId: "empty-state-see-templates-link",
                            children: (0, $gLArq.default).seeTemplates.defaultMessage
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("iKivd", function(module, exports) {

$parcel$export(module.exports, "emptyStateIcon", () => $4d328e903cb38247$export$639b28b9524fd6f0);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $4d328e903cb38247$export$639b28b9524fd6f0 = /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
    width: "313",
    height: "215",
    viewBox: "0 0 313 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M146.296 0.793168C183.809 4.00611 210.17 26.1894 237.711 45.7988C266.71 66.447 301.378 85.3411 307.01 115.226C313.293 148.564 305.832 189.973 268.25 207.848C231.892 225.141 189.127 193.51 146.296 191.668C108.52 190.042 68.5787 214.216 37.4175 197.917C4.57549 180.738 1.18294 145.502 0.153 115.226C-0.911134 83.9451 2.95664 50.6107 31.6423 28.1492C60.6366 5.44611 104.914 -2.75118 146.296 0.793168Z",
            fill: "var(--ds-background-accent-blue-subtlest, #E9F2FF)"
        }),
        /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            filter: "url(#filter0_dd_1968_47879)",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    x: "21",
                    y: "15",
                    width: "280",
                    height: "180",
                    rx: "8",
                    fill: "var(--ds-surface, white)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    x: "207",
                    y: "46.5",
                    width: "77",
                    height: "14",
                    rx: "2",
                    fill: "var(--ds-background-accent-blue-subtlest, #E9F2FF)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    x: "208",
                    y: "47.5",
                    width: "12",
                    height: "12",
                    rx: "4",
                    fill: "var(--ds-background-accent-blue-subtlest, #E9F2FF)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    d: "M215 50L213 57",
                    stroke: "var(--ds-icon-accent-blue, #1D7AFC)",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    d: "M215 50L211.5 53.5H216.5L213 57",
                    stroke: "var(--ds-icon-accent-blue, #1D7AFC)",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    x: "207",
                    y: "46.5",
                    width: "77",
                    height: "14",
                    rx: "2",
                    stroke: "var(--ds-border-focused, #388BFF)",
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    x: "37",
                    y: "45.5",
                    width: "155",
                    height: "16",
                    rx: "3",
                    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    x: "37",
                    y: "71.5",
                    width: "155",
                    height: "28",
                    rx: "3",
                    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    x: "37",
                    y: "109.5",
                    width: "17",
                    height: "17",
                    rx: "8.5",
                    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    x: "58",
                    y: "113.5",
                    width: "27",
                    height: "9",
                    rx: "3",
                    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    x: "89",
                    y: "113.5",
                    width: "27",
                    height: "9",
                    rx: "3",
                    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    x: "120",
                    y: "113.5",
                    width: "27",
                    height: "9",
                    rx: "3",
                    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    x: "37",
                    y: "136.5",
                    width: "133",
                    height: "9",
                    rx: "3",
                    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    x: "37",
                    y: "155.5",
                    width: "89",
                    height: "9",
                    rx: "3",
                    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
                })
            ]
        }),
        /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)("filter", {
                id: "filter0_dd_1968_47879",
                x: "9",
                y: "11",
                width: "304",
                height: "204",
                filterUnits: "userSpaceOnUse",
                colorInterpolationFilters: "sRGB",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("feFlood", {
                        floodOpacity: "0",
                        result: "BackgroundImageFix"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("feColorMatrix", {
                        in: "SourceAlpha",
                        type: "matrix",
                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                        result: "hardAlpha"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("feOffset", {}),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("feGaussianBlur", {
                        stdDeviation: "0.5"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("feColorMatrix", {
                        type: "matrix",
                        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("feBlend", {
                        mode: "normal",
                        in2: "BackgroundImageFix",
                        result: "effect1_dropShadow_1968_47879"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("feColorMatrix", {
                        in: "SourceAlpha",
                        type: "matrix",
                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                        result: "hardAlpha"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("feOffset", {
                        dy: "8"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("feGaussianBlur", {
                        stdDeviation: "6"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("feColorMatrix", {
                        type: "matrix",
                        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.15 0"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("feBlend", {
                        mode: "normal",
                        in2: "effect1_dropShadow_1968_47879",
                        result: "effect2_dropShadow_1968_47879"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("feBlend", {
                        mode: "normal",
                        in: "SourceGraphic",
                        in2: "effect2_dropShadow_1968_47879",
                        result: "shape"
                    })
                ]
            })
        })
    ]
});

});

parcelRegister("gLArq", function(module, exports) {

$parcel$export(module.exports, "default", () => $905fe42a37f07961$export$2e2bcd8739ae039);
const $905fe42a37f07961$var$messages = {
    emptyStateMessage: {
        id: 'automation-platform.manual-rules-empty-state.empty-state-message-new',
        defaultMessage: 'Create an automation to perform tasks with the click of a button. Once created, manually triggered automations will appear here.',
        description: 'The message to show when there is no manual rule'
    },
    addManuallyTriggeredAutomation: {
        id: 'automation-platform.manual-rules-empty-state.add-manually-triggered-automation',
        defaultMessage: 'Add manually triggered automation',
        description: 'Link to the page to create automations'
    },
    seeTemplates: {
        id: 'automation-platform.manual-rules-empty-state.see-templates',
        defaultMessage: 'See templates',
        description: 'Link to the page to see the automation templates'
    },
    createAutomationsButtonTitle: {
        id: 'automation-platform.manual-rules-empty-state.create-automations-button-title',
        defaultMessage: 'You must be a project admin to create automations',
        description: 'The title to show for create automations button'
    }
};
var $905fe42a37f07961$export$2e2bcd8739ae039 = $905fe42a37f07961$var$messages;

});

parcelRegister("itjg4", function(module, exports) {

$parcel$export(module.exports, "ManualRuleEmptyState", () => $49f280f65fcb451b$export$5ef19aedb65f813a);
$parcel$export(module.exports, "Message", () => $49f280f65fcb451b$export$f69c19e57285b83a);
$parcel$export(module.exports, "Links", () => $49f280f65fcb451b$export$b2e089eb3692b073);
$parcel$export(module.exports, "ActionLink", () => $49f280f65fcb451b$export$51485461e6c971ae);
$parcel$export(module.exports, "EmptyStateIconContainer", () => $49f280f65fcb451b$export$8a3dea5ee464347b);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $49f280f65fcb451b$export$5ef19aedb65f813a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12fp59q",
            __cmplp.className
        ])
    });
});
const $49f280f65fcb451b$export$f69c19e57285b83a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _zg8l4jg8 _1e0c1txw _4cvr1h6o _y3gn1h6o _19pk19bv _2hwxv47k _otyr19bv _18u0v47k _syaz1ddj",
            __cmplp.className
        ])
    });
});
const $49f280f65fcb451b$export$b2e089eb3692b073 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66 _19pk1mwd _1bah1h6o _1e0c11p5 _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $49f280f65fcb451b$export$51485461e6c971ae = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1wmz _2hwx1wmz _otyr1wmz _18u01wmz",
            __cmplp.className
        ])
    });
});
const $49f280f65fcb451b$export$8a3dea5ee464347b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3ipo3b _1bsb1mjv _19pkv47k _2hwxv47k _otyrv47k _18u0v47k",
            __cmplp.className
        ])
    });
});

});



parcelRegister("9g7AR", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $f0a8168eb14215a7$export$8f31e4c4a37b8e9c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1noc6 = parcelRequire("1noc6");
const $f0a8168eb14215a7$export$9ea727bd75377e4c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f0a8168eb14215a7$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1noc6.MenuIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f0a8168eb14215a7$var$SkeletonIcon, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f0a8168eb14215a7$var$SkeletonText, null));
const $f0a8168eb14215a7$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f0a8168eb14215a7$export$9ea727bd75377e4c, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f0a8168eb14215a7$export$9ea727bd75377e4c, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f0a8168eb14215a7$export$9ea727bd75377e4c, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f0a8168eb14215a7$export$9ea727bd75377e4c, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f0a8168eb14215a7$export$9ea727bd75377e4c, null));
var $f0a8168eb14215a7$export$2e2bcd8739ae039 = $f0a8168eb14215a7$export$8f31e4c4a37b8e9c;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f0a8168eb14215a7$var$SkeletonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc _2hwxv47k _otyru2gc _18u0v47k _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $f0a8168eb14215a7$var$SkeletonIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _189eyh40 _1dqonqa1 _1h6d3acm _1bsb7vkz _4t3i7vkz _1e0c1o8l _bfhk1r31 _tzy4nh7s",
            __cmplp.className
        ])
    });
});
const $f0a8168eb14215a7$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f0a8168eb14215a7$var$SkeletonText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbp3fh _4t3i7vkz _19pk1b66 _18u0utpp _5sag9cwz _1o51q7pw _tip812c5 _j7hq1nls _1pglp3kn _bfhkn82g _1itk1kpv _12vemgnk",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iB7zz", function(module, exports) {

$parcel$export(module.exports, "default", () => $40e848f463c7648a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $40e848f463c7648a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    manualRules: {
        "id": "issue-field-status.status-view.actions.actions-menu.automation-submenu.manual-rules",
        "defaultMessage": "From Automation"
    }
});

});


parcelRegister("3ihJD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f42e97e576f5978$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0f42e97e576f5978$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    automation: {
        "id": "issue-field-status.status-view.actions.actions-menu.automation",
        "defaultMessage": "Automation"
    },
    actions: {
        "id": "issue-field-status.status-view.actions.actions-menu.actions",
        "defaultMessage": "Actions"
    },
    manualRules: {
        "id": "issue-field-status.status-view.actions.actions-menu.manual-rules",
        "defaultMessage": "From Automation"
    },
    workflowTransitions: {
        "id": "issue-field-status.status-view.actions.actions-menu.workflow-transitions",
        "defaultMessage": "From Workflow"
    }
});

});

parcelRegister("1MVgQ", function(module, exports) {

$parcel$export(module.exports, "TransitionsSubMenu", () => $1c26f090eaa43df4$export$d6b4ae7200493213);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $2OMDV = parcelRequire("2OMDV");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $kIfyk = parcelRequire("kIfyk");
const $1c26f090eaa43df4$export$c0117b1abc6c64e3 = (0, $2OMDV.AnalyticsEventToProps)('dropdownItem', {
    onClick: 'clicked'
})((0, $6B7KL.default));
const $1c26f090eaa43df4$export$d6b4ae7200493213 = ({ initialised: initialised, transitions: transitions, canManageAutomations: canManageAutomations, onSelect: onSelect })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    if (!initialised || transitions.length === 0) return null;
    const onClick = (transition, _, analyticsEvent)=>{
        const localEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdown'
        });
        (0, $8zOmE.fireUIAnalytics)(localEvent, 'loopActionsMenu');
        onSelect(transition, analyticsEvent);
    };
    const transitionItemGroupProps = canManageAutomations ? {
        title: formatMessage((0, $kIfyk.default).workflowTransitions)
    } : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), transitionItemGroupProps, transitions.map((transition)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            key: transition.id,
            content: transition.name
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1c26f090eaa43df4$export$c0117b1abc6c64e3, {
            role: "button",
            onClick: (event, analyticsEvent)=>onClick(transition, event, analyticsEvent)
        }, transition.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
        action: "exposed",
        actionSubject: "feature",
        actionSubjectId: "loopActions",
        attributes: {
            controlType: 'menu'
        }
    }));
};
var $1c26f090eaa43df4$export$2e2bcd8739ae039 = $1c26f090eaa43df4$export$d6b4ae7200493213;

});
parcelRegister("kIfyk", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9c3882f167fffa0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f9c3882f167fffa0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    workflowTransitions: {
        "id": "issue-field-status.status-view.actions.actions-menu.transitions-submenu.workflow-transitions",
        "defaultMessage": "From Workflow"
    }
});

});


parcelRegister("2JIM8", function(module, exports) {

$parcel$export(module.exports, "RecurWorkContainer", () => $7acc8ef1f63796cf$export$e1a3907856a4ad7c);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7XluA = parcelRequire("7XluA");

var $5GuG4 = parcelRequire("5GuG4");

var $lB5s6 = parcelRequire("lB5s6");
const $7acc8ef1f63796cf$export$e1a3907856a4ad7c = ({ entryPointRef: entryPointRef, issueKey: issueKey, onBack: onBack, onClose: onClose })=>{
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            issueKey: issueKey,
            onCancel: onBack,
            onClose: onClose,
            hasBackButton: true,
            recurWorkFormEntryPoint: 'actionsMenu'
        }), [
        issueKey,
        onBack,
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $7acc8ef1f63796cf$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointRef,
        id: "issue-view-automation-menu-recur-work-containers",
        packageName: (0, $lB5s6.PACKAGE_NAME),
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5GuG4.Skeleton), null),
        runtimeProps: runtimeProps,
        errorFallback: "flag"
    }));
};
const $7acc8ef1f63796cf$var$containerStyles = (0, $8CUq3.xcss)({
    // maxHeight = total height - top navigation height(56px) - top and bottom space (20px)
    maxHeight: 'calc(100vh - 76px)',
    overflow: 'auto',
    paddingBlock: 'space.300',
    paddingInline: 'space.250'
});

});
parcelRegister("5GuG4", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $884b736f2a39e46f$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gzH4T = parcelRequire("gzH4T");

var $1wbtX = parcelRequire("1wbtX");

var $34fhs = parcelRequire("34fhs");

var $8Ggfa = parcelRequire("8Ggfa");
const $884b736f2a39e46f$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $884b736f2a39e46f$var$skeletonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $34fhs.H100LCompiled), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzH4T.Fill), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.SpacerCompiled), {
        height: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzH4T.Fill), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.SpacerCompiled), {
        height: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzH4T.Fill), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.SpacerCompiled), {
        height: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $34fhs.H100LCompiled), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzH4T.Fill), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.SpacerCompiled), {
        height: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzH4T.Fill), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.SpacerCompiled), {
        height: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $34fhs.H100LCompiled), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzH4T.Fill), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.SpacerCompiled), {
        height: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Ggfa.Button), null));
const $884b736f2a39e46f$var$skeletonContainerStyles = (0, $8CUq3.xcss)({
    minWidth: '300px'
});

});
parcelRegister("gzH4T", function(module, exports) {

$parcel$export(module.exports, "Fill", () => $86943b3dfe04c963$export$ffffe40bfa0649a3);
/* fill.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1wbtX = parcelRequire("1wbtX");
const $86943b3dfe04c963$export$ffffe40bfa0649a3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $1wbtX.SkeletonCompiled), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _1e0c1o8l _aetryzv1",
            __cmplp.className
        ])
    });
});
var $86943b3dfe04c963$export$2e2bcd8739ae039 = $86943b3dfe04c963$export$ffffe40bfa0649a3;

});
parcelRegister("1wbtX", function(module, exports) {

$parcel$export(module.exports, "getKeyframes", () => $39c21c8edc6f2616$export$b2b5e866b2fbf2ec);
$parcel$export(module.exports, "SkeletonCompiled", () => $39c21c8edc6f2616$export$dc84d515085190e);
$parcel$export(module.exports, "SpacerCompiled", () => $39c21c8edc6f2616$export$e477bb7d17087f28);
$parcel$export(module.exports, "Skeleton", () => $39c21c8edc6f2616$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "Spacer", () => $39c21c8edc6f2616$export$d7a54cba636a8cd6);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");
const $39c21c8edc6f2616$export$b2b5e866b2fbf2ec = (offsetX = 0)=>{
    const fromPositionX = -Math.abs(offsetX) - 300;
    const toPositionX = fromPositionX + 2000;
    return (0, $47bDC.keyframes)({
        '0%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${fromPositionX}px 0`
        },
        '100%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${toPositionX}px 0`
        }
    });
};
const $39c21c8edc6f2616$var$shimmer = $39c21c8edc6f2616$export$b2b5e866b2fbf2ec();
const $39c21c8edc6f2616$export$1d2144641222f3bd = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "ieqbub-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationDelay: props.theme.animationDelay || '0s',
        animationDuration: '1s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationName: props.theme.animationName || $39c21c8edc6f2616$var$shimmer,
        animationTimingFunction: 'linear',
        backgroundColor: "var(--ds-skeleton, #091E420F)",
        backgroundImage: `linear-gradient( to right, ${"var(--ds-skeleton, #091E420F)"} 10%, ${"var(--ds-skeleton-subtle, #091E4208)"} 30%, ${"var(--ds-skeleton, #091E420F)"} 50% )`,
        backgroundRepeat: 'no-repeat',
        borderRadius: '2px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.width
    }));
const $39c21c8edc6f2616$export$b1deee0d21f1be36 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "ieqbub-1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height
    }));
const $39c21c8edc6f2616$export$dc84d515085190e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $lD23V.default)(__cmplp.height),
            "--_1gljcou": (0, $lD23V.default)(__cmplp.width)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _ju25ru3m _5sag9cwz _1o51q7pw _tip812c5 _j7hq1245 _1pglp3kn _bfhkn82g _1itk1kpv _12vemgnk _4t3i1474 _1bsb1rkg",
            __cmplp.className
        ])
    });
});
const $39c21c8edc6f2616$export$e477bb7d17087f28 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $lD23V.default)(__cmplp.height)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1474",
            __cmplp.className
        ])
    });
});
const $39c21c8edc6f2616$export$8f31e4c4a37b8e9c = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('enghealth-4756-migrate-complex-styled-component'), $39c21c8edc6f2616$export$dc84d515085190e, $39c21c8edc6f2616$export$1d2144641222f3bd);
const $39c21c8edc6f2616$export$d7a54cba636a8cd6 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('enghealth-4756-migrate-complex-styled-component'), $39c21c8edc6f2616$export$e477bb7d17087f28, $39c21c8edc6f2616$export$b1deee0d21f1be36);

});


parcelRegister("34fhs", function(module, exports) {

$parcel$export(module.exports, "H100LCompiled", () => $2ff3bfba15f6ac9d$export$e61e2190cb48676b);
$parcel$export(module.exports, "H400Compiled", () => $2ff3bfba15f6ac9d$export$892b8de9d7e14f37);
$parcel$export(module.exports, "H700MCompiled", () => $2ff3bfba15f6ac9d$export$53b7b049cff342cb);
$parcel$export(module.exports, "PlainText", () => $2ff3bfba15f6ac9d$export$f6d32c6d49be0014);
$parcel$export(module.exports, "Paragraph", () => $2ff3bfba15f6ac9d$export$358a232cca1ab2ac);
$parcel$export(module.exports, "H300", () => $2ff3bfba15f6ac9d$export$f36868a89c031e58);
$parcel$export(module.exports, "H500", () => $2ff3bfba15f6ac9d$export$377ef4361b3db48f);
/* text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1wbtX = parcelRequire("1wbtX");
const $2ff3bfba15f6ac9d$export$b0895c0bfbd1ffb8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $1wbtX.SkeletonCompiled), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $2ff3bfba15f6ac9d$export$e6dbad138f5bdf17 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3iutpp _otyr12x7",
            __cmplp.className
        ])
    });
});
const $2ff3bfba15f6ac9d$export$7c050ac4f729d35 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _19pkutpp",
            __cmplp.className
        ])
    });
});
const $2ff3bfba15f6ac9d$export$33ebdec21c095f6e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3iutpp _19pkv77o _otyrv77o",
            __cmplp.className
        ])
    });
});
const $2ff3bfba15f6ac9d$export$82a6f7cce44c254 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$33ebdec21c095f6e, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkv47k",
            __cmplp.className
        ])
    });
});
const $2ff3bfba15f6ac9d$export$e61e2190cb48676b = $2ff3bfba15f6ac9d$export$82a6f7cce44c254;
const $2ff3bfba15f6ac9d$export$8c60685913d30500 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3iutpp _19pkv77o _otyrv77o",
            __cmplp.className
        ])
    });
});
const $2ff3bfba15f6ac9d$export$f82bfe67e6a089e6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$8c60685913d30500, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkv47k",
            __cmplp.className
        ])
    });
});
const $2ff3bfba15f6ac9d$export$350917bb6067b798 = $2ff3bfba15f6ac9d$export$f82bfe67e6a089e6;
const $2ff3bfba15f6ac9d$export$eb27f46149e3e85a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3iutpp _19pkv77o _otyrv77o",
            __cmplp.className
        ])
    });
});
const $2ff3bfba15f6ac9d$export$fd72e0c4b34be76a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$eb27f46149e3e85a, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkv47k",
            __cmplp.className
        ])
    });
});
const $2ff3bfba15f6ac9d$export$bfaabc8568c580b1 = $2ff3bfba15f6ac9d$export$fd72e0c4b34be76a;
const $2ff3bfba15f6ac9d$export$892b8de9d7e14f37 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3iutpp _19pke4h9 _otyre4h9",
            __cmplp.className
        ])
    });
});
const $2ff3bfba15f6ac9d$export$9f435470752d8e4b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$892b8de9d7e14f37, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkpxbi",
            __cmplp.className
        ])
    });
});
const $2ff3bfba15f6ac9d$export$f9230dd2e3259be0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$9f435470752d8e4b, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkd4y9 _otyrv77o",
            __cmplp.className
        ])
    });
});
const $2ff3bfba15f6ac9d$export$ef0a9f1262ddb059 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3iv47k",
            __cmplp.className
        ])
    });
});
const $2ff3bfba15f6ac9d$export$3306f1638a65aa25 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$ef0a9f1262ddb059, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1ejb",
            __cmplp.className
        ])
    });
});
const $2ff3bfba15f6ac9d$export$8fbd282ac52a8998 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$3306f1638a65aa25, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk14no _otyr1b66",
            __cmplp.className
        ])
    });
});
const $2ff3bfba15f6ac9d$export$7966954511c1edb6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3iv47k _19pkv77o _otyrv77o",
            __cmplp.className
        ])
    });
});
const $2ff3bfba15f6ac9d$export$576c433bd0b626fd = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$7966954511c1edb6, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkxy5q",
            __cmplp.className
        ])
    });
});
const $2ff3bfba15f6ac9d$export$594a18f5d65c77d1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$576c433bd0b626fd, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1jfw",
            __cmplp.className
        ])
    });
});
const $2ff3bfba15f6ac9d$export$bd4f20a0c6dc0659 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1ejb _19pkv77o _otyrv77o",
            __cmplp.className
        ])
    });
});
const $2ff3bfba15f6ac9d$export$53b7b049cff342cb = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$bd4f20a0c6dc0659, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1jfw",
            __cmplp.className
        ])
    });
});
const $2ff3bfba15f6ac9d$export$957ddfeb34e9bf68 = $2ff3bfba15f6ac9d$export$53b7b049cff342cb;
const $2ff3bfba15f6ac9d$export$675af1e83e93897e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3ixy5q _19pke4h9 _otyrv77o",
            __cmplp.className
        ])
    });
});
const $2ff3bfba15f6ac9d$export$19ab514bc0674f75 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$675af1e83e93897e, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1jfw",
            __cmplp.className
        ])
    });
});
const $2ff3bfba15f6ac9d$export$8293db07860f297 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$19ab514bc0674f75, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkoahv",
            __cmplp.className
        ])
    });
});
const $2ff3bfba15f6ac9d$export$a3699bd2412e4867 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$b0895c0bfbd1ffb8, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3ildb6 _19pkv77o _otyrv77o",
            __cmplp.className
        ])
    });
});
const $2ff3bfba15f6ac9d$export$e3181bb29e80b5f3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $2ff3bfba15f6ac9d$export$a3699bd2412e4867, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1l27",
            __cmplp.className
        ])
    });
});
const $2ff3bfba15f6ac9d$export$1b6e300f10774868 = $2ff3bfba15f6ac9d$export$e3181bb29e80b5f3;
const $2ff3bfba15f6ac9d$export$f6d32c6d49be0014 = $2ff3bfba15f6ac9d$export$e6dbad138f5bdf17;
const $2ff3bfba15f6ac9d$export$358a232cca1ab2ac = $2ff3bfba15f6ac9d$export$7c050ac4f729d35;
const $2ff3bfba15f6ac9d$export$f36868a89c031e58 = $2ff3bfba15f6ac9d$export$eb27f46149e3e85a;
const $2ff3bfba15f6ac9d$export$377ef4361b3db48f = $2ff3bfba15f6ac9d$export$ef0a9f1262ddb059;
const $2ff3bfba15f6ac9d$export$47d8e8f28b07dbe6 = $2ff3bfba15f6ac9d$export$bd4f20a0c6dc0659;

});

parcelRegister("8Ggfa", function(module, exports) {

$parcel$export(module.exports, "ButtonGroupSkeleton", () => $c14cfd8511f792ec$export$f799693edd23bb6f);
$parcel$export(module.exports, "Button", () => $c14cfd8511f792ec$export$353f5b6fc5456de1);
/* button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $fOVFI = parcelRequire("fOVFI");

var $gwIPs = parcelRequire("gwIPs");

var $4R6GH = parcelRequire("4R6GH");

var $7XYc4 = parcelRequire("7XYc4");

var $1wbtX = parcelRequire("1wbtX");
const $c14cfd8511f792ec$export$f799693edd23bb6f = ({ children: children })=>{
    const buttonCount = (0, $5uXOq.Children).count(children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c14cfd8511f792ec$export$651ab49d5833a3a0, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c14cfd8511f792ec$export$8000eb553c875e4a, {
        buttonCount: buttonCount
    }), (0, (/*@__PURE__*/$parcel$interopDefault($fOVFI)))(buttonCount - 1).map((n)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c14cfd8511f792ec$export$70fd5be149617b04, {
            key: n,
            position: n
        })));
};
const $c14cfd8511f792ec$var$buttonWidth = 13 * (0, $gwIPs.gridSize);
const $c14cfd8511f792ec$var$buttonHeight = "var(--ds-space-400, 32px)";
const $c14cfd8511f792ec$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $1wbtX.SkeletonCompiled), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1l8a _4t3ixy5q _19pku2gc _2hwxidpf _otyru2gc _18u0idpf",
            __cmplp.className
        ])
    });
});
var $c14cfd8511f792ec$export$2e2bcd8739ae039 = $c14cfd8511f792ec$export$353f5b6fc5456de1;
const $c14cfd8511f792ec$export$1b81fb2232691eb7 = /*#__PURE__*/ (0, $47bDC.default)((0, $1wbtX.Skeleton)).withConfig({
    componentId: "sc-9j1lqv-0"
})({
    position: 'relative',
    overflow: 'hidden',
    height: $c14cfd8511f792ec$var$buttonHeight,
    flexGrow: 1
});
const $c14cfd8511f792ec$export$651ab49d5833a3a0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $1wbtX.SkeletonCompiled), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _kqswh2mm _4t3ixy5q _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $c14cfd8511f792ec$export$69b1032f2ecdf404 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('enghealth-4756-migrate-complex-styled-component'), $c14cfd8511f792ec$export$651ab49d5833a3a0, $c14cfd8511f792ec$export$1b81fb2232691eb7);
const $c14cfd8511f792ec$export$89b24f7f70fa7330 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-9j1lqv-1"
})`width:4px;height:100%;position:absolute;top:0;right:${// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props)=>(props.position + 1) * $c14cfd8511f792ec$var$buttonWidth}px;`;
const $c14cfd8511f792ec$export$70fd5be149617b04 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { position: position, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_dvd417": (0, $lD23V.default)((__cmplp.position + 1) * $c14cfd8511f792ec$var$buttonWidth, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1y44 _4t3i1osq _kqswstnw _154iidpf _1xi2z0ue",
            __cmplp.className
        ])
    });
});
const $c14cfd8511f792ec$export$17d680238e50603e = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('enghealth-4756-migrate-complex-styled-component'), $c14cfd8511f792ec$export$70fd5be149617b04, $c14cfd8511f792ec$export$89b24f7f70fa7330);
const $c14cfd8511f792ec$export$cb547f293e9be1df = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-9j1lqv-2"
})`position:absolute;width:calc( 100% - ${// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props)=>props.buttonCount * $c14cfd8511f792ec$var$buttonWidth}px );height:100%;top:0;right:${// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props)=>props.buttonCount * $c14cfd8511f792ec$var$buttonWidth}px;`;
const $c14cfd8511f792ec$export$8000eb553c875e4a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { buttonCount: buttonCount, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1rvrc3m": (0, $lD23V.default)(__cmplp.buttonCount * $c14cfd8511f792ec$var$buttonWidth, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1bsb1150 _4t3i1osq _154iidpf _1xi217nd",
            __cmplp.className
        ])
    });
});
const $c14cfd8511f792ec$export$e717bcf55e1dfb40 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('enghealth-4756-migrate-complex-styled-component'), $c14cfd8511f792ec$export$8000eb553c875e4a, $c14cfd8511f792ec$export$cb547f293e9be1df);

});
parcelRegister("fOVFI", function(module, exports) {

var $l2xln = parcelRequire("l2xln");

var $2KOtB = parcelRequire("2KOtB");

var $kPZpS = parcelRequire("kPZpS");
/** Used as references for various `Number` constants. */ var $b84842ed891355b2$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used as references for the maximum length and index of an array. */ var $b84842ed891355b2$var$MAX_ARRAY_LENGTH = 4294967295;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b84842ed891355b2$var$nativeMin = Math.min;
/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */ function $b84842ed891355b2$var$times(n, iteratee) {
    n = $kPZpS(n);
    if (n < 1 || n > $b84842ed891355b2$var$MAX_SAFE_INTEGER) return [];
    var index = $b84842ed891355b2$var$MAX_ARRAY_LENGTH, length = $b84842ed891355b2$var$nativeMin(n, $b84842ed891355b2$var$MAX_ARRAY_LENGTH);
    iteratee = $2KOtB(iteratee);
    n -= $b84842ed891355b2$var$MAX_ARRAY_LENGTH;
    var result = $l2xln(length, iteratee);
    while(++index < n)iteratee(index);
    return result;
}
module.exports = $b84842ed891355b2$var$times;

});



parcelRegister("lB5s6", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $6f0f89877d18d987$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "POPUP_ID", () => $6f0f89877d18d987$export$15a8d6e972bbb4b3);
$parcel$export(module.exports, "RECUR_WORK_COMPONENT_TEST_ID_PREFIX", () => $6f0f89877d18d987$export$3e363f319e1afe5e);
$parcel$export(module.exports, "POPUP_KEYS", () => $6f0f89877d18d987$export$d41dc11f8bf913b8);
const $6f0f89877d18d987$export$b8b9d90f9e5bd72b = 'jira-issue-field-status';
const $6f0f89877d18d987$export$15a8d6e972bbb4b3 = 'issue-field-status-view-actions-menu-popup';
const $6f0f89877d18d987$export$3e363f319e1afe5e = 'issue-field-status.ui.status-view.actions.actions-menu';
const $6f0f89877d18d987$export$d41dc11f8bf913b8 = {
    recurWork: 'RECUR_WORK'
};

});


parcelRegister("iejfI", function(module, exports) {

$parcel$export(module.exports, "RecurWorkMenuItem", () => $26641c38c790ccdd$export$c241ccc0fa71c379);

var $5uXOq = parcelRequire("5uXOq");

var $bpC55 = parcelRequire("bpC55");

var $kJpBP = parcelRequire("kJpBP");

var $MHKc7 = parcelRequire("MHKc7");

var $1I7E8 = parcelRequire("1I7E8");

var $34Rrn = parcelRequire("34Rrn");

var $2Yv61 = parcelRequire("2Yv61");

var $e4yMr = parcelRequire("e4yMr");

var $jpopi = parcelRequire("jpopi");

var $cNd4s = parcelRequire("cNd4s");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $8M6yJ = parcelRequire("8M6yJ");

var $dVMqV = parcelRequire("dVMqV");

var $2YZCu = parcelRequire("2YZCu");

var $cpjnU = parcelRequire("cpjnU");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $1eyaH = parcelRequire("1eyaH");

var $4anLj = parcelRequire("4anLj");

var $93Yeu = parcelRequire("93Yeu");

var $17Gip = parcelRequire("17Gip");
const $26641c38c790ccdd$var$messages = (0, $7VHMR.defineMessages)({
    ruleDidNotLoad: {
        "id": "recur-work-menu-item.popup.rule-did-not-load",
        "defaultMessage": "Rule did not load. Try refreshing the page."
    },
    userNotPermittedToEdit: {
        "id": "recur-work-menu-item.popup.user-not-permitted-to-edit",
        "defaultMessage": "<link>Contact your administrator</link> to edit this rule."
    }
});
const $26641c38c790ccdd$export$c241ccc0fa71c379 = ({ buttonRef: buttonRef, onClick: onClick, issueKey: issueKey, recurWorkFormEntryPoint: recurWorkFormEntryPoint })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isProjectAdmin = (0, $4anLj.useIsProjectAdmin)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const [{ canEditIssues: canEditIssues }] = (0, $17Gip.useProjectPermissions)(projectKey);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { issueProperties: issueProperties, hasFetched: hasFetched, hasBootstrapError: hasBootstrapError, isRuleOwner: isRuleOwner, isFetching: isFetching, isDeletingRule: isDeletingRule, isCreatingRule: isCreatingRule, isUpdatingRule: isUpdatingRule } = (0, $1eyaH.useRecurWorkItemState)();
    const { fetch: refetch } = (0, $1eyaH.useRecurWorkItemActions)();
    const [isPopupOpen, setIsPopupOpen] = (0, $5uXOq.useState)(false);
    const userPermittedToEdit = canEditIssues && (isSiteAdmin || isProjectAdmin || issueProperties && isRuleOwner || !issueProperties);
    (0, $5uXOq.useEffect)(()=>{
        if (hasFetched && !(isFetching || isDeletingRule || isCreatingRule || isUpdatingRule)) refetch();
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'menuItem viewed', 'recurOnSchedulePopup', {
            canViewRecurOnSchedulePopup: userPermittedToEdit,
            recurWorkFormEntryPoint: recurWorkFormEntryPoint
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const ruleFailedToLoad = hasFetched && hasBootstrapError;
    const menuItemMessage = (0, $5uXOq.useMemo)(()=>{
        const isRecurOnComplete = (0, $cpjnU.isRecurOnCompleteToggleRule)(issueProperties);
        let parsedrRule;
        try {
            parsedrRule = (0, $dVMqV.parse)(issueProperties?.recurOnScheduleConfig?.rRule);
        } catch (err) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('jira-issue-field-status.src.ui.status-view.actions.actions-menu.recur-work-menu-item', 'Error parsing rRule string', // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            err);
        }
        const rrule = parsedrRule?.event?.rrule ?? {};
        return (0, $cpjnU.getRecurMenuItemLabel)(rrule, isRecurOnComplete);
    }, [
        issueProperties
    ]);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'menuItem clicked', 'recurOnSchedulePopup', {
            recurWorkFormEntryPoint: recurWorkFormEntryPoint
        });
        onClick();
    }, [
        createAnalyticsEvent,
        onClick,
        recurWorkFormEntryPoint
    ]);
    if (ruleFailedToLoad || !userPermittedToEdit) {
        const popupMessage = ruleFailedToLoad ? formatMessage($26641c38c790ccdd$var$messages.ruleDidNotLoad) : formatMessage($26641c38c790ccdd$var$messages.userNotPermittedToEdit, {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                    href: "/jira/contact-administrator"
                }, chunks)
        });
        const testId = ruleFailedToLoad ? 'issue-field-status.ui.status-view.actions.actions-menu.recur-work-menu-item.warn-button-item' : 'issue-field-status.ui.status-view.actions.actions-menu.recur-work-menu-item.info-button-item';
        const icon = ruleFailedToLoad ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($34Rrn))), {
            color: "var(--ds-icon-warning, #E56910)",
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Yv61))), {
            color: "var(--ds-icon-discovery, #8270DB)",
            label: ""
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
            isOpen: isPopupOpen,
            onClose: ()=>setIsPopupOpen(false),
            placement: "top",
            shouldRenderToParent: true,
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
                    padding: "space.200"
                }, popupMessage),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
                    ...triggerProps,
                    onClick: ()=>setIsPopupOpen(!isPopupOpen),
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8M6yJ.MenuIcon), null, icon),
                    testId: testId
                }, formatMessage(menuItemMessage))
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        ref: buttonRef,
        onClick: handleClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8M6yJ.MenuIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jpopi))), {
            label: ""
        })),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bpC55))), {
            label: "",
            size: "small"
        }),
        testId: "issue-field-status.ui.status-view.actions.actions-menu.recur-work-menu-item.button-item",
        interactionName: "jira-issue-field-status.ui.status-view.actions.actions-menu.recur-work-menu-item.button"
    }, formatMessage(menuItemMessage));
};

});




$parcel$global.rlb("6mU2N")
//# sourceMappingURL=actions-old.debc4b41.js.map
